// This file is auto-generated by @hey-api/openapi-ts

import {
  type Client,
  formDataBodySerializer,
  type Options as Options2,
  type TDataShape,
} from "./client";
import { client } from "./client.gen";
import type {
  AgentsExtractFileContentData,
  AgentsExtractFileContentErrors,
  AgentsExtractFileContentResponses,
  AgentsGetAvailableModelsData,
  AgentsGetAvailableModelsResponses,
  AgentsGetCacheHealthData,
  AgentsGetCacheHealthResponses,
  AgentsGetCompletionData,
  AgentsGetCompletionErrors,
  AgentsGetCompletionResponses,
  AgentsGetSpecificAgentResponseData,
  AgentsGetSpecificAgentResponseErrors,
  AgentsGetSpecificAgentResponseResponses,
  AgentsGetWayakResponseData,
  AgentsGetWayakResponseErrors,
  AgentsGetWayakResponseResponses,
  AgentsStreamWayakResponseData,
  AgentsStreamWayakResponseErrors,
  AgentsStreamWayakResponseResponses,
  AnalyzeSchemaAlignmentData,
  AnalyzeSchemaAlignmentErrors,
  AnalyzeSchemaAlignmentResponses,
  AnalyzeSessionSchemaAlignmentData,
  AnalyzeSessionSchemaAlignmentErrors,
  AnalyzeSessionSchemaAlignmentResponses,
  ApproveSchemaData,
  ApproveSchemaErrors,
  ApproveSchemaResponses,
  BrainsCreateBrainData,
  BrainsCreateBrainErrors,
  BrainsCreateBrainResponses,
  BrainsDeleteBrainData,
  BrainsDeleteBrainErrors,
  BrainsDeleteBrainResponses,
  BrainsGetBrainsForUserIdData,
  BrainsGetBrainsForUserIdErrors,
  BrainsGetBrainsForUserIdResponses,
  BrainsUpdateBrainData,
  BrainsUpdateBrainErrors,
  BrainsUpdateBrainResponses,
  CalculateLakehouseMetricData,
  CalculateLakehouseMetricErrors,
  CalculateLakehouseMetricResponses,
  CancelUploadSessionData,
  CancelUploadSessionErrors,
  CancelUploadSessionResponses,
  CompleteUploadData,
  CompleteUploadErrors,
  CompleteUploadResponses,
  CreateDatasourceMetricData,
  CreateDatasourceMetricErrors,
  CreateDatasourceMetricResponses,
  CreateLakehouseMetricData,
  CreateLakehouseMetricErrors,
  CreateLakehouseMetricResponses,
  CreateUploadSessionData,
  CreateUploadSessionErrors,
  CreateUploadSessionResponses,
  DeleteDatasourceMetricData,
  DeleteDatasourceMetricErrors,
  DeleteDatasourceMetricResponses,
  DeleteLakehouseMetricData,
  DeleteLakehouseMetricErrors,
  DeleteLakehouseMetricResponses,
  FilesCompleteUploadSessionData,
  FilesCompleteUploadSessionErrors,
  FilesCompleteUploadSessionResponses,
  FilesCreateUploadSessionData,
  FilesCreateUploadSessionErrors,
  FilesCreateUploadSessionResponses,
  FilesDeleteFileData,
  FilesDeleteFileErrors,
  FilesDeleteFileResponses,
  FilesGetAcceptedFileTypesData,
  FilesGetAcceptedFileTypesResponses,
  FilesGetFileData,
  FilesGetFileErrors,
  FilesGetFileResponses,
  FilesIndexFileData,
  FilesIndexFileErrors,
  FilesIndexFileResponses,
  FilesScrapeWebPageData,
  FilesScrapeWebPageErrors,
  FilesScrapeWebPageResponses,
  FilesUploadFileData,
  FilesUploadFileErrors,
  FilesUploadFileResponses,
  GetJobStatusData,
  GetJobStatusErrors,
  GetJobStatusResponses,
  GetLakehouseMetricData,
  GetLakehouseMetricErrors,
  GetLakehouseMetricResponses,
  GetUploadSessionStatusData,
  GetUploadSessionStatusErrors,
  GetUploadSessionStatusResponses,
  InferSchemaFromPreviewData,
  InferSchemaFromPreviewErrors,
  InferSchemaFromPreviewResponses,
  InvitationsAcceptInvitationData,
  InvitationsAcceptInvitationErrors,
  InvitationsAcceptInvitationResponses,
  InvitationsCancelInvitationData,
  InvitationsCancelInvitationErrors,
  InvitationsCancelInvitationResponses,
  InvitationsGetOrganizationInvitationsData,
  InvitationsGetOrganizationInvitationsErrors,
  InvitationsGetOrganizationInvitationsResponses,
  InvitationsInviteUserToOrganizationData,
  InvitationsInviteUserToOrganizationErrors,
  InvitationsInviteUserToOrganizationResponses,
  KnowledgeBasesCancelJobData,
  KnowledgeBasesCancelJobErrors,
  KnowledgeBasesCancelJobResponses,
  KnowledgeBasesCompleteUploadData,
  KnowledgeBasesCompleteUploadErrors,
  KnowledgeBasesCompleteUploadResponses,
  KnowledgeBasesCreateFolderData,
  KnowledgeBasesCreateFolderErrors,
  KnowledgeBasesCreateFolderResponses,
  KnowledgeBasesCreateKnowledgeBaseData,
  KnowledgeBasesCreateKnowledgeBaseErrors,
  KnowledgeBasesCreateKnowledgeBaseResponses,
  KnowledgeBasesCreateUploadSessionData,
  KnowledgeBasesCreateUploadSessionErrors,
  KnowledgeBasesCreateUploadSessionResponses,
  KnowledgeBasesDeleteFileData,
  KnowledgeBasesDeleteFileErrors,
  KnowledgeBasesDeleteFileResponses,
  KnowledgeBasesDeleteFolderData,
  KnowledgeBasesDeleteFolderErrors,
  KnowledgeBasesDeleteFolderResponses,
  KnowledgeBasesDeleteKnowledgeBaseData,
  KnowledgeBasesDeleteKnowledgeBaseErrors,
  KnowledgeBasesDeleteKnowledgeBaseResponses,
  KnowledgeBasesGetFileContentData,
  KnowledgeBasesGetFileContentErrors,
  KnowledgeBasesGetFileContentResponses,
  KnowledgeBasesGetFileData,
  KnowledgeBasesGetFileErrors,
  KnowledgeBasesGetFileResponses,
  KnowledgeBasesGetFileSignedUrlData,
  KnowledgeBasesGetFileSignedUrlErrors,
  KnowledgeBasesGetFileSignedUrlResponses,
  KnowledgeBasesGetFolderContentsData,
  KnowledgeBasesGetFolderContentsErrors,
  KnowledgeBasesGetFolderContentsResponses,
  KnowledgeBasesGetJobStatusData,
  KnowledgeBasesGetJobStatusErrors,
  KnowledgeBasesGetJobStatusResponses,
  KnowledgeBasesGetKnowledgeBaseData,
  KnowledgeBasesGetKnowledgeBaseErrors,
  KnowledgeBasesGetKnowledgeBaseResponses,
  KnowledgeBasesListActiveJobsData,
  KnowledgeBasesListActiveJobsErrors,
  KnowledgeBasesListActiveJobsResponses,
  KnowledgeBasesListFilesData,
  KnowledgeBasesListFilesErrors,
  KnowledgeBasesListFilesResponses,
  KnowledgeBasesListFoldersData,
  KnowledgeBasesListFoldersErrors,
  KnowledgeBasesListFoldersResponses,
  KnowledgeBasesListJobsData,
  KnowledgeBasesListJobsErrors,
  KnowledgeBasesListJobsResponses,
  KnowledgeBasesListKnowledgeBasesData,
  KnowledgeBasesListKnowledgeBasesErrors,
  KnowledgeBasesListKnowledgeBasesResponses,
  KnowledgeBasesLocalUploadData,
  KnowledgeBasesLocalUploadErrors,
  KnowledgeBasesLocalUploadResponses,
  KnowledgeBasesMoveFileData,
  KnowledgeBasesMoveFileErrors,
  KnowledgeBasesMoveFileResponses,
  KnowledgeBasesUpdateFolderData,
  KnowledgeBasesUpdateFolderErrors,
  KnowledgeBasesUpdateFolderResponses,
  KnowledgeBasesUpdateKnowledgeBaseData,
  KnowledgeBasesUpdateKnowledgeBaseErrors,
  KnowledgeBasesUpdateKnowledgeBaseResponses,
  KnowledgeBasesUploadFileData,
  KnowledgeBasesUploadFileErrors,
  KnowledgeBasesUploadFileResponses,
  ListLakehouseMetricCalculationsData,
  ListLakehouseMetricCalculationsErrors,
  ListLakehouseMetricCalculationsResponses,
  ListLakehouseMetricsData,
  ListLakehouseMetricsErrors,
  ListLakehouseMetricsResponses,
  LocalUploadData,
  LocalUploadErrors,
  LocalUploadResponses,
  MessagesCreateMessageData,
  MessagesCreateMessageErrors,
  MessagesCreateMessageResponses,
  MessagesDeleteMessageData,
  MessagesDeleteMessageErrors,
  MessagesDeleteMessageResponses,
  MessagesGetMessageData,
  MessagesGetMessageErrors,
  MessagesGetMessageResponses,
  MessagesUpdateMessageData,
  MessagesUpdateMessageErrors,
  MessagesUpdateMessageResponses,
  NotificationsGetNotificationsData,
  NotificationsGetNotificationsErrors,
  NotificationsGetNotificationsResponses,
  NotificationsGetUnreadCountData,
  NotificationsGetUnreadCountResponses,
  NotificationsMarkAllReadData,
  NotificationsMarkAllReadResponses,
  NotificationsMarkAsReadData,
  NotificationsMarkAsReadErrors,
  NotificationsMarkAsReadResponses,
  OntologyAgentNaturalQueryData,
  OntologyAgentNaturalQueryErrors,
  OntologyAgentNaturalQueryResponses,
  OntologyAnalyzeMetricEnhancementData,
  OntologyAnalyzeMetricEnhancementErrors,
  OntologyAnalyzeMetricEnhancementResponses,
  OntologyAppendFileToTableData,
  OntologyAppendFileToTableErrors,
  OntologyAppendFileToTableResponses,
  OntologyAssessDatasourceMigrationData,
  OntologyAssessDatasourceMigrationErrors,
  OntologyAssessDatasourceMigrationResponses,
  OntologyBatchAssessAndMigrateDatasourcesData,
  OntologyBatchAssessAndMigrateDatasourcesErrors,
  OntologyBatchAssessAndMigrateDatasourcesResponses,
  OntologyBatchAssessDatasourcesData,
  OntologyBatchAssessDatasourcesErrors,
  OntologyBatchAssessDatasourcesResponses,
  OntologyCancelSyncJobData,
  OntologyCancelSyncJobErrors,
  OntologyCancelSyncJobResponses,
  OntologyCheckSchemaDriftData,
  OntologyCheckSchemaDriftErrors,
  OntologyCheckSchemaDriftResponses,
  OntologyCreateApiConnectionData,
  OntologyCreateApiConnectionErrors,
  OntologyCreateApiConnectionResponses,
  OntologyCreateCompositeDataSourceData,
  OntologyCreateCompositeDataSourceErrors,
  OntologyCreateCompositeDataSourceResponses,
  OntologyCreateDashboardData,
  OntologyCreateDashboardErrors,
  OntologyCreateDashboardResponses,
  OntologyCreateDatabaseConnectionData,
  OntologyCreateDatabaseConnectionErrors,
  OntologyCreateDatabaseConnectionResponses,
  OntologyCreateForeignConnectionData,
  OntologyCreateForeignConnectionErrors,
  OntologyCreateForeignConnectionResponses,
  OntologyCreateForeignDataSourceData,
  OntologyCreateForeignDataSourceErrors,
  OntologyCreateForeignDataSourceResponses,
  OntologyCreateIcebergDataSourceData,
  OntologyCreateIcebergDataSourceErrors,
  OntologyCreateIcebergDataSourceResponses,
  OntologyCreateMigrationJobData,
  OntologyCreateMigrationJobErrors,
  OntologyCreateMigrationJobResponses,
  OntologyCreateMongodbDatasourceData,
  OntologyCreateMongodbDatasourceErrors,
  OntologyCreateMongodbDatasourceResponses,
  OntologyCreateMysqlDatasourceData,
  OntologyCreateMysqlDatasourceResponses,
  OntologyCreateNamespaceData,
  OntologyCreateNamespaceErrors,
  OntologyCreateNamespaceResponses,
  OntologyCreatePostgresqlDatasourceData,
  OntologyCreatePostgresqlDatasourceResponses,
  OntologyCreateRelationshipData,
  OntologyCreateRelationshipErrors,
  OntologyCreateRelationshipResponses,
  OntologyCreateSemanticObjectData,
  OntologyCreateSemanticObjectErrors,
  OntologyCreateSemanticObjectResponses,
  OntologyCreateSqlserverDatasourceData,
  OntologyCreateSqlserverDatasourceResponses,
  OntologyCreateSyncConfigurationData,
  OntologyCreateSyncConfigurationErrors,
  OntologyCreateSyncConfigurationResponses,
  OntologyCreateViewData,
  OntologyCreateViewErrors,
  OntologyCreateViewResponses,
  OntologyDebugResolveRuntimeData,
  OntologyDebugResolveRuntimeErrors,
  OntologyDebugResolveRuntimeResponses,
  OntologyDeleteApiConnectionData,
  OntologyDeleteApiConnectionErrors,
  OntologyDeleteApiConnectionResponses,
  OntologyDeleteDashboardData,
  OntologyDeleteDashboardErrors,
  OntologyDeleteDashboardResponses,
  OntologyDeleteDataSourceData,
  OntologyDeleteDataSourceErrors,
  OntologyDeleteDataSourceResponses,
  OntologyDeleteForeignConnectionData,
  OntologyDeleteForeignConnectionErrors,
  OntologyDeleteForeignConnectionResponses,
  OntologyDeleteNamespaceData,
  OntologyDeleteNamespaceErrors,
  OntologyDeleteNamespaceResponses,
  OntologyDeleteSemanticObjectData,
  OntologyDeleteSemanticObjectErrors,
  OntologyDeleteSemanticObjectResponses,
  OntologyDeleteViewData,
  OntologyDeleteViewErrors,
  OntologyDeleteViewResponses,
  OntologyDiscoverApiSchemaData,
  OntologyDiscoverApiSchemaErrors,
  OntologyDiscoverApiSchemaResponses,
  OntologyDiscoverDatabaseTablesData,
  OntologyDiscoverDatabaseTablesErrors,
  OntologyDiscoverDatabaseTablesResponses,
  OntologyDiscoverForeignConnectionSchemasData,
  OntologyDiscoverForeignConnectionSchemasErrors,
  OntologyDiscoverForeignConnectionSchemasResponses,
  OntologyDiscoverForeignConnectionTablesData,
  OntologyDiscoverForeignConnectionTablesErrors,
  OntologyDiscoverForeignConnectionTablesResponses,
  OntologyDiscoverNamespaceSemanticObjectsData,
  OntologyDiscoverNamespaceSemanticObjectsErrors,
  OntologyDiscoverNamespaceSemanticObjectsResponses,
  OntologyDiscoverSemanticObjectsSingleTableData,
  OntologyDiscoverSemanticObjectsSingleTableErrors,
  OntologyDiscoverSemanticObjectsSingleTableResponses,
  OntologyDiscoverSemanticObjectsUnifiedData,
  OntologyDiscoverSemanticObjectsUnifiedErrors,
  OntologyDiscoverSemanticObjectsUnifiedResponses,
  OntologyDiscoverSemanticsFromDatasourceData,
  OntologyDiscoverSemanticsFromDatasourceErrors,
  OntologyDiscoverSemanticsFromDatasourceResponses,
  OntologyDiscoverTablesByConnectionIdData,
  OntologyDiscoverTablesByConnectionIdErrors,
  OntologyDiscoverTablesByConnectionIdResponses,
  OntologyDropTableData,
  OntologyDropTableErrors,
  OntologyDropTableResponses,
  OntologyEmbedTableData,
  OntologyEmbedTableErrors,
  OntologyEmbedTableResponses,
  OntologyEvolveTableSchemaData,
  OntologyEvolveTableSchemaErrors,
  OntologyEvolveTableSchemaResponses,
  OntologyExecuteMigrationJobData,
  OntologyExecuteMigrationJobErrors,
  OntologyExecuteMigrationJobResponses,
  OntologyExecuteNaturalQueryData,
  OntologyExecuteNaturalQueryErrors,
  OntologyExecuteNaturalQueryResponses,
  OntologyExecuteSqlQueryData,
  OntologyExecuteSqlQueryErrors,
  OntologyExecuteSqlQueryResponses,
  OntologyExecuteViewData,
  OntologyExecuteViewErrors,
  OntologyExecuteViewResponses,
  OntologyExplainQueryData,
  OntologyExplainQueryErrors,
  OntologyExplainQueryResponses,
  OntologyGetAgentContextData,
  OntologyGetAgentContextErrors,
  OntologyGetAgentContextResponses,
  OntologyGetApiConnectionData,
  OntologyGetApiConnectionErrors,
  OntologyGetApiConnectionResponses,
  OntologyGetAvailableFiltersData,
  OntologyGetAvailableFiltersErrors,
  OntologyGetAvailableFiltersResponses,
  OntologyGetColumnLineageData,
  OntologyGetColumnLineageErrors,
  OntologyGetColumnLineageResponses,
  OntologyGetCrossSystemLineageData,
  OntologyGetCrossSystemLineageErrors,
  OntologyGetCrossSystemLineageResponses,
  OntologyGetDashboardContextData,
  OntologyGetDashboardContextErrors,
  OntologyGetDashboardContextResponses,
  OntologyGetDashboardData,
  OntologyGetDashboardErrors,
  OntologyGetDashboardResponses,
  OntologyGetDashboardsData,
  OntologyGetDashboardsErrors,
  OntologyGetDashboardsResponses,
  OntologyGetDataSourceByNameData,
  OntologyGetDataSourceByNameErrors,
  OntologyGetDataSourceByNameResponses,
  OntologyGetDatasourceData,
  OntologyGetDataSourceData,
  OntologyGetDatasourceErrors,
  OntologyGetDataSourceErrors,
  OntologyGetDatasourceResponses,
  OntologyGetDataSourceResponses,
  OntologyGetDatasourcesData,
  OntologyGetDatasourcesErrors,
  OntologyGetDatasourcesResponses,
  OntologyGetEmbeddingStatusData,
  OntologyGetEmbeddingStatusErrors,
  OntologyGetEmbeddingStatusResponses,
  OntologyGetForeignConnectionData,
  OntologyGetForeignConnectionErrors,
  OntologyGetForeignConnectionResponses,
  OntologyGetForeignTableDetailsData,
  OntologyGetForeignTableDetailsErrors,
  OntologyGetForeignTableDetailsResponses,
  OntologyGetImpactAnalysisData,
  OntologyGetImpactAnalysisErrors,
  OntologyGetImpactAnalysisResponses,
  OntologyGetIntegrationStatusData,
  OntologyGetIntegrationStatusErrors,
  OntologyGetIntegrationStatusResponses,
  OntologyGetLakehouseStatsData,
  OntologyGetLakehouseStatsErrors,
  OntologyGetLakehouseStatsResponses,
  OntologyGetMetricData,
  OntologyGetMetricDependenciesData,
  OntologyGetMetricDependenciesErrors,
  OntologyGetMetricDependenciesResponses,
  OntologyGetMetricErrors,
  OntologyGetMetricResponses,
  OntologyGetMetricsData,
  OntologyGetMetricsErrors,
  OntologyGetMetricsResponses,
  OntologyGetMigrationProgressData,
  OntologyGetMigrationProgressErrors,
  OntologyGetMigrationProgressResponses,
  OntologyGetNamespaceData,
  OntologyGetNamespaceErrors,
  OntologyGetNamespaceOverviewData,
  OntologyGetNamespaceOverviewErrors,
  OntologyGetNamespaceOverviewResponses,
  OntologyGetNamespaceResponses,
  OntologyGetNamespacesData,
  OntologyGetNamespacesErrors,
  OntologyGetNamespacesResponses,
  OntologyGetQueryHistoryData,
  OntologyGetQueryHistoryErrors,
  OntologyGetQueryHistoryResponses,
  OntologyGetQueryReferenceData,
  OntologyGetQueryReferenceErrors,
  OntologyGetQueryReferenceResponses,
  OntologyGetRuntimeGraphData,
  OntologyGetRuntimeGraphErrors,
  OntologyGetRuntimeGraphLineageData,
  OntologyGetRuntimeGraphLineageErrors,
  OntologyGetRuntimeGraphLineageResponses,
  OntologyGetRuntimeGraphNeighborhoodData,
  OntologyGetRuntimeGraphNeighborhoodErrors,
  OntologyGetRuntimeGraphNeighborhoodResponses,
  OntologyGetRuntimeGraphResponses,
  OntologyGetRuntimeTraceData,
  OntologyGetRuntimeTraceErrors,
  OntologyGetRuntimeTraceResponses,
  OntologyGetSemanticSuggestionsData,
  OntologyGetSemanticSuggestionsErrors,
  OntologyGetSemanticSuggestionsResponses,
  OntologyGetSyncJobStatusData,
  OntologyGetSyncJobStatusErrors,
  OntologyGetSyncJobStatusResponses,
  OntologyGetTableDetailsData,
  OntologyGetTableDetailsErrors,
  OntologyGetTableDetailsResponses,
  OntologyGetTableHistoryData,
  OntologyGetTableHistoryErrors,
  OntologyGetTableHistoryResponses,
  OntologyGetTableLineageData,
  OntologyGetTableLineageErrors,
  OntologyGetTableLineageResponses,
  OntologyGetTablesHealthData,
  OntologyGetTablesHealthErrors,
  OntologyGetTablesHealthResponses,
  OntologyGetViewAvailableFiltersData,
  OntologyGetViewAvailableFiltersErrors,
  OntologyGetViewAvailableFiltersResponses,
  OntologyGetViewData,
  OntologyGetViewErrors,
  OntologyGetViewResponses,
  OntologyIngestFileToTableData,
  OntologyIngestFileToTableErrors,
  OntologyIngestFileToTableResponses,
  OntologyListApiConnectionsData,
  OntologyListApiConnectionsErrors,
  OntologyListApiConnectionsResponses,
  OntologyListByForeignConnectionData,
  OntologyListByForeignConnectionErrors,
  OntologyListByForeignConnectionResponses,
  OntologyListByIcebergTableData,
  OntologyListByIcebergTableErrors,
  OntologyListByIcebergTableResponses,
  OntologyListDatabaseConnectionsData,
  OntologyListDatabaseConnectionsErrors,
  OntologyListDatabaseConnectionsResponses,
  OntologyListDataSourcesData,
  OntologyListDataSourcesErrors,
  OntologyListDataSourcesResponses,
  OntologyListForeignConnectionsData,
  OntologyListForeignConnectionsErrors,
  OntologyListForeignConnectionsResponses,
  OntologyListMigrationsData,
  OntologyListMigrationsErrors,
  OntologyListMigrationsResponses,
  OntologyListRelationshipsData,
  OntologyListRelationshipsErrors,
  OntologyListRelationshipsResponses,
  OntologyListRuntimeSpacesData,
  OntologyListRuntimeSpacesErrors,
  OntologyListRuntimeSpacesResponses,
  OntologyListSemanticObjectsData,
  OntologyListSemanticObjectsErrors,
  OntologyListSemanticObjectsResponses,
  OntologyListSyncJobsData,
  OntologyListSyncJobsErrors,
  OntologyListSyncJobsResponses,
  OntologyListTablesData,
  OntologyListTablesErrors,
  OntologyListTablesResponses,
  OntologyListViewsData,
  OntologyListViewsErrors,
  OntologyListViewsResponses,
  OntologyPromoteRuntimeAssetData,
  OntologyPromoteRuntimeAssetErrors,
  OntologyPromoteRuntimeAssetResponses,
  OntologyRebuildCatalogData,
  OntologyRebuildCatalogErrors,
  OntologyRebuildCatalogResponses,
  OntologyStartSyncJobData,
  OntologyStartSyncJobErrors,
  OntologyStartSyncJobResponses,
  OntologySyncApiConnectionData,
  OntologySyncApiConnectionErrors,
  OntologySyncApiConnectionResponses,
  OntologySyncForeignConnectionSchemaData,
  OntologySyncForeignConnectionSchemaErrors,
  OntologySyncForeignConnectionSchemaResponses,
  OntologySyncFromApiData,
  OntologySyncFromApiResponses,
  OntologySyncFromDatabaseData,
  OntologySyncFromDatabaseResponses,
  OntologySyncSchemaData,
  OntologySyncSchemaErrors,
  OntologySyncSchemaResponses,
  OntologySyncTableMetadataData,
  OntologySyncTableMetadataErrors,
  OntologySyncTableMetadataResponses,
  OntologyTestApiConnectionData,
  OntologyTestApiConnectionErrors,
  OntologyTestApiConnectionResponses,
  OntologyTestConnectionData,
  OntologyTestConnectionErrors,
  OntologyTestConnectionResponses,
  OntologyTestDatabaseConnectionData,
  OntologyTestDatabaseConnectionErrors,
  OntologyTestDatabaseConnectionResponses,
  OntologyTestExistingApiConnectionData,
  OntologyTestExistingApiConnectionErrors,
  OntologyTestExistingApiConnectionResponses,
  OntologyTestForeignConnectionData,
  OntologyTestForeignConnectionErrors,
  OntologyTestForeignConnectionResponses,
  OntologyTestQueryData,
  OntologyTestQueryErrors,
  OntologyTestQueryResponses,
  OntologyUpdateApiConnectionData,
  OntologyUpdateApiConnectionErrors,
  OntologyUpdateApiConnectionResponses,
  OntologyUpdateDashboardData,
  OntologyUpdateDashboardErrors,
  OntologyUpdateDashboardResponses,
  OntologyUpdateDataSourceData,
  OntologyUpdateDataSourceErrors,
  OntologyUpdateDataSourceResponses,
  OntologyUpdateForeignConnectionData,
  OntologyUpdateForeignConnectionErrors,
  OntologyUpdateForeignConnectionResponses,
  OntologyUpdateNamespaceData,
  OntologyUpdateNamespaceErrors,
  OntologyUpdateNamespaceResponses,
  OntologyUpdateObjectDimensionsData,
  OntologyUpdateObjectDimensionsErrors,
  OntologyUpdateObjectDimensionsResponses,
  OntologyUpdateSemanticObjectData,
  OntologyUpdateSemanticObjectErrors,
  OntologyUpdateSemanticObjectResponses,
  OntologyUpdateViewData,
  OntologyUpdateViewErrors,
  OntologyUpdateViewResponses,
  OntologyUploadFileData,
  OntologyUploadFileErrors,
  OntologyUploadFileResponses,
  OrganizationsAddOrganizationMemberData,
  OrganizationsAddOrganizationMemberErrors,
  OrganizationsAddOrganizationMemberResponses,
  OrganizationsCreateOrganizationData,
  OrganizationsCreateOrganizationErrors,
  OrganizationsCreateOrganizationResponses,
  OrganizationsGetOrganizationBrainsData,
  OrganizationsGetOrganizationBrainsErrors,
  OrganizationsGetOrganizationBrainsResponses,
  OrganizationsGetOrganizationData,
  OrganizationsGetOrganizationErrors,
  OrganizationsGetOrganizationMemberActivityData,
  OrganizationsGetOrganizationMemberActivityErrors,
  OrganizationsGetOrganizationMemberActivityResponses,
  OrganizationsGetOrganizationMembersData,
  OrganizationsGetOrganizationMembersErrors,
  OrganizationsGetOrganizationMembersResponses,
  OrganizationsGetOrganizationProjectsData,
  OrganizationsGetOrganizationProjectsErrors,
  OrganizationsGetOrganizationProjectsResponses,
  OrganizationsGetOrganizationResponses,
  OrganizationsGetOrganizationThreadsAllData,
  OrganizationsGetOrganizationThreadsAllErrors,
  OrganizationsGetOrganizationThreadsAllResponses,
  OrganizationsGetOrganizationThreadsData,
  OrganizationsGetOrganizationThreadsErrors,
  OrganizationsGetOrganizationThreadsResponses,
  OrganizationsGetPersonalOrganizationData,
  OrganizationsGetPersonalOrganizationResponses,
  OrganizationsGetUserOrganizationsData,
  OrganizationsGetUserOrganizationsResponses,
  OrganizationsRemoveOrganizationMemberData,
  OrganizationsRemoveOrganizationMemberErrors,
  OrganizationsRemoveOrganizationMemberResponses,
  OrganizationsUpdateOrganizationData,
  OrganizationsUpdateOrganizationErrors,
  OrganizationsUpdateOrganizationMemberRoleData,
  OrganizationsUpdateOrganizationMemberRoleErrors,
  OrganizationsUpdateOrganizationMemberRoleResponses,
  OrganizationsUpdateOrganizationResponses,
  PipedreamBrowseConnectionFilesData,
  PipedreamBrowseConnectionFilesErrors,
  PipedreamBrowseConnectionFilesResponses,
  PipedreamCreateConnectTokenData,
  PipedreamCreateConnectTokenErrors,
  PipedreamCreateConnectTokenResponses,
  PipedreamDisconnectData,
  PipedreamDisconnectErrors,
  PipedreamDisconnectResponses,
  PipedreamGetResolvedConnectionsData,
  PipedreamGetResolvedConnectionsErrors,
  PipedreamGetResolvedConnectionsResponses,
  PipedreamHandleConnectWebhookData,
  PipedreamHandleConnectWebhookErrors,
  PipedreamHandleConnectWebhookResponses,
  PipedreamListConnectionsData,
  PipedreamListConnectionsErrors,
  PipedreamListConnectionsResponses,
  PipedreamListSupportedAppsData,
  PipedreamListSupportedAppsErrors,
  PipedreamListSupportedAppsResponses,
  PipedreamPrepareConnectionFileAccessData,
  PipedreamPrepareConnectionFileAccessErrors,
  PipedreamPrepareConnectionFileAccessResponses,
  PipedreamSaveConnectionData,
  PipedreamSaveConnectionErrors,
  PipedreamSaveConnectionResponses,
  PlaybooksActivateOrchestratorData,
  PlaybooksActivateOrchestratorErrors,
  PlaybooksActivateOrchestratorResponses,
  PlaybooksActivatePlaybookData,
  PlaybooksActivatePlaybookErrors,
  PlaybooksActivatePlaybookResponses,
  PlaybooksCancelExecutionData,
  PlaybooksCancelExecutionErrors,
  PlaybooksCancelExecutionResponses,
  PlaybooksCancelOrchestratorRunData,
  PlaybooksCancelOrchestratorRunErrors,
  PlaybooksCancelOrchestratorRunResponses,
  PlaybooksCreateExecutionFileDownloadUrlData,
  PlaybooksCreateExecutionFileDownloadUrlErrors,
  PlaybooksCreateExecutionFileDownloadUrlResponses,
  PlaybooksCreateIntegrationData,
  PlaybooksCreateIntegrationErrors,
  PlaybooksCreateIntegrationResponses,
  PlaybooksCreateManagedListData,
  PlaybooksCreateManagedListErrors,
  PlaybooksCreateManagedListItemsData,
  PlaybooksCreateManagedListItemsErrors,
  PlaybooksCreateManagedListItemsResponses,
  PlaybooksCreateManagedListResponses,
  PlaybooksCreateOrchestratorData,
  PlaybooksCreateOrchestratorErrors,
  PlaybooksCreateOrchestratorResponses,
  PlaybooksCreatePlaybookData,
  PlaybooksCreatePlaybookErrors,
  PlaybooksCreatePlaybookResponses,
  PlaybooksDeleteIntegrationData,
  PlaybooksDeleteIntegrationErrors,
  PlaybooksDeleteIntegrationResponses,
  PlaybooksDeleteManagedListData,
  PlaybooksDeleteManagedListErrors,
  PlaybooksDeleteManagedListItemData,
  PlaybooksDeleteManagedListItemErrors,
  PlaybooksDeleteManagedListItemResponses,
  PlaybooksDeleteManagedListResponses,
  PlaybooksDeleteOrchestratorData,
  PlaybooksDeleteOrchestratorErrors,
  PlaybooksDeleteOrchestratorResponses,
  PlaybooksDeletePlaybookData,
  PlaybooksDeletePlaybookErrors,
  PlaybooksDeletePlaybookResponses,
  PlaybooksDisableWebhookData,
  PlaybooksDisableWebhookErrors,
  PlaybooksDisableWebhookResponses,
  PlaybooksDiscoverNodeContextData,
  PlaybooksDiscoverNodeContextErrors,
  PlaybooksDiscoverNodeContextResponses,
  PlaybooksEnableWebhookData,
  PlaybooksEnableWebhookErrors,
  PlaybooksEnableWebhookResponses,
  PlaybooksExecutePlaybookData,
  PlaybooksExecutePlaybookErrors,
  PlaybooksExecutePlaybookResponses,
  PlaybooksExecutePlaybookWithFilesData,
  PlaybooksExecutePlaybookWithFilesErrors,
  PlaybooksExecutePlaybookWithFilesResponses,
  PlaybooksGetExecutionData,
  PlaybooksGetExecutionErrors,
  PlaybooksGetExecutionResponses,
  PlaybooksGetManagedListData,
  PlaybooksGetManagedListErrors,
  PlaybooksGetManagedListResponses,
  PlaybooksGetMonitorOverviewData,
  PlaybooksGetMonitorOverviewErrors,
  PlaybooksGetMonitorOverviewResponses,
  PlaybooksGetNodeTypesData,
  PlaybooksGetNodeTypesErrors,
  PlaybooksGetNodeTypesResponses,
  PlaybooksGetOrchestratorData,
  PlaybooksGetOrchestratorErrors,
  PlaybooksGetOrchestratorResponses,
  PlaybooksGetOrchestratorRunData,
  PlaybooksGetOrchestratorRunErrors,
  PlaybooksGetOrchestratorRunResponses,
  PlaybooksGetPlaybookData,
  PlaybooksGetPlaybookErrors,
  PlaybooksGetPlaybookResponses,
  PlaybooksGetQueueHealthData,
  PlaybooksGetQueueHealthErrors,
  PlaybooksGetQueueHealthResponses,
  PlaybooksGetScheduleTimelineData,
  PlaybooksGetScheduleTimelineErrors,
  PlaybooksGetScheduleTimelineResponses,
  PlaybooksGetWorkRecordData,
  PlaybooksGetWorkRecordErrors,
  PlaybooksGetWorkRecordResponses,
  PlaybooksListAllEmailsData,
  PlaybooksListAllEmailsErrors,
  PlaybooksListAllEmailsResponses,
  PlaybooksListAllReportsData,
  PlaybooksListAllReportsErrors,
  PlaybooksListAllReportsResponses,
  PlaybooksListAllSlackMessagesData,
  PlaybooksListAllSlackMessagesErrors,
  PlaybooksListAllSlackMessagesResponses,
  PlaybooksListExecutionFilesData,
  PlaybooksListExecutionFilesErrors,
  PlaybooksListExecutionFilesResponses,
  PlaybooksListExecutionsData,
  PlaybooksListExecutionsErrors,
  PlaybooksListExecutionsResponses,
  PlaybooksListIntegrationsData,
  PlaybooksListIntegrationsErrors,
  PlaybooksListIntegrationsResponses,
  PlaybooksListManagedListItemsData,
  PlaybooksListManagedListItemsErrors,
  PlaybooksListManagedListItemsResponses,
  PlaybooksListManagedListsData,
  PlaybooksListManagedListsErrors,
  PlaybooksListManagedListsResponses,
  PlaybooksListOrchestratorRunItemsData,
  PlaybooksListOrchestratorRunItemsErrors,
  PlaybooksListOrchestratorRunItemsResponses,
  PlaybooksListOrchestratorRunsData,
  PlaybooksListOrchestratorRunsErrors,
  PlaybooksListOrchestratorRunsResponses,
  PlaybooksListOrchestratorsData,
  PlaybooksListOrchestratorsErrors,
  PlaybooksListOrchestratorsResponses,
  PlaybooksListPhaseRunnerHealthData,
  PlaybooksListPhaseRunnerHealthErrors,
  PlaybooksListPhaseRunnerHealthResponses,
  PlaybooksListPhaseRunnerTicksData,
  PlaybooksListPhaseRunnerTicksErrors,
  PlaybooksListPhaseRunnerTicksResponses,
  PlaybooksListPlaybooksData,
  PlaybooksListPlaybooksErrors,
  PlaybooksListPlaybooksResponses,
  PlaybooksListReportsData,
  PlaybooksListReportsErrors,
  PlaybooksListReportsResponses,
  PlaybooksListWorkArtifactsData,
  PlaybooksListWorkArtifactsErrors,
  PlaybooksListWorkArtifactsResponses,
  PlaybooksListWorkRecordsData,
  PlaybooksListWorkRecordsErrors,
  PlaybooksListWorkRecordsResponses,
  PlaybooksManualReviewActionData,
  PlaybooksManualReviewActionErrors,
  PlaybooksManualReviewActionResponses,
  PlaybooksPauseOrchestratorData,
  PlaybooksPauseOrchestratorErrors,
  PlaybooksPauseOrchestratorResponses,
  PlaybooksPausePlaybookData,
  PlaybooksPausePlaybookErrors,
  PlaybooksPausePlaybookResponses,
  PlaybooksPreviewOrchestratorData,
  PlaybooksPreviewOrchestratorErrors,
  PlaybooksPreviewOrchestratorResponses,
  PlaybooksRegenerateWebhookData,
  PlaybooksRegenerateWebhookErrors,
  PlaybooksRegenerateWebhookResponses,
  PlaybooksRetryFailedOrchestratorRunData,
  PlaybooksRetryFailedOrchestratorRunErrors,
  PlaybooksRetryFailedOrchestratorRunResponses,
  PlaybooksRetryWorkRecordData,
  PlaybooksRetryWorkRecordErrors,
  PlaybooksRetryWorkRecordResponses,
  PlaybooksRollbackPlaybookData,
  PlaybooksRollbackPlaybookErrors,
  PlaybooksRollbackPlaybookResponses,
  PlaybooksRunOrchestratorData,
  PlaybooksRunOrchestratorErrors,
  PlaybooksRunOrchestratorResponses,
  PlaybooksSetDefaultIntegrationData,
  PlaybooksSetDefaultIntegrationErrors,
  PlaybooksSetDefaultIntegrationResponses,
  PlaybooksSignedDownloadUrlData,
  PlaybooksSignedDownloadUrlErrors,
  PlaybooksSignedDownloadUrlResponses,
  PlaybooksTestIntegrationEmailData,
  PlaybooksTestIntegrationEmailErrors,
  PlaybooksTestIntegrationEmailResponses,
  PlaybooksUpdateIntegrationData,
  PlaybooksUpdateIntegrationErrors,
  PlaybooksUpdateIntegrationResponses,
  PlaybooksUpdateManagedListData,
  PlaybooksUpdateManagedListErrors,
  PlaybooksUpdateManagedListItemData,
  PlaybooksUpdateManagedListItemErrors,
  PlaybooksUpdateManagedListItemResponses,
  PlaybooksUpdateManagedListResponses,
  PlaybooksUpdateOrchestratorData,
  PlaybooksUpdateOrchestratorErrors,
  PlaybooksUpdateOrchestratorResponses,
  PlaybooksUpdatePlaybookData,
  PlaybooksUpdatePlaybookErrors,
  PlaybooksUpdatePlaybookResponses,
  PlaybooksUploadRecordSourceData,
  PlaybooksUploadRecordSourceErrors,
  PlaybooksUploadRecordSourceResponses,
  ProgrammaticIngestData,
  ProgrammaticIngestErrors,
  ProgrammaticIngestResponses,
  ProjectsAddProjectMemberData,
  ProjectsAddProjectMemberErrors,
  ProjectsAddProjectMemberResponses,
  ProjectsCreateProjectData,
  ProjectsCreateProjectErrors,
  ProjectsCreateProjectResponses,
  ProjectsDeleteProjectData,
  ProjectsDeleteProjectErrors,
  ProjectsDeleteProjectResponses,
  ProjectsGetProjectData,
  ProjectsGetProjectErrors,
  ProjectsGetProjectFilesData,
  ProjectsGetProjectFilesErrors,
  ProjectsGetProjectFilesResponses,
  ProjectsGetProjectMembersData,
  ProjectsGetProjectMembersErrors,
  ProjectsGetProjectMembersResponses,
  ProjectsGetProjectResponses,
  ProjectsGetProjectThreadsData,
  ProjectsGetProjectThreadsErrors,
  ProjectsGetProjectThreadsResponses,
  ProjectsIndexProjectFilesData,
  ProjectsIndexProjectFilesErrors,
  ProjectsIndexProjectFilesResponses,
  ProjectsRemoveProjectMemberData,
  ProjectsRemoveProjectMemberErrors,
  ProjectsRemoveProjectMemberResponses,
  ProjectsUpdateProjectData,
  ProjectsUpdateProjectErrors,
  ProjectsUpdateProjectMemberData,
  ProjectsUpdateProjectMemberErrors,
  ProjectsUpdateProjectMemberResponses,
  ProjectsUpdateProjectResponses,
  SkillsCreateSkillData,
  SkillsCreateSkillErrors,
  SkillsCreateSkillResponses,
  SkillsDeleteSkillData,
  SkillsDeleteSkillErrors,
  SkillsDeleteSkillResponses,
  SkillsGetOrganizationSkillsData,
  SkillsGetOrganizationSkillsErrors,
  SkillsGetOrganizationSkillsResponses,
  SkillsGetSkillData,
  SkillsGetSkillErrors,
  SkillsGetSkillResponses,
  SkillsUpdateSkillData,
  SkillsUpdateSkillErrors,
  SkillsUpdateSkillResponses,
  TestLakehouseMetricSqlData,
  TestLakehouseMetricSqlErrors,
  TestLakehouseMetricSqlResponses,
  ThreadsCreateThreadData,
  ThreadsCreateThreadErrors,
  ThreadsCreateThreadResponses,
  ThreadsDeleteThreadData,
  ThreadsDeleteThreadErrors,
  ThreadsDeleteThreadFileData,
  ThreadsDeleteThreadFileErrors,
  ThreadsDeleteThreadFileResponses,
  ThreadsDeleteThreadResponses,
  ThreadsDownloadThreadFileData,
  ThreadsDownloadThreadFileErrors,
  ThreadsDownloadThreadFileResponses,
  ThreadsGetThreadData,
  ThreadsGetThreadErrors,
  ThreadsGetThreadMessagesData,
  ThreadsGetThreadMessagesErrors,
  ThreadsGetThreadMessagesResponses,
  ThreadsGetThreadResponses,
  ThreadsListThreadFilesData,
  ThreadsListThreadFilesErrors,
  ThreadsListThreadFilesResponses,
  ThreadsUpdateThreadData,
  ThreadsUpdateThreadErrors,
  ThreadsUpdateThreadResponses,
  ThreadsUploadThreadFileData,
  ThreadsUploadThreadFileErrors,
  ThreadsUploadThreadFileResponses,
  UpdateDatasourceMetricData,
  UpdateDatasourceMetricErrors,
  UpdateDatasourceMetricResponses,
  UpdateLakehouseMetricData,
  UpdateLakehouseMetricErrors,
  UpdateLakehouseMetricResponses,
  UsersCreateNewUserData,
  UsersCreateNewUserErrors,
  UsersCreateNewUserResponses,
  UsersCreateUserContextEndpointData,
  UsersCreateUserContextEndpointErrors,
  UsersCreateUserContextEndpointResponses,
  UsersDeleteUserContextEndpointData,
  UsersDeleteUserContextEndpointErrors,
  UsersDeleteUserContextEndpointResponses,
  UsersGetUserContextsEndpointData,
  UsersGetUserContextsEndpointErrors,
  UsersGetUserContextsEndpointResponses,
  UsersGetUserProfileByEmailData,
  UsersGetUserProfileByEmailErrors,
  UsersGetUserProfileByEmailResponses,
  UsersGetUserProjectsData,
  UsersGetUserProjectsErrors,
  UsersGetUserProjectsResponses,
  UsersGetUserThreadsData,
  UsersGetUserThreadsErrors,
  UsersGetUserThreadsResponses,
  UsersUpdateUserContextEndpointData,
  UsersUpdateUserContextEndpointErrors,
  UsersUpdateUserContextEndpointResponses,
  WebhooksIngestResendEmailEventsData,
  WebhooksIngestResendEmailEventsErrors,
  WebhooksIngestResendEmailEventsResponses,
  WebhooksTriggerWebhookData,
  WebhooksTriggerWebhookErrors,
  WebhooksTriggerWebhookResponses,
} from "./types.gen";

export type Options<
  TData extends TDataShape = TDataShape,
  ThrowOnError extends boolean = boolean,
> = Options2<TData, ThrowOnError> & {
  /**
   * You can provide a client instance returned by `createClient()` instead of
   * individual options. This might be also useful if you want to implement a
   * custom client.
   */
  client?: Client;
  /**
   * You can pass arbitrary values through the `meta` object. This can be
   * used to access values that aren't defined as part of the SDK function.
   */
  meta?: Record<string, unknown>;
};

/**
 * Ingest Resend email lifecycle webhook events
 *
 * Receive and verify Resend lifecycle webhook events.
 */
export const webhooksIngestResendEmailEvents = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<WebhooksIngestResendEmailEventsData, ThrowOnError>,
) => {
  return (options?.client ?? client).post<
    WebhooksIngestResendEmailEventsResponses,
    WebhooksIngestResendEmailEventsErrors,
    ThrowOnError
  >({
    url: "/api/webhooks/resend/email-events",
    ...options,
  });
};

/**
 * Trigger playbook via webhook
 *
 * Trigger a playbook execution via webhook token.
 *
 * This endpoint is unauthenticated — security is provided by
 * the entropy of the webhook token (256-bit via secrets.token_urlsafe(32)).
 */
export const webhooksTriggerWebhook = <ThrowOnError extends boolean = false>(
  options: Options<WebhooksTriggerWebhookData, ThrowOnError>,
) => {
  return (options.client ?? client).post<
    WebhooksTriggerWebhookResponses,
    WebhooksTriggerWebhookErrors,
    ThrowOnError
  >({
    url: "/api/webhooks/{webhook_token}",
    ...options,
  });
};

/**
 * Create new user
 */
export const usersCreateNewUser = <ThrowOnError extends boolean = false>(
  options: Options<UsersCreateNewUserData, ThrowOnError>,
) => {
  return (options.client ?? client).post<
    UsersCreateNewUserResponses,
    UsersCreateNewUserErrors,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/api/users",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });
};

/**
 * Get all threads not assigned to a project for a user
 */
export const usersGetUserThreads = <ThrowOnError extends boolean = false>(
  options: Options<UsersGetUserThreadsData, ThrowOnError>,
) => {
  return (options.client ?? client).get<
    UsersGetUserThreadsResponses,
    UsersGetUserThreadsErrors,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/api/users/{user_id}/threads",
    ...options,
  });
};

/**
 * Get all projects for a user, optional pagination parameter
 */
export const usersGetUserProjects = <ThrowOnError extends boolean = false>(
  options: Options<UsersGetUserProjectsData, ThrowOnError>,
) => {
  return (options.client ?? client).get<
    UsersGetUserProjectsResponses,
    UsersGetUserProjectsErrors,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/api/users/{user_id}/projects",
    ...options,
  });
};

/**
 * Get all user contexts for a user
 */
export const usersGetUserContextsEndpoint = <
  ThrowOnError extends boolean = false,
>(
  options: Options<UsersGetUserContextsEndpointData, ThrowOnError>,
) => {
  return (options.client ?? client).get<
    UsersGetUserContextsEndpointResponses,
    UsersGetUserContextsEndpointErrors,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/api/users/{user_id}/contexts",
    ...options,
  });
};

/**
 * Create new user context
 */
export const usersCreateUserContextEndpoint = <
  ThrowOnError extends boolean = false,
>(
  options: Options<UsersCreateUserContextEndpointData, ThrowOnError>,
) => {
  return (options.client ?? client).post<
    UsersCreateUserContextEndpointResponses,
    UsersCreateUserContextEndpointErrors,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/api/users/context",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });
};

/**
 * Delete user context with given ID
 */
export const usersDeleteUserContextEndpoint = <
  ThrowOnError extends boolean = false,
>(
  options: Options<UsersDeleteUserContextEndpointData, ThrowOnError>,
) => {
  return (options.client ?? client).delete<
    UsersDeleteUserContextEndpointResponses,
    UsersDeleteUserContextEndpointErrors,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/api/users/context/{context_id}",
    ...options,
  });
};

/**
 * Update user context with given ID
 */
export const usersUpdateUserContextEndpoint = <
  ThrowOnError extends boolean = false,
>(
  options: Options<UsersUpdateUserContextEndpointData, ThrowOnError>,
) => {
  return (options.client ?? client).put<
    UsersUpdateUserContextEndpointResponses,
    UsersUpdateUserContextEndpointErrors,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/api/users/context/{context_id}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });
};

/**
 * Get User Profile By Email
 */
export const usersGetUserProfileByEmail = <
  ThrowOnError extends boolean = false,
>(
  options: Options<UsersGetUserProfileByEmailData, ThrowOnError>,
) => {
  return (options.client ?? client).get<
    UsersGetUserProfileByEmailResponses,
    UsersGetUserProfileByEmailErrors,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/api/users/profile/find",
    ...options,
  });
};

/**
 * Upload a file to a project with a given ID.
 */
export const filesUploadFile = <ThrowOnError extends boolean = false>(
  options: Options<FilesUploadFileData, ThrowOnError>,
) => {
  return (options.client ?? client).post<
    FilesUploadFileResponses,
    FilesUploadFileErrors,
    ThrowOnError
  >({
    ...formDataBodySerializer,
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/api/files/{project_id}/upload",
    ...options,
    headers: {
      "Content-Type": null,
      ...options.headers,
    },
  });
};

/**
 * Create an upload session with a signed URL for direct-to-Supabase uploads.
 */
export const filesCreateUploadSession = <ThrowOnError extends boolean = false>(
  options: Options<FilesCreateUploadSessionData, ThrowOnError>,
) => {
  return (options.client ?? client).post<
    FilesCreateUploadSessionResponses,
    FilesCreateUploadSessionErrors,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/api/files/{project_id}/upload-session",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });
};

/**
 * Complete an upload session after file was uploaded to Supabase.
 */
export const filesCompleteUploadSession = <
  ThrowOnError extends boolean = false,
>(
  options: Options<FilesCompleteUploadSessionData, ThrowOnError>,
) => {
  return (options.client ?? client).post<
    FilesCompleteUploadSessionResponses,
    FilesCompleteUploadSessionErrors,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/api/files/{project_id}/upload-session/{file_id}/complete",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });
};

/**
 * Scrape web page URL and save contents as file
 */
export const filesScrapeWebPage = <ThrowOnError extends boolean = false>(
  options: Options<FilesScrapeWebPageData, ThrowOnError>,
) => {
  return (options.client ?? client).post<
    FilesScrapeWebPageResponses,
    FilesScrapeWebPageErrors,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/api/files/{project_id}/web",
    ...options,
  });
};

/**
 * Get Accepted File Types
 */
export const filesGetAcceptedFileTypes = <ThrowOnError extends boolean = false>(
  options?: Options<FilesGetAcceptedFileTypesData, ThrowOnError>,
) => {
  return (options?.client ?? client).get<
    FilesGetAcceptedFileTypesResponses,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/api/files/file_types",
    ...options,
  });
};

/**
 * Delete a file with the given ID.
 */
export const filesDeleteFile = <ThrowOnError extends boolean = false>(
  options: Options<FilesDeleteFileData, ThrowOnError>,
) => {
  return (options.client ?? client).delete<
    FilesDeleteFileResponses,
    FilesDeleteFileErrors,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/api/files/{file_id}",
    ...options,
  });
};

/**
 * Get file with a given ID.
 */
export const filesGetFile = <ThrowOnError extends boolean = false>(
  options: Options<FilesGetFileData, ThrowOnError>,
) => {
  return (options.client ?? client).get<
    FilesGetFileResponses,
    FilesGetFileErrors,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/api/files/{file_id}",
    ...options,
  });
};

/**
 * Create embeddings for a file with ID. Removes any prior existing embeddings.
 */
export const filesIndexFile = <ThrowOnError extends boolean = false>(
  options: Options<FilesIndexFileData, ThrowOnError>,
) => {
  return (options.client ?? client).put<
    FilesIndexFileResponses,
    FilesIndexFileErrors,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/api/files/{file_id}/index",
    ...options,
  });
};

/**
 * Delete project with given ID
 */
export const projectsDeleteProject = <ThrowOnError extends boolean = false>(
  options: Options<ProjectsDeleteProjectData, ThrowOnError>,
) => {
  return (options.client ?? client).delete<
    ProjectsDeleteProjectResponses,
    ProjectsDeleteProjectErrors,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/api/projects/{project_id}",
    ...options,
  });
};

/**
 * Get a project by it's ID
 */
export const projectsGetProject = <ThrowOnError extends boolean = false>(
  options: Options<ProjectsGetProjectData, ThrowOnError>,
) => {
  return (options.client ?? client).get<
    ProjectsGetProjectResponses,
    ProjectsGetProjectErrors,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/api/projects/{project_id}",
    ...options,
  });
};

/**
 * Update project with given ID
 */
export const projectsUpdateProject = <ThrowOnError extends boolean = false>(
  options: Options<ProjectsUpdateProjectData, ThrowOnError>,
) => {
  return (options.client ?? client).put<
    ProjectsUpdateProjectResponses,
    ProjectsUpdateProjectErrors,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/api/projects/{project_id}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });
};

/**
 * Create new project
 */
export const projectsCreateProject = <ThrowOnError extends boolean = false>(
  options: Options<ProjectsCreateProjectData, ThrowOnError>,
) => {
  return (options.client ?? client).post<
    ProjectsCreateProjectResponses,
    ProjectsCreateProjectErrors,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/api/projects",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });
};

/**
 * Get all threads of a project
 */
export const projectsGetProjectThreads = <ThrowOnError extends boolean = false>(
  options: Options<ProjectsGetProjectThreadsData, ThrowOnError>,
) => {
  return (options.client ?? client).get<
    ProjectsGetProjectThreadsResponses,
    ProjectsGetProjectThreadsErrors,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/api/projects/{project_id}/threads",
    ...options,
  });
};

/**
 * Get all files of a project
 */
export const projectsGetProjectFiles = <ThrowOnError extends boolean = false>(
  options: Options<ProjectsGetProjectFilesData, ThrowOnError>,
) => {
  return (options.client ?? client).get<
    ProjectsGetProjectFilesResponses,
    ProjectsGetProjectFilesErrors,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/api/projects/{project_id}/files",
    ...options,
  });
};

/**
 * Get all members of a project
 */
export const projectsGetProjectMembers = <ThrowOnError extends boolean = false>(
  options: Options<ProjectsGetProjectMembersData, ThrowOnError>,
) => {
  return (options.client ?? client).get<
    ProjectsGetProjectMembersResponses,
    ProjectsGetProjectMembersErrors,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/api/projects/{project_id}/members",
    ...options,
  });
};

/**
 * Add or update a project member
 */
export const projectsAddProjectMember = <ThrowOnError extends boolean = false>(
  options: Options<ProjectsAddProjectMemberData, ThrowOnError>,
) => {
  return (options.client ?? client).post<
    ProjectsAddProjectMemberResponses,
    ProjectsAddProjectMemberErrors,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/api/projects/{project_id}/members",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });
};

/**
 * Remove a project member
 */
export const projectsRemoveProjectMember = <
  ThrowOnError extends boolean = false,
>(
  options: Options<ProjectsRemoveProjectMemberData, ThrowOnError>,
) => {
  return (options.client ?? client).delete<
    ProjectsRemoveProjectMemberResponses,
    ProjectsRemoveProjectMemberErrors,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/api/projects/{project_id}/members/{member_user_id}",
    ...options,
  });
};

/**
 * Update a project member role
 */
export const projectsUpdateProjectMember = <
  ThrowOnError extends boolean = false,
>(
  options: Options<ProjectsUpdateProjectMemberData, ThrowOnError>,
) => {
  return (options.client ?? client).put<
    ProjectsUpdateProjectMemberResponses,
    ProjectsUpdateProjectMemberErrors,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/api/projects/{project_id}/members/{member_user_id}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });
};

/**
 * Index all files of a project
 */
export const projectsIndexProjectFiles = <ThrowOnError extends boolean = false>(
  options: Options<ProjectsIndexProjectFilesData, ThrowOnError>,
) => {
  return (options.client ?? client).get<
    ProjectsIndexProjectFilesResponses,
    ProjectsIndexProjectFilesErrors,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/api/projects/{project_id}/files/index",
    ...options,
  });
};

/**
 * Delete thread with given ID
 */
export const threadsDeleteThread = <ThrowOnError extends boolean = false>(
  options: Options<ThreadsDeleteThreadData, ThrowOnError>,
) => {
  return (options.client ?? client).delete<
    ThreadsDeleteThreadResponses,
    ThreadsDeleteThreadErrors,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/api/threads/{thread_id}",
    ...options,
  });
};

/**
 * Get thread details
 */
export const threadsGetThread = <ThrowOnError extends boolean = false>(
  options: Options<ThreadsGetThreadData, ThrowOnError>,
) => {
  return (options.client ?? client).get<
    ThreadsGetThreadResponses,
    ThreadsGetThreadErrors,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/api/threads/{thread_id}",
    ...options,
  });
};

/**
 * Update thread with given ID
 */
export const threadsUpdateThread = <ThrowOnError extends boolean = false>(
  options: Options<ThreadsUpdateThreadData, ThrowOnError>,
) => {
  return (options.client ?? client).put<
    ThreadsUpdateThreadResponses,
    ThreadsUpdateThreadErrors,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/api/threads/{thread_id}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });
};

/**
 * Create new thread
 */
export const threadsCreateThread = <ThrowOnError extends boolean = false>(
  options: Options<ThreadsCreateThreadData, ThrowOnError>,
) => {
  return (options.client ?? client).post<
    ThreadsCreateThreadResponses,
    ThreadsCreateThreadErrors,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/api/threads",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });
};

/**
 * Get all messages for a given thread
 */
export const threadsGetThreadMessages = <ThrowOnError extends boolean = false>(
  options: Options<ThreadsGetThreadMessagesData, ThrowOnError>,
) => {
  return (options.client ?? client).get<
    ThreadsGetThreadMessagesResponses,
    ThreadsGetThreadMessagesErrors,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/api/threads/{thread_id}/messages",
    ...options,
  });
};

/**
 * List all files uploaded to thread
 */
export const threadsListThreadFiles = <ThrowOnError extends boolean = false>(
  options: Options<ThreadsListThreadFilesData, ThrowOnError>,
) => {
  return (options.client ?? client).get<
    ThreadsListThreadFilesResponses,
    ThreadsListThreadFilesErrors,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/api/threads/{thread_id}/files",
    ...options,
  });
};

/**
 * Upload a file to thread storage
 */
export const threadsUploadThreadFile = <ThrowOnError extends boolean = false>(
  options: Options<ThreadsUploadThreadFileData, ThrowOnError>,
) => {
  return (options.client ?? client).post<
    ThreadsUploadThreadFileResponses,
    ThreadsUploadThreadFileErrors,
    ThrowOnError
  >({
    ...formDataBodySerializer,
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/api/threads/{thread_id}/files",
    ...options,
    headers: {
      "Content-Type": null,
      ...options.headers,
    },
  });
};

/**
 * Delete a file from thread storage
 */
export const threadsDeleteThreadFile = <ThrowOnError extends boolean = false>(
  options: Options<ThreadsDeleteThreadFileData, ThrowOnError>,
) => {
  return (options.client ?? client).delete<
    ThreadsDeleteThreadFileResponses,
    ThreadsDeleteThreadFileErrors,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/api/threads/{thread_id}/files/{filename}",
    ...options,
  });
};

/**
 * Download a file from thread storage
 */
export const threadsDownloadThreadFile = <ThrowOnError extends boolean = false>(
  options: Options<ThreadsDownloadThreadFileData, ThrowOnError>,
) => {
  return (options.client ?? client).get<
    ThreadsDownloadThreadFileResponses,
    ThreadsDownloadThreadFileErrors,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/api/threads/{thread_id}/files/{filename}",
    ...options,
  });
};

/**
 * Create a new brain
 *
 * Create a new brain. creator_id is set from JWT, not request body.
 */
export const brainsCreateBrain = <ThrowOnError extends boolean = false>(
  options: Options<BrainsCreateBrainData, ThrowOnError>,
) => {
  return (options.client ?? client).post<
    BrainsCreateBrainResponses,
    BrainsCreateBrainErrors,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/api/brains",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });
};

/**
 * Delete a brain with given ID
 */
export const brainsDeleteBrain = <ThrowOnError extends boolean = false>(
  options: Options<BrainsDeleteBrainData, ThrowOnError>,
) => {
  return (options.client ?? client).delete<
    BrainsDeleteBrainResponses,
    BrainsDeleteBrainErrors,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/api/brains/{brain_id}",
    ...options,
  });
};

/**
 * Update brain with given ID
 *
 * Update a brain
 */
export const brainsUpdateBrain = <ThrowOnError extends boolean = false>(
  options: Options<BrainsUpdateBrainData, ThrowOnError>,
) => {
  return (options.client ?? client).put<
    BrainsUpdateBrainResponses,
    BrainsUpdateBrainErrors,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/api/brains/{brain_id}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });
};

/**
 * Get all brains for a user
 *
 * Get all brains for a user
 */
export const brainsGetBrainsForUserId = <ThrowOnError extends boolean = false>(
  options: Options<BrainsGetBrainsForUserIdData, ThrowOnError>,
) => {
  return (options.client ?? client).get<
    BrainsGetBrainsForUserIdResponses,
    BrainsGetBrainsForUserIdErrors,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/api/brains/{user_id}",
    ...options,
  });
};

/**
 * Create new message
 */
export const messagesCreateMessage = <ThrowOnError extends boolean = false>(
  options: Options<MessagesCreateMessageData, ThrowOnError>,
) => {
  return (options.client ?? client).post<
    MessagesCreateMessageResponses,
    MessagesCreateMessageErrors,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/api/messages",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });
};

/**
 * Delete message with given ID
 */
export const messagesDeleteMessage = <ThrowOnError extends boolean = false>(
  options: Options<MessagesDeleteMessageData, ThrowOnError>,
) => {
  return (options.client ?? client).delete<
    MessagesDeleteMessageResponses,
    MessagesDeleteMessageErrors,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/api/messages/{message_id}",
    ...options,
  });
};

/**
 * Get message processing status
 */
export const messagesGetMessage = <ThrowOnError extends boolean = false>(
  options: Options<MessagesGetMessageData, ThrowOnError>,
) => {
  return (options.client ?? client).get<
    MessagesGetMessageResponses,
    MessagesGetMessageErrors,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/api/messages/{message_id}",
    ...options,
  });
};

/**
 * Update message with given ID
 */
export const messagesUpdateMessage = <ThrowOnError extends boolean = false>(
  options: Options<MessagesUpdateMessageData, ThrowOnError>,
) => {
  return (options.client ?? client).put<
    MessagesUpdateMessageResponses,
    MessagesUpdateMessageErrors,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/api/messages/{message_id}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });
};

/**
 * Send a message to a Wayak Agent
 */
export const agentsGetWayakResponse = <ThrowOnError extends boolean = false>(
  options: Options<AgentsGetWayakResponseData, ThrowOnError>,
) => {
  return (options.client ?? client).post<
    AgentsGetWayakResponseResponses,
    AgentsGetWayakResponseErrors,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/api/agents/wayak",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });
};

/**
 * Stream a Wayak Agent response via SSE
 *
 * Stream agent response as Server-Sent Events for real-time token delivery.
 *
 * Supports reconnection via the Last-Event-ID header. If SSE streaming
 * is disabled, returns 503 Service Unavailable.
 */
export const agentsStreamWayakResponse = <ThrowOnError extends boolean = false>(
  options: Options<AgentsStreamWayakResponseData, ThrowOnError>,
) => {
  return (options.client ?? client).post<
    AgentsStreamWayakResponseResponses,
    AgentsStreamWayakResponseErrors,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/api/agents/wayak/stream",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });
};

/**
 * Send a message to a specific agent
 */
export const agentsGetSpecificAgentResponse = <
  ThrowOnError extends boolean = false,
>(
  options: Options<AgentsGetSpecificAgentResponseData, ThrowOnError>,
) => {
  return (options.client ?? client).post<
    AgentsGetSpecificAgentResponseResponses,
    AgentsGetSpecificAgentResponseErrors,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/api/agents/agent/{agentId}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });
};

/**
 * Get all supported models
 */
export const agentsGetAvailableModels = <ThrowOnError extends boolean = false>(
  options?: Options<AgentsGetAvailableModelsData, ThrowOnError>,
) => {
  return (options?.client ?? client).get<
    AgentsGetAvailableModelsResponses,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/api/agents/models",
    ...options,
  });
};

/**
 * Extract content from a file using OCR
 *
 * Extract content from a file (PDF or image) using OCR capabilities.
 * Returns a complete markdown document with embedded images.
 */
export const agentsExtractFileContent = <ThrowOnError extends boolean = false>(
  options: Options<AgentsExtractFileContentData, ThrowOnError>,
) => {
  return (options.client ?? client).post<
    AgentsExtractFileContentResponses,
    AgentsExtractFileContentErrors,
    ThrowOnError
  >({
    ...formDataBodySerializer,
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/api/agents/extraction",
    ...options,
    headers: {
      "Content-Type": null,
      ...options.headers,
    },
  });
};

/**
 * Get a direct completion from an LLM
 *
 * Get a direct completion from an LLM based on the provided messages.
 */
export const agentsGetCompletion = <ThrowOnError extends boolean = false>(
  options: Options<AgentsGetCompletionData, ThrowOnError>,
) => {
  return (options.client ?? client).post<
    AgentsGetCompletionResponses,
    AgentsGetCompletionErrors,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/api/agents/completion",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });
};

/**
 * Get User Organizations
 */
export const organizationsGetUserOrganizations = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<OrganizationsGetUserOrganizationsData, ThrowOnError>,
) => {
  return (options?.client ?? client).get<
    OrganizationsGetUserOrganizationsResponses,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/api/organizations",
    ...options,
  });
};

/**
 * Create Organization
 */
export const organizationsCreateOrganization = <
  ThrowOnError extends boolean = false,
>(
  options: Options<OrganizationsCreateOrganizationData, ThrowOnError>,
) => {
  return (options.client ?? client).post<
    OrganizationsCreateOrganizationResponses,
    OrganizationsCreateOrganizationErrors,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/api/organizations",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });
};

/**
 * Get Personal Organization
 */
export const organizationsGetPersonalOrganization = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<OrganizationsGetPersonalOrganizationData, ThrowOnError>,
) => {
  return (options?.client ?? client).get<
    OrganizationsGetPersonalOrganizationResponses,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/api/organizations/personal",
    ...options,
  });
};

/**
 * Get Organization
 */
export const organizationsGetOrganization = <
  ThrowOnError extends boolean = false,
>(
  options: Options<OrganizationsGetOrganizationData, ThrowOnError>,
) => {
  return (options.client ?? client).get<
    OrganizationsGetOrganizationResponses,
    OrganizationsGetOrganizationErrors,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/api/organizations/{org_id}",
    ...options,
  });
};

/**
 * Update Organization
 */
export const organizationsUpdateOrganization = <
  ThrowOnError extends boolean = false,
>(
  options: Options<OrganizationsUpdateOrganizationData, ThrowOnError>,
) => {
  return (options.client ?? client).put<
    OrganizationsUpdateOrganizationResponses,
    OrganizationsUpdateOrganizationErrors,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/api/organizations/{org_id}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });
};

/**
 * Get Organization Members
 */
export const organizationsGetOrganizationMembers = <
  ThrowOnError extends boolean = false,
>(
  options: Options<OrganizationsGetOrganizationMembersData, ThrowOnError>,
) => {
  return (options.client ?? client).get<
    OrganizationsGetOrganizationMembersResponses,
    OrganizationsGetOrganizationMembersErrors,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/api/organizations/{org_id}/members",
    ...options,
  });
};

/**
 * Add Organization Member
 */
export const organizationsAddOrganizationMember = <
  ThrowOnError extends boolean = false,
>(
  options: Options<OrganizationsAddOrganizationMemberData, ThrowOnError>,
) => {
  return (options.client ?? client).post<
    OrganizationsAddOrganizationMemberResponses,
    OrganizationsAddOrganizationMemberErrors,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/api/organizations/{org_id}/members",
    ...options,
  });
};

/**
 * Remove Organization Member
 */
export const organizationsRemoveOrganizationMember = <
  ThrowOnError extends boolean = false,
>(
  options: Options<OrganizationsRemoveOrganizationMemberData, ThrowOnError>,
) => {
  return (options.client ?? client).delete<
    OrganizationsRemoveOrganizationMemberResponses,
    OrganizationsRemoveOrganizationMemberErrors,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/api/organizations/{org_id}/members/{user_id}",
    ...options,
  });
};

/**
 * Update Organization Member Role
 *
 * Change a member's role. Admin-only. Protected against demoting
 * the last remaining OWNER — promote another member to OWNER first.
 */
export const organizationsUpdateOrganizationMemberRole = <
  ThrowOnError extends boolean = false,
>(
  options: Options<OrganizationsUpdateOrganizationMemberRoleData, ThrowOnError>,
) => {
  return (options.client ?? client).put<
    OrganizationsUpdateOrganizationMemberRoleResponses,
    OrganizationsUpdateOrganizationMemberRoleErrors,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/api/organizations/{org_id}/members/{user_id}/role",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });
};

/**
 * Get Organization Member Activity
 *
 * Per-member last-sign-in timestamps, admin-only.
 *
 * Reads last_sign_in_at via the Supabase Admin API (GoTrue) scoped to
 * the org's members. Works on any deployment, including local, where
 * the `auth` schema isn't exposed through PostgREST. When the Admin
 * API itself is unreachable, `available` is False so the UI shows
 * "unavailable" rather than reporting every member as "never signed
 * in".
 */
export const organizationsGetOrganizationMemberActivity = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    OrganizationsGetOrganizationMemberActivityData,
    ThrowOnError
  >,
) => {
  return (options.client ?? client).get<
    OrganizationsGetOrganizationMemberActivityResponses,
    OrganizationsGetOrganizationMemberActivityErrors,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/api/organizations/{org_id}/members/activity",
    ...options,
  });
};

/**
 * Get Organization Projects
 */
export const organizationsGetOrganizationProjects = <
  ThrowOnError extends boolean = false,
>(
  options: Options<OrganizationsGetOrganizationProjectsData, ThrowOnError>,
) => {
  return (options.client ?? client).get<
    OrganizationsGetOrganizationProjectsResponses,
    OrganizationsGetOrganizationProjectsErrors,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/api/organizations/{org_id}/projects",
    ...options,
  });
};

/**
 * Get Organization Threads
 *
 * Viewer-scoped thread list for an org. Returns ONLY threads
 * owned by the current caller. Admin settings pages must NOT use
 * this route — it would collapse aggregate views to the viewer's
 * own threads. Use `/threads/all` (admin-only) for org-wide
 * analytics.
 */
export const organizationsGetOrganizationThreads = <
  ThrowOnError extends boolean = false,
>(
  options: Options<OrganizationsGetOrganizationThreadsData, ThrowOnError>,
) => {
  return (options.client ?? client).get<
    OrganizationsGetOrganizationThreadsResponses,
    OrganizationsGetOrganizationThreadsErrors,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/api/organizations/{org_id}/threads",
    ...options,
  });
};

/**
 * Get Organization Threads All
 *
 * Org-wide thread list for admin analytics. Returns EVERY thread
 * in the org regardless of author. Admin-only — the existing
 * `/threads` route stays viewer-scoped for its legacy consumers.
 */
export const organizationsGetOrganizationThreadsAll = <
  ThrowOnError extends boolean = false,
>(
  options: Options<OrganizationsGetOrganizationThreadsAllData, ThrowOnError>,
) => {
  return (options.client ?? client).get<
    OrganizationsGetOrganizationThreadsAllResponses,
    OrganizationsGetOrganizationThreadsAllErrors,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/api/organizations/{org_id}/threads/all",
    ...options,
  });
};

/**
 * Get Organization Brains
 */
export const organizationsGetOrganizationBrains = <
  ThrowOnError extends boolean = false,
>(
  options: Options<OrganizationsGetOrganizationBrainsData, ThrowOnError>,
) => {
  return (options.client ?? client).get<
    OrganizationsGetOrganizationBrainsResponses,
    OrganizationsGetOrganizationBrainsErrors,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/api/organizations/{org_id}/brains",
    ...options,
  });
};

/**
 * List Knowledge Bases
 *
 * List all Knowledge Bases for an organization.
 *
 * Query parameters:
 * - active_only: If True, only return active KBs (default: True)
 */
export const knowledgeBasesListKnowledgeBases = <
  ThrowOnError extends boolean = false,
>(
  options: Options<KnowledgeBasesListKnowledgeBasesData, ThrowOnError>,
) => {
  return (options.client ?? client).get<
    KnowledgeBasesListKnowledgeBasesResponses,
    KnowledgeBasesListKnowledgeBasesErrors,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/api/organizations/{org_id}/knowledge-bases",
    ...options,
  });
};

/**
 * Create Knowledge Base
 *
 * Create a new Knowledge Base.
 *
 * Requires: User must be a member of the organization.
 */
export const knowledgeBasesCreateKnowledgeBase = <
  ThrowOnError extends boolean = false,
>(
  options: Options<KnowledgeBasesCreateKnowledgeBaseData, ThrowOnError>,
) => {
  return (options.client ?? client).post<
    KnowledgeBasesCreateKnowledgeBaseResponses,
    KnowledgeBasesCreateKnowledgeBaseErrors,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/api/organizations/{org_id}/knowledge-bases",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });
};

/**
 * Delete Knowledge Base
 *
 * Delete a Knowledge Base (soft delete).
 *
 * Only OWNER and ADMIN roles can delete.
 */
export const knowledgeBasesDeleteKnowledgeBase = <
  ThrowOnError extends boolean = false,
>(
  options: Options<KnowledgeBasesDeleteKnowledgeBaseData, ThrowOnError>,
) => {
  return (options.client ?? client).delete<
    KnowledgeBasesDeleteKnowledgeBaseResponses,
    KnowledgeBasesDeleteKnowledgeBaseErrors,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/api/organizations/{org_id}/knowledge-bases/{kb_id}",
    ...options,
  });
};

/**
 * Get Knowledge Base
 *
 * Get a Knowledge Base by ID with stats.
 */
export const knowledgeBasesGetKnowledgeBase = <
  ThrowOnError extends boolean = false,
>(
  options: Options<KnowledgeBasesGetKnowledgeBaseData, ThrowOnError>,
) => {
  return (options.client ?? client).get<
    KnowledgeBasesGetKnowledgeBaseResponses,
    KnowledgeBasesGetKnowledgeBaseErrors,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/api/organizations/{org_id}/knowledge-bases/{kb_id}",
    ...options,
  });
};

/**
 * Update Knowledge Base
 *
 * Update a Knowledge Base.
 *
 * Only OWNER and ADMIN roles can update.
 */
export const knowledgeBasesUpdateKnowledgeBase = <
  ThrowOnError extends boolean = false,
>(
  options: Options<KnowledgeBasesUpdateKnowledgeBaseData, ThrowOnError>,
) => {
  return (options.client ?? client).patch<
    KnowledgeBasesUpdateKnowledgeBaseResponses,
    KnowledgeBasesUpdateKnowledgeBaseErrors,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/api/organizations/{org_id}/knowledge-bases/{kb_id}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });
};

/**
 * List Folders
 *
 * Get folder list and tree structure for a Knowledge Base.
 */
export const knowledgeBasesListFolders = <ThrowOnError extends boolean = false>(
  options: Options<KnowledgeBasesListFoldersData, ThrowOnError>,
) => {
  return (options.client ?? client).get<
    KnowledgeBasesListFoldersResponses,
    KnowledgeBasesListFoldersErrors,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/api/organizations/{org_id}/knowledge-bases/{kb_id}/folders",
    ...options,
  });
};

/**
 * Create Folder
 *
 * Create a new folder in a Knowledge Base.
 *
 * Enforces maximum depth of 10 levels.
 */
export const knowledgeBasesCreateFolder = <
  ThrowOnError extends boolean = false,
>(
  options: Options<KnowledgeBasesCreateFolderData, ThrowOnError>,
) => {
  return (options.client ?? client).post<
    KnowledgeBasesCreateFolderResponses,
    KnowledgeBasesCreateFolderErrors,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/api/organizations/{org_id}/knowledge-bases/{kb_id}/folders",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });
};

/**
 * Delete Folder
 *
 * Delete a folder and all its contents (cascade delete).
 */
export const knowledgeBasesDeleteFolder = <
  ThrowOnError extends boolean = false,
>(
  options: Options<KnowledgeBasesDeleteFolderData, ThrowOnError>,
) => {
  return (options.client ?? client).delete<
    KnowledgeBasesDeleteFolderResponses,
    KnowledgeBasesDeleteFolderErrors,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/api/organizations/{org_id}/knowledge-bases/{kb_id}/folders/{folder_id}",
    ...options,
  });
};

/**
 * Get Folder Contents
 *
 * Get folder contents (subfolders and files).
 */
export const knowledgeBasesGetFolderContents = <
  ThrowOnError extends boolean = false,
>(
  options: Options<KnowledgeBasesGetFolderContentsData, ThrowOnError>,
) => {
  return (options.client ?? client).get<
    KnowledgeBasesGetFolderContentsResponses,
    KnowledgeBasesGetFolderContentsErrors,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/api/organizations/{org_id}/knowledge-bases/{kb_id}/folders/{folder_id}",
    ...options,
  });
};

/**
 * Update Folder
 *
 * Update folder (rename or move).
 *
 * Validates depth limit when moving folders.
 */
export const knowledgeBasesUpdateFolder = <
  ThrowOnError extends boolean = false,
>(
  options: Options<KnowledgeBasesUpdateFolderData, ThrowOnError>,
) => {
  return (options.client ?? client).patch<
    KnowledgeBasesUpdateFolderResponses,
    KnowledgeBasesUpdateFolderErrors,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/api/organizations/{org_id}/knowledge-bases/{kb_id}/folders/{folder_id}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });
};

/**
 * List Files
 *
 * List files in a Knowledge Base or folder.
 *
 * Query parameters:
 * - folder_id: Optional folder ID. If not provided, lists root-level files.
 * Use 'all' to list all files regardless of folder.
 */
export const knowledgeBasesListFiles = <ThrowOnError extends boolean = false>(
  options: Options<KnowledgeBasesListFilesData, ThrowOnError>,
) => {
  return (options.client ?? client).get<
    KnowledgeBasesListFilesResponses,
    KnowledgeBasesListFilesErrors,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/api/organizations/{org_id}/knowledge-bases/{kb_id}/files",
    ...options,
  });
};

/**
 * Upload File
 *
 * Upload a file to a Knowledge Base and trigger background processing.
 *
 * Returns immediately with job_id. Client should poll job status for progress.
 *
 * Max file size: 100 MB
 */
export const knowledgeBasesUploadFile = <ThrowOnError extends boolean = false>(
  options: Options<KnowledgeBasesUploadFileData, ThrowOnError>,
) => {
  return (options.client ?? client).post<
    KnowledgeBasesUploadFileResponses,
    KnowledgeBasesUploadFileErrors,
    ThrowOnError
  >({
    ...formDataBodySerializer,
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/api/organizations/{org_id}/knowledge-bases/{kb_id}/files",
    ...options,
    headers: {
      "Content-Type": null,
      ...options.headers,
    },
  });
};

/**
 * Create Upload Session
 *
 * Create an upload session for resumable file upload.
 *
 * Step 1 of the 3-step resumable upload flow:
 * 1. POST this endpoint -> get resumable_url + file_id
 * 2. PUT chunks to resumable_url (client uploads directly to GCS)
 * 3. POST .../complete -> verify blob + enqueue processing
 *
 * For local dev (no GCS), use the local-upload endpoint instead of step 2.
 */
export const knowledgeBasesCreateUploadSession = <
  ThrowOnError extends boolean = false,
>(
  options: Options<KnowledgeBasesCreateUploadSessionData, ThrowOnError>,
) => {
  return (options.client ?? client).post<
    KnowledgeBasesCreateUploadSessionResponses,
    KnowledgeBasesCreateUploadSessionErrors,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/api/organizations/{org_id}/knowledge-bases/{kb_id}/files/upload-session",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });
};

/**
 * Local Upload
 *
 * Upload file content for local development (no GCS).
 *
 * Step 2 alternative for local dev: POST the file to backend storage
 * instead of PUTting to a GCS resumable URL.
 */
export const knowledgeBasesLocalUpload = <ThrowOnError extends boolean = false>(
  options: Options<KnowledgeBasesLocalUploadData, ThrowOnError>,
) => {
  return (options.client ?? client).post<
    KnowledgeBasesLocalUploadResponses,
    KnowledgeBasesLocalUploadErrors,
    ThrowOnError
  >({
    ...formDataBodySerializer,
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/api/organizations/{org_id}/knowledge-bases/{kb_id}/files/upload-session/{file_id}/local-upload",
    ...options,
    headers: {
      "Content-Type": null,
      ...options.headers,
    },
  });
};

/**
 * Complete Upload
 *
 * Complete an upload session: verify blob, create job, enqueue Celery.
 *
 * Step 3 of the 3-step resumable upload flow.
 * Call after the file has been uploaded to GCS (or via local-upload).
 */
export const knowledgeBasesCompleteUpload = <
  ThrowOnError extends boolean = false,
>(
  options: Options<KnowledgeBasesCompleteUploadData, ThrowOnError>,
) => {
  return (options.client ?? client).post<
    KnowledgeBasesCompleteUploadResponses,
    KnowledgeBasesCompleteUploadErrors,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/api/organizations/{org_id}/knowledge-bases/{kb_id}/files/upload-session/{file_id}/complete",
    ...options,
  });
};

/**
 * Delete File
 *
 * Delete a file (soft delete).
 */
export const knowledgeBasesDeleteFile = <ThrowOnError extends boolean = false>(
  options: Options<KnowledgeBasesDeleteFileData, ThrowOnError>,
) => {
  return (options.client ?? client).delete<
    KnowledgeBasesDeleteFileResponses,
    KnowledgeBasesDeleteFileErrors,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/api/organizations/{org_id}/knowledge-bases/{kb_id}/files/{file_id}",
    ...options,
  });
};

/**
 * Get File
 *
 * Get file metadata by ID.
 */
export const knowledgeBasesGetFile = <ThrowOnError extends boolean = false>(
  options: Options<KnowledgeBasesGetFileData, ThrowOnError>,
) => {
  return (options.client ?? client).get<
    KnowledgeBasesGetFileResponses,
    KnowledgeBasesGetFileErrors,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/api/organizations/{org_id}/knowledge-bases/{kb_id}/files/{file_id}",
    ...options,
  });
};

/**
 * Move File
 *
 * Move a file to a different folder.
 */
export const knowledgeBasesMoveFile = <ThrowOnError extends boolean = false>(
  options: Options<KnowledgeBasesMoveFileData, ThrowOnError>,
) => {
  return (options.client ?? client).patch<
    KnowledgeBasesMoveFileResponses,
    KnowledgeBasesMoveFileErrors,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/api/organizations/{org_id}/knowledge-bases/{kb_id}/files/{file_id}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });
};

/**
 * Stream the raw file content for inline preview or download.
 *
 * Stream the raw bytes of a KB file so the browser can preview or
 * download it. Authenticated via the existing org-membership check —
 * we never expose public URLs or signed URLs to the underlying object
 * storage.
 */
export const knowledgeBasesGetFileContent = <
  ThrowOnError extends boolean = false,
>(
  options: Options<KnowledgeBasesGetFileContentData, ThrowOnError>,
) => {
  return (options.client ?? client).get<
    KnowledgeBasesGetFileContentResponses,
    KnowledgeBasesGetFileContentErrors,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/api/organizations/{org_id}/knowledge-bases/{kb_id}/files/{file_id}/content",
    ...options,
  });
};

/**
 * Issue a short-lived signed download URL for third-party viewers.
 *
 * Return a short-lived signed URL pointing at the KB file in GCS. Used
 * to hand the file to third-party viewers that need a publicly
 * fetchable URL — Google Docs Viewer for PowerPoint, for example.
 *
 * The URL grants read-only access for at most 1 hour. The caller is
 * still auth-checked against org membership here, before the signed
 * URL is issued.
 */
export const knowledgeBasesGetFileSignedUrl = <
  ThrowOnError extends boolean = false,
>(
  options: Options<KnowledgeBasesGetFileSignedUrlData, ThrowOnError>,
) => {
  return (options.client ?? client).get<
    KnowledgeBasesGetFileSignedUrlResponses,
    KnowledgeBasesGetFileSignedUrlErrors,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/api/organizations/{org_id}/knowledge-bases/{kb_id}/files/{file_id}/signed-url",
    ...options,
  });
};

/**
 * Get Job Status
 *
 * Poll job status and progress.
 *
 * Use this endpoint to track background processing jobs (file upload, OCR, etc.).
 */
export const knowledgeBasesGetJobStatus = <
  ThrowOnError extends boolean = false,
>(
  options: Options<KnowledgeBasesGetJobStatusData, ThrowOnError>,
) => {
  return (options.client ?? client).get<
    KnowledgeBasesGetJobStatusResponses,
    KnowledgeBasesGetJobStatusErrors,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/api/organizations/{org_id}/knowledge-bases/jobs/{job_id}",
    ...options,
  });
};

/**
 * List Jobs
 *
 * List processing jobs for an organization.
 *
 * Query parameters:
 * - status: Optional status filter ('queued', 'running', 'completed', 'failed', 'cancelled')
 * - limit: Maximum number of jobs to return (default 100)
 */
export const knowledgeBasesListJobs = <ThrowOnError extends boolean = false>(
  options: Options<KnowledgeBasesListJobsData, ThrowOnError>,
) => {
  return (options.client ?? client).get<
    KnowledgeBasesListJobsResponses,
    KnowledgeBasesListJobsErrors,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/api/organizations/{org_id}/knowledge-bases/jobs",
    ...options,
  });
};

/**
 * List Active Jobs
 *
 * List all queued and running jobs for an organization.
 */
export const knowledgeBasesListActiveJobs = <
  ThrowOnError extends boolean = false,
>(
  options: Options<KnowledgeBasesListActiveJobsData, ThrowOnError>,
) => {
  return (options.client ?? client).get<
    KnowledgeBasesListActiveJobsResponses,
    KnowledgeBasesListActiveJobsErrors,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/api/organizations/{org_id}/knowledge-bases/jobs/active",
    ...options,
  });
};

/**
 * Cancel Job
 *
 * Cancel a queued or running job.
 */
export const knowledgeBasesCancelJob = <ThrowOnError extends boolean = false>(
  options: Options<KnowledgeBasesCancelJobData, ThrowOnError>,
) => {
  return (options.client ?? client).post<
    KnowledgeBasesCancelJobResponses,
    KnowledgeBasesCancelJobErrors,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/api/organizations/{org_id}/knowledge-bases/jobs/{job_id}/cancel",
    ...options,
  });
};

/**
 * Invite User To Organization
 *
 * Invite a user to join an organization.
 *
 * Flow:
 * 1. Check if user already exists
 * 2. Check if user is already a member
 * 3. For existing users: Add immediately to org (no email)
 * 4. For new users: Create invitation and send email via Supabase
 * 5. Handle duplicate invitations by updating role and resending
 */
export const invitationsInviteUserToOrganization = <
  ThrowOnError extends boolean = false,
>(
  options: Options<InvitationsInviteUserToOrganizationData, ThrowOnError>,
) => {
  return (options.client ?? client).post<
    InvitationsInviteUserToOrganizationResponses,
    InvitationsInviteUserToOrganizationErrors,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/api/invitations/{org_id}/invite",
    ...options,
  });
};

/**
 * Get Organization Invitations
 *
 * Get all pending invitations for an organization
 */
export const invitationsGetOrganizationInvitations = <
  ThrowOnError extends boolean = false,
>(
  options: Options<InvitationsGetOrganizationInvitationsData, ThrowOnError>,
) => {
  return (options.client ?? client).get<
    InvitationsGetOrganizationInvitationsResponses,
    InvitationsGetOrganizationInvitationsErrors,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/api/invitations/{org_id}/invitations",
    ...options,
  });
};

/**
 * Cancel Invitation
 *
 * Cancel a pending invitation — must be admin of the invitation's org.
 */
export const invitationsCancelInvitation = <
  ThrowOnError extends boolean = false,
>(
  options: Options<InvitationsCancelInvitationData, ThrowOnError>,
) => {
  return (options.client ?? client).delete<
    InvitationsCancelInvitationResponses,
    InvitationsCancelInvitationErrors,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/api/invitations/invitations/{invitation_id}",
    ...options,
  });
};

/**
 * Accept Invitation
 *
 * Accept an invitation and join the organization.
 * Called after user signs up via invitation email.
 * User ID comes from JWT, not query param.
 */
export const invitationsAcceptInvitation = <
  ThrowOnError extends boolean = false,
>(
  options: Options<InvitationsAcceptInvitationData, ThrowOnError>,
) => {
  return (options.client ?? client).post<
    InvitationsAcceptInvitationResponses,
    InvitationsAcceptInvitationErrors,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/api/invitations/accept/{invitation_id}",
    ...options,
  });
};

/**
 * Get all dashboards for an organization
 *
 * Get all dashboards for an organization
 *
 * Args:
 * org_id: Organization ID to filter by
 *
 * Returns:
 * List of dashboards
 */
export const ontologyGetDashboards = <ThrowOnError extends boolean = false>(
  options: Options<OntologyGetDashboardsData, ThrowOnError>,
) => {
  return (options.client ?? client).get<
    OntologyGetDashboardsResponses,
    OntologyGetDashboardsErrors,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/api/ontology/dashboards",
    ...options,
  });
};

/**
 * Create a new dashboard
 *
 * Create a new dashboard with metrics layout
 *
 * Args:
 * dashboard: The dashboard data to create
 *
 * Returns:
 * The created dashboard
 */
export const ontologyCreateDashboard = <ThrowOnError extends boolean = false>(
  options: Options<OntologyCreateDashboardData, ThrowOnError>,
) => {
  return (options.client ?? client).post<
    OntologyCreateDashboardResponses,
    OntologyCreateDashboardErrors,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/api/ontology/dashboards",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });
};

/**
 * Delete a dashboard
 *
 * Delete a dashboard
 *
 * Args:
 * dashboard_id: Dashboard ID to delete
 *
 * Returns:
 * The deleted dashboard
 */
export const ontologyDeleteDashboard = <ThrowOnError extends boolean = false>(
  options: Options<OntologyDeleteDashboardData, ThrowOnError>,
) => {
  return (options.client ?? client).delete<
    OntologyDeleteDashboardResponses,
    OntologyDeleteDashboardErrors,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/api/ontology/dashboards/{dashboard_id}",
    ...options,
  });
};

/**
 * Get a dashboard by ID
 *
 * Get a dashboard by ID
 *
 * Args:
 * dashboard_id: Dashboard ID to retrieve
 *
 * Returns:
 * The dashboard
 */
export const ontologyGetDashboard = <ThrowOnError extends boolean = false>(
  options: Options<OntologyGetDashboardData, ThrowOnError>,
) => {
  return (options.client ?? client).get<
    OntologyGetDashboardResponses,
    OntologyGetDashboardErrors,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/api/ontology/dashboards/{dashboard_id}",
    ...options,
  });
};

/**
 * Update a dashboard
 *
 * Update a dashboard
 *
 * Args:
 * dashboard_id: Dashboard ID to update
 * update_data: Data to update
 *
 * Returns:
 * The updated dashboard
 */
export const ontologyUpdateDashboard = <ThrowOnError extends boolean = false>(
  options: Options<OntologyUpdateDashboardData, ThrowOnError>,
) => {
  return (options.client ?? client).put<
    OntologyUpdateDashboardResponses,
    OntologyUpdateDashboardErrors,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/api/ontology/dashboards/{dashboard_id}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });
};

/**
 * Get available filters for a dashboard
 *
 * Get available filters for all views in a dashboard.
 *
 * Discovers filters by analyzing semantic object references in each view's SQL
 * and returns combined filters with options.
 *
 * Args:
 * dashboard_id: Dashboard ID
 * org_id: Organization ID
 *
 * Returns:
 * Available filters for the dashboard
 */
export const ontologyGetAvailableFilters = <
  ThrowOnError extends boolean = false,
>(
  options: Options<OntologyGetAvailableFiltersData, ThrowOnError>,
) => {
  return (options.client ?? client).get<
    OntologyGetAvailableFiltersResponses,
    OntologyGetAvailableFiltersErrors,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/api/ontology/dashboards/{dashboard_id}/available-filters",
    ...options,
  });
};

/**
 * Generate dashboard context for agent
 *
 * Generate context document for dashboard agent
 *
 * This endpoint fetches all views in the dashboard and generates
 * a formatted context document that includes view metadata, SQL queries,
 * and chart configurations for the agent to understand the dashboard.
 *
 * Args:
 * dashboard_id: Dashboard ID
 * org_id: Organization ID
 *
 * Returns:
 * Generated context document
 */
export const ontologyGetDashboardContext = <
  ThrowOnError extends boolean = false,
>(
  options: Options<OntologyGetDashboardContextData, ThrowOnError>,
) => {
  return (options.client ?? client).post<
    OntologyGetDashboardContextResponses,
    OntologyGetDashboardContextErrors,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/api/ontology/dashboards/{dashboard_id}/context",
    ...options,
  });
};

/**
 * Test database connection
 *
 * Test connection to a database.
 *
 * Args:
 * request: Connection test request with database type and credentials
 *
 * Returns:
 * Connection test results including database information
 */
export const ontologyTestDatabaseConnection = <
  ThrowOnError extends boolean = false,
>(
  options: Options<OntologyTestDatabaseConnectionData, ThrowOnError>,
) => {
  return (options.client ?? client).post<
    OntologyTestDatabaseConnectionResponses,
    OntologyTestDatabaseConnectionErrors,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/api/ontology/lakehouse/database-integration/connections/test",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });
};

/**
 * Discover tables in database
 *
 * Discover available tables in a database.
 *
 * Args:
 * request: Table discovery request
 *
 * Returns:
 * List of discovered tables with metadata
 */
export const ontologyDiscoverDatabaseTables = <
  ThrowOnError extends boolean = false,
>(
  options: Options<OntologyDiscoverDatabaseTablesData, ThrowOnError>,
) => {
  return (options.client ?? client).post<
    OntologyDiscoverDatabaseTablesResponses,
    OntologyDiscoverDatabaseTablesErrors,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/api/ontology/lakehouse/database-integration/connections/discover-tables",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });
};

/**
 * Discover tables using stored connection
 *
 * Discover available tables using a stored database connection.
 *
 * This endpoint will use cached schema data if available and use_cache=True.
 * Set use_cache=False to force a fresh discovery from the database.
 *
 * Args:
 * connection_id: ID of the stored database connection
 * schema_name: Optional schema name to filter tables
 * use_cache: Whether to use cached schema data (default: True)
 *
 * Returns:
 * List of discovered tables with metadata
 */
export const ontologyDiscoverTablesByConnectionId = <
  ThrowOnError extends boolean = false,
>(
  options: Options<OntologyDiscoverTablesByConnectionIdData, ThrowOnError>,
) => {
  return (options.client ?? client).get<
    OntologyDiscoverTablesByConnectionIdResponses,
    OntologyDiscoverTablesByConnectionIdErrors,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/api/ontology/lakehouse/database-integration/connections/{connection_id}/discover-tables",
    ...options,
  });
};

/**
 * Sync and cache foreign connection schema
 *
 * Discover and cache schema from a foreign database connection.
 *
 * This endpoint will:
 * 1. Discover all tables and their schemas from the external database
 * 2. Store the schema information in the foreign_connections table
 * 3. Update the schema_synced_at timestamp
 * 4. Return the discovered schema
 *
 * Use this to cache schema for better performance when querying foreign connections.
 *
 * Args:
 * connection_id: ID of the stored database connection
 * schema_name: Optional schema name to filter tables
 *
 * Returns:
 * List of discovered tables with metadata
 */
export const ontologySyncForeignConnectionSchema = <
  ThrowOnError extends boolean = false,
>(
  options: Options<OntologySyncForeignConnectionSchemaData, ThrowOnError>,
) => {
  return (options.client ?? client).post<
    OntologySyncForeignConnectionSchemaResponses,
    OntologySyncForeignConnectionSchemaErrors,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/api/ontology/lakehouse/database-integration/connections/{connection_id}/sync-schema",
    ...options,
  });
};

/**
 * List database connections
 *
 * List all database connections for the user.
 *
 * Returns:
 * List of database connections
 */
export const ontologyListDatabaseConnections = <
  ThrowOnError extends boolean = false,
>(
  options: Options<OntologyListDatabaseConnectionsData, ThrowOnError>,
) => {
  return (options.client ?? client).get<
    OntologyListDatabaseConnectionsResponses,
    OntologyListDatabaseConnectionsErrors,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/api/ontology/lakehouse/database-integration/connections",
    ...options,
  });
};

/**
 * Create database connection
 *
 * Create a new database connection configuration.
 *
 * Args:
 * request: Connection creation request
 *
 * Returns:
 * Created connection information
 */
export const ontologyCreateDatabaseConnection = <
  ThrowOnError extends boolean = false,
>(
  options: Options<OntologyCreateDatabaseConnectionData, ThrowOnError>,
) => {
  return (options.client ?? client).post<
    OntologyCreateDatabaseConnectionResponses,
    OntologyCreateDatabaseConnectionErrors,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/api/ontology/lakehouse/database-integration/connections",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });
};

/**
 * Create sync configuration
 *
 * Create a new database sync configuration.
 *
 * Args:
 * request: Sync configuration request
 *
 * Returns:
 * Created sync configuration
 */
export const ontologyCreateSyncConfiguration = <
  ThrowOnError extends boolean = false,
>(
  options: Options<OntologyCreateSyncConfigurationData, ThrowOnError>,
) => {
  return (options.client ?? client).post<
    OntologyCreateSyncConfigurationResponses,
    OntologyCreateSyncConfigurationErrors,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/api/ontology/lakehouse/database-integration/sync-configs",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });
};

/**
 * List sync jobs
 *
 * List sync jobs for the user.
 *
 * Args:
 * sync_config_id: Optional filter by sync configuration
 *
 * Returns:
 * List of sync jobs
 */
export const ontologyListSyncJobs = <ThrowOnError extends boolean = false>(
  options?: Options<OntologyListSyncJobsData, ThrowOnError>,
) => {
  return (options?.client ?? client).get<
    OntologyListSyncJobsResponses,
    OntologyListSyncJobsErrors,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/api/ontology/lakehouse/database-integration/sync-jobs",
    ...options,
  });
};

/**
 * Start sync job
 *
 * Start a database sync job.
 *
 * Args:
 * request: Sync job start request
 *
 * Returns:
 * Started sync job information
 */
export const ontologyStartSyncJob = <ThrowOnError extends boolean = false>(
  options: Options<OntologyStartSyncJobData, ThrowOnError>,
) => {
  return (options.client ?? client).post<
    OntologyStartSyncJobResponses,
    OntologyStartSyncJobErrors,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/api/ontology/lakehouse/database-integration/sync-jobs",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });
};

/**
 * Cancel sync job
 *
 * Cancel a running sync job.
 *
 * Args:
 * job_id: Sync job ID to cancel
 *
 * Returns:
 * Cancellation confirmation
 */
export const ontologyCancelSyncJob = <ThrowOnError extends boolean = false>(
  options: Options<OntologyCancelSyncJobData, ThrowOnError>,
) => {
  return (options.client ?? client).delete<
    OntologyCancelSyncJobResponses,
    OntologyCancelSyncJobErrors,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/api/ontology/lakehouse/database-integration/sync-jobs/{job_id}",
    ...options,
  });
};

/**
 * Get sync job status
 *
 * Get status of a sync job.
 *
 * Args:
 * job_id: Sync job ID
 *
 * Returns:
 * Sync job status and progress
 */
export const ontologyGetSyncJobStatus = <ThrowOnError extends boolean = false>(
  options: Options<OntologyGetSyncJobStatusData, ThrowOnError>,
) => {
  return (options.client ?? client).get<
    OntologyGetSyncJobStatusResponses,
    OntologyGetSyncJobStatusErrors,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/api/ontology/lakehouse/database-integration/sync-jobs/{job_id}",
    ...options,
  });
};

/**
 * List Views
 *
 * List all views for an organization with optional filtering.
 */
export const ontologyListViews = <ThrowOnError extends boolean = false>(
  options: Options<OntologyListViewsData, ThrowOnError>,
) => {
  return (options.client ?? client).get<
    OntologyListViewsResponses,
    OntologyListViewsErrors,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/api/ontology/lakehouse/views",
    ...options,
  });
};

/**
 * Create View
 *
 * Create a new lakehouse view.
 *
 * A view is a saved visualization with a SQL query and chart configuration.
 */
export const ontologyCreateView = <ThrowOnError extends boolean = false>(
  options: Options<OntologyCreateViewData, ThrowOnError>,
) => {
  return (options.client ?? client).post<
    OntologyCreateViewResponses,
    OntologyCreateViewErrors,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/api/ontology/lakehouse/views",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });
};

/**
 * Delete View
 *
 * Delete a view.
 */
export const ontologyDeleteView = <ThrowOnError extends boolean = false>(
  options: Options<OntologyDeleteViewData, ThrowOnError>,
) => {
  return (options.client ?? client).delete<
    OntologyDeleteViewResponses,
    OntologyDeleteViewErrors,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/api/ontology/lakehouse/views/{view_id}",
    ...options,
  });
};

/**
 * Get View
 *
 * Get a single view by ID.
 */
export const ontologyGetView = <ThrowOnError extends boolean = false>(
  options: Options<OntologyGetViewData, ThrowOnError>,
) => {
  return (options.client ?? client).get<
    OntologyGetViewResponses,
    OntologyGetViewErrors,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/api/ontology/lakehouse/views/{view_id}",
    ...options,
  });
};

/**
 * Update View
 *
 * Update an existing view.
 *
 * Only provided fields will be updated.
 */
export const ontologyUpdateView = <ThrowOnError extends boolean = false>(
  options: Options<OntologyUpdateViewData, ThrowOnError>,
) => {
  return (options.client ?? client).put<
    OntologyUpdateViewResponses,
    OntologyUpdateViewErrors,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/api/ontology/lakehouse/views/{view_id}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });
};

/**
 * Get View Available Filters
 *
 * Get available filters for a view.
 *
 * Discovers filters by analyzing semantic object references in the view's SQL
 * and returning filterable columns with their options.
 */
export const ontologyGetViewAvailableFilters = <
  ThrowOnError extends boolean = false,
>(
  options: Options<OntologyGetViewAvailableFiltersData, ThrowOnError>,
) => {
  return (options.client ?? client).get<
    OntologyGetViewAvailableFiltersResponses,
    OntologyGetViewAvailableFiltersErrors,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/api/ontology/lakehouse/views/{view_id}/available-filters",
    ...options,
  });
};

/**
 * Execute View
 *
 * Execute a view's SQL query and return results with visualization config.
 *
 * This runs the saved SQL query and returns the data along with the
 * chart configuration for rendering.
 *
 * Optionally accepts filter_values in the request body to filter results
 * at the semantic object level (before aggregation).
 */
export const ontologyExecuteView = <ThrowOnError extends boolean = false>(
  options: Options<OntologyExecuteViewData, ThrowOnError>,
) => {
  return (options.client ?? client).post<
    OntologyExecuteViewResponses,
    OntologyExecuteViewErrors,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/api/ontology/lakehouse/views/{view_id}/execute",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });
};

/**
 * Test Query
 *
 * Test a SQL query for validity before saving as a view.
 *
 * Returns validation status and sample results if valid.
 */
export const ontologyTestQuery = <ThrowOnError extends boolean = false>(
  options: Options<OntologyTestQueryData, ThrowOnError>,
) => {
  return (options.client ?? client).post<
    OntologyTestQueryResponses,
    OntologyTestQueryErrors,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/api/ontology/lakehouse/views/test-query",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });
};

/**
 * Create Iceberg Data Source
 *
 * Create a data source from an existing Iceberg table.
 *
 * The Iceberg table must already exist in the lakehouse.
 */
export const ontologyCreateIcebergDataSource = <
  ThrowOnError extends boolean = false,
>(
  options: Options<OntologyCreateIcebergDataSourceData, ThrowOnError>,
) => {
  return (options.client ?? client).post<
    OntologyCreateIcebergDataSourceResponses,
    OntologyCreateIcebergDataSourceErrors,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/api/ontology/lakehouse/data-sources/iceberg",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });
};

/**
 * Create Foreign Data Source
 *
 * Create a data source from a foreign database table.
 *
 * Requires an existing foreign connection to be configured.
 */
export const ontologyCreateForeignDataSource = <
  ThrowOnError extends boolean = false,
>(
  options: Options<OntologyCreateForeignDataSourceData, ThrowOnError>,
) => {
  return (options.client ?? client).post<
    OntologyCreateForeignDataSourceResponses,
    OntologyCreateForeignDataSourceErrors,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/api/ontology/lakehouse/data-sources/foreign",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });
};

/**
 * Create Composite Data Source
 *
 * Create a composite data source from multiple sources.
 *
 * The composite definition should be a SQL SELECT statement that
 * joins or combines data from multiple data sources.
 */
export const ontologyCreateCompositeDataSource = <
  ThrowOnError extends boolean = false,
>(
  options: Options<OntologyCreateCompositeDataSourceData, ThrowOnError>,
) => {
  return (options.client ?? client).post<
    OntologyCreateCompositeDataSourceResponses,
    OntologyCreateCompositeDataSourceErrors,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/api/ontology/lakehouse/data-sources/composite",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });
};

/**
 * List Data Sources
 *
 * List all data sources for the organization.
 *
 * Supports filtering by source type and searching by name.
 */
export const ontologyListDataSources = <ThrowOnError extends boolean = false>(
  options: Options<OntologyListDataSourcesData, ThrowOnError>,
) => {
  return (options.client ?? client).get<
    OntologyListDataSourcesResponses,
    OntologyListDataSourcesErrors,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/api/ontology/lakehouse/data-sources/",
    ...options,
  });
};

/**
 * Delete Data Source
 *
 * Delete a data source.
 *
 * Will fail if the data source is referenced by semantic objects
 * or other composite data sources.
 */
export const ontologyDeleteDataSource = <ThrowOnError extends boolean = false>(
  options: Options<OntologyDeleteDataSourceData, ThrowOnError>,
) => {
  return (options.client ?? client).delete<
    OntologyDeleteDataSourceResponses,
    OntologyDeleteDataSourceErrors,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/api/ontology/lakehouse/data-sources/{data_source_id}",
    ...options,
  });
};

/**
 * Get Data Source
 *
 * Get a single data source with detailed information.
 */
export const ontologyGetDataSource = <ThrowOnError extends boolean = false>(
  options: Options<OntologyGetDataSourceData, ThrowOnError>,
) => {
  return (options.client ?? client).get<
    OntologyGetDataSourceResponses,
    OntologyGetDataSourceErrors,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/api/ontology/lakehouse/data-sources/{data_source_id}",
    ...options,
  });
};

/**
 * Update Data Source
 *
 * Update an existing data source.
 *
 * Only name can be updated for all types.
 * Composite sources can also update definition and dependencies.
 */
export const ontologyUpdateDataSource = <ThrowOnError extends boolean = false>(
  options: Options<OntologyUpdateDataSourceData, ThrowOnError>,
) => {
  return (options.client ?? client).patch<
    OntologyUpdateDataSourceResponses,
    OntologyUpdateDataSourceErrors,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/api/ontology/lakehouse/data-sources/{data_source_id}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });
};

/**
 * Get Data Source By Name
 *
 * Get a data source by its name.
 */
export const ontologyGetDataSourceByName = <
  ThrowOnError extends boolean = false,
>(
  options: Options<OntologyGetDataSourceByNameData, ThrowOnError>,
) => {
  return (options.client ?? client).get<
    OntologyGetDataSourceByNameResponses,
    OntologyGetDataSourceByNameErrors,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/api/ontology/lakehouse/data-sources/by-name/{name}",
    ...options,
  });
};

/**
 * Check Schema Drift
 *
 * Check for schema drift in a data source.
 *
 * Compares the stored schema snapshot with the current live schema
 * and reports any differences (added, removed, or modified columns).
 */
export const ontologyCheckSchemaDrift = <ThrowOnError extends boolean = false>(
  options: Options<OntologyCheckSchemaDriftData, ThrowOnError>,
) => {
  return (options.client ?? client).post<
    OntologyCheckSchemaDriftResponses,
    OntologyCheckSchemaDriftErrors,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/api/ontology/lakehouse/data-sources/{data_source_id}/check-drift",
    ...options,
  });
};

/**
 * Sync Schema
 *
 * Sync schema from the live source.
 *
 * Updates the stored schema snapshot to match the current live schema.
 * Returns information about any drift detected during the sync.
 */
export const ontologySyncSchema = <ThrowOnError extends boolean = false>(
  options: Options<OntologySyncSchemaData, ThrowOnError>,
) => {
  return (options.client ?? client).post<
    OntologySyncSchemaResponses,
    OntologySyncSchemaErrors,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/api/ontology/lakehouse/data-sources/{data_source_id}/sync-schema",
    ...options,
  });
};

/**
 * Get Query Reference
 *
 * Get the SQL reference string for a data source.
 *
 * Returns the string that should be used in SQL queries to reference
 * this data source (e.g., 'namespace.table' for Iceberg,
 * 'foreign.connection.schema.table' for foreign sources).
 */
export const ontologyGetQueryReference = <ThrowOnError extends boolean = false>(
  options: Options<OntologyGetQueryReferenceData, ThrowOnError>,
) => {
  return (options.client ?? client).get<
    OntologyGetQueryReferenceResponses,
    OntologyGetQueryReferenceErrors,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/api/ontology/lakehouse/data-sources/{data_source_id}/query-reference",
    ...options,
  });
};

/**
 * List By Iceberg Table
 *
 * Find all data sources that reference an Iceberg table.
 */
export const ontologyListByIcebergTable = <
  ThrowOnError extends boolean = false,
>(
  options: Options<OntologyListByIcebergTableData, ThrowOnError>,
) => {
  return (options.client ?? client).get<
    OntologyListByIcebergTableResponses,
    OntologyListByIcebergTableErrors,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/api/ontology/lakehouse/data-sources/by-iceberg-table/{iceberg_table_id}",
    ...options,
  });
};

/**
 * List By Foreign Connection
 *
 * Find all data sources that reference a foreign connection.
 */
export const ontologyListByForeignConnection = <
  ThrowOnError extends boolean = false,
>(
  options: Options<OntologyListByForeignConnectionData, ThrowOnError>,
) => {
  return (options.client ?? client).get<
    OntologyListByForeignConnectionResponses,
    OntologyListByForeignConnectionErrors,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/api/ontology/lakehouse/data-sources/by-foreign-connection/{foreign_connection_id}",
    ...options,
  });
};

/**
 * Test API connection
 *
 * Test an API connection without saving it. Validates credentials, endpoint, and returns sample data.
 */
export const ontologyTestApiConnection = <ThrowOnError extends boolean = false>(
  options: Options<OntologyTestApiConnectionData, ThrowOnError>,
) => {
  return (options.client ?? client).post<
    OntologyTestApiConnectionResponses,
    OntologyTestApiConnectionErrors,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/api/ontology/lakehouse/api-integrations/test",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });
};

/**
 * Discover API schema
 *
 * Discover the schema of an API endpoint by fetching sample data and analyzing the structure.
 */
export const ontologyDiscoverApiSchema = <ThrowOnError extends boolean = false>(
  options: Options<OntologyDiscoverApiSchemaData, ThrowOnError>,
) => {
  return (options.client ?? client).post<
    OntologyDiscoverApiSchemaResponses,
    OntologyDiscoverApiSchemaErrors,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/api/ontology/lakehouse/api-integrations/discover",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });
};

/**
 * List API connections
 *
 * List all API connections for an organization.
 */
export const ontologyListApiConnections = <
  ThrowOnError extends boolean = false,
>(
  options: Options<OntologyListApiConnectionsData, ThrowOnError>,
) => {
  return (options.client ?? client).get<
    OntologyListApiConnectionsResponses,
    OntologyListApiConnectionsErrors,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/api/ontology/lakehouse/api-integrations/connections",
    ...options,
  });
};

/**
 * Create API connection
 *
 * Create a new API connection for syncing data to an Iceberg table.
 */
export const ontologyCreateApiConnection = <
  ThrowOnError extends boolean = false,
>(
  options: Options<OntologyCreateApiConnectionData, ThrowOnError>,
) => {
  return (options.client ?? client).post<
    OntologyCreateApiConnectionResponses,
    OntologyCreateApiConnectionErrors,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/api/ontology/lakehouse/api-integrations/connections",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });
};

/**
 * Delete API connection
 *
 * Delete an API connection. Associated tables remain but lose their connection reference.
 */
export const ontologyDeleteApiConnection = <
  ThrowOnError extends boolean = false,
>(
  options: Options<OntologyDeleteApiConnectionData, ThrowOnError>,
) => {
  return (options.client ?? client).delete<
    OntologyDeleteApiConnectionResponses,
    OntologyDeleteApiConnectionErrors,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/api/ontology/lakehouse/api-integrations/connections/{connection_id}",
    ...options,
  });
};

/**
 * Get API connection
 *
 * Get details of an API connection including created tables.
 */
export const ontologyGetApiConnection = <ThrowOnError extends boolean = false>(
  options: Options<OntologyGetApiConnectionData, ThrowOnError>,
) => {
  return (options.client ?? client).get<
    OntologyGetApiConnectionResponses,
    OntologyGetApiConnectionErrors,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/api/ontology/lakehouse/api-integrations/connections/{connection_id}",
    ...options,
  });
};

/**
 * Update API connection
 *
 * Update an existing API connection.
 */
export const ontologyUpdateApiConnection = <
  ThrowOnError extends boolean = false,
>(
  options: Options<OntologyUpdateApiConnectionData, ThrowOnError>,
) => {
  return (options.client ?? client).put<
    OntologyUpdateApiConnectionResponses,
    OntologyUpdateApiConnectionErrors,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/api/ontology/lakehouse/api-integrations/connections/{connection_id}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });
};

/**
 * Sync API connection
 *
 * Start a sync job for an API connection. Returns a job_id for tracking progress.
 */
export const ontologySyncApiConnection = <ThrowOnError extends boolean = false>(
  options: Options<OntologySyncApiConnectionData, ThrowOnError>,
) => {
  return (options.client ?? client).post<
    OntologySyncApiConnectionResponses,
    OntologySyncApiConnectionErrors,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/api/ontology/lakehouse/api-integrations/connections/{connection_id}/sync",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });
};

/**
 * Test existing connection
 *
 * Test an existing API connection to verify it's still working.
 */
export const ontologyTestExistingApiConnection = <
  ThrowOnError extends boolean = false,
>(
  options: Options<OntologyTestExistingApiConnectionData, ThrowOnError>,
) => {
  return (options.client ?? client).post<
    OntologyTestExistingApiConnectionResponses,
    OntologyTestExistingApiConnectionErrors,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/api/ontology/lakehouse/api-integrations/connections/{connection_id}/test",
    ...options,
  });
};

/**
 * Upload files to lakehouse storage
 *
 * Upload files (CSV, Excel, JSON, Parquet) to lakehouse storage area.
 * Files are stored in the /raw/ directory for later processing.
 *
 * Args:
 * file: File to upload
 * org_id: Organization ID
 *
 * Returns:
 * Upload result with file location and metadata
 */
export const ontologyUploadFile = <ThrowOnError extends boolean = false>(
  options: Options<OntologyUploadFileData, ThrowOnError>,
) => {
  return (options.client ?? client).post<
    OntologyUploadFileResponses,
    OntologyUploadFileErrors,
    ThrowOnError
  >({
    ...formDataBodySerializer,
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/api/ontology/lakehouse/upload",
    ...options,
    headers: {
      "Content-Type": null,
      ...options.headers,
    },
  });
};

/**
 * Create upload session for resumable upload
 *
 * Create a new upload session.
 *
 * Returns a session ID and GCS resumable upload URL(s) for direct
 * client-to-GCS uploads. In local dev mode, use the local-upload endpoint.
 *
 * Args:
 * request: Upload session creation parameters
 * raw_request: FastAPI Request to extract Origin header for GCS CORS
 *
 * Returns:
 * Upload session details with resumable upload URLs
 */
export const createUploadSession = <ThrowOnError extends boolean = false>(
  options: Options<CreateUploadSessionData, ThrowOnError>,
) => {
  return (options.client ?? client).post<
    CreateUploadSessionResponses,
    CreateUploadSessionErrors,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/api/ontology/lakehouse/upload-session",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });
};

/**
 * Complete upload session
 *
 * Complete an upload session.
 *
 * Verifies the file exists (GCS blob or local file), then triggers
 * background processing. Returns immediately with a job ID.
 *
 * Args:
 * session_id: Upload session ID
 * request: Completion parameters including optional checksum
 * background_tasks: FastAPI background tasks
 *
 * Returns:
 * Completion status with job ID for tracking processing
 */
export const completeUpload = <ThrowOnError extends boolean = false>(
  options: Options<CompleteUploadData, ThrowOnError>,
) => {
  return (options.client ?? client).post<
    CompleteUploadResponses,
    CompleteUploadErrors,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/api/ontology/lakehouse/upload-complete/{session_id}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });
};

/**
 * Cancel upload session
 *
 * Cancel an upload session and optionally cleanup GCS blobs.
 *
 * Args:
 * session_id: Upload session ID to cancel
 * cleanup: Whether to delete uploaded blobs (default: true)
 *
 * Returns:
 * Cancellation confirmation with cleanup details
 */
export const cancelUploadSession = <ThrowOnError extends boolean = false>(
  options: Options<CancelUploadSessionData, ThrowOnError>,
) => {
  return (options.client ?? client).delete<
    CancelUploadSessionResponses,
    CancelUploadSessionErrors,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/api/ontology/lakehouse/upload-session/{session_id}",
    ...options,
  });
};

/**
 * Infer schema from preview file
 *
 * Infer schema from the uploaded preview file.
 *
 * Call this endpoint after the client has finished uploading the preview
 * slice (either to GCS via the resumable URL or locally). The system will
 * analyze the data and return an inferred schema for user review.
 *
 * The session will transition to 'schema_review' phase after this call.
 *
 * Args:
 * session_id: Upload session ID
 * request: Schema inference parameters (sample_rows, date_formats, encoding)
 *
 * Returns:
 * Inferred schema with sample data and recommendations
 */
export const inferSchemaFromPreview = <ThrowOnError extends boolean = false>(
  options: Options<InferSchemaFromPreviewData, ThrowOnError>,
) => {
  return (options.client ?? client).post<
    InferSchemaFromPreviewResponses,
    InferSchemaFromPreviewErrors,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/api/ontology/lakehouse/upload-session/{session_id}/infer-schema",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });
};

/**
 * Approve schema and continue upload
 *
 * Approve the inferred schema (with optional modifications) and continue upload.
 *
 * After reviewing the inferred schema, call this endpoint to approve it
 * (with any modifications). The session transitions to 'full_upload' phase
 * and returns a resumable upload URL for the full file. A background job
 * is created immediately so the UI can navigate to job tracking.
 *
 * Args:
 * session_id: Upload session ID
 * request: Approved schema with table configuration
 * raw_request: FastAPI Request to extract Origin header for GCS CORS
 *
 * Returns:
 * Resumable upload URL for full file and job ID for tracking
 */
export const approveSchema = <ThrowOnError extends boolean = false>(
  options: Options<ApproveSchemaData, ThrowOnError>,
) => {
  return (options.client ?? client).post<
    ApproveSchemaResponses,
    ApproveSchemaErrors,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/api/ontology/lakehouse/upload-session/{session_id}/approve-schema",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });
};

/**
 * Analyze schema alignment with target table
 *
 * Analyze schema alignment between the uploaded file and a target table.
 *
 * Use this endpoint in the ETL Builder when the user selects an existing table
 * as the destination. It compares the inferred schema from the uploaded file
 * with the target table's schema and returns detailed mapping information.
 *
 * The response includes:
 * - Perfect matches (same name and type)
 * - Castable matches (same name, compatible types)
 * - Fuzzy name matches (similar names)
 * - Type conflicts (incompatible types)
 * - Extra columns (in source but not target)
 * - Missing columns (in target but not source)
 *
 * Args:
 * session_id: Upload session ID (must have completed schema inference)
 * request: Target table specification
 *
 * Returns:
 * Detailed schema alignment analysis with recommendations
 */
export const analyzeSessionSchemaAlignment = <
  ThrowOnError extends boolean = false,
>(
  options: Options<AnalyzeSessionSchemaAlignmentData, ThrowOnError>,
) => {
  return (options.client ?? client).post<
    AnalyzeSessionSchemaAlignmentResponses,
    AnalyzeSessionSchemaAlignmentErrors,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/api/ontology/lakehouse/upload-session/{session_id}/analyze-alignment",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });
};

/**
 * Get upload session status
 *
 * Get the current status of an upload session.
 *
 * Args:
 * session_id: Upload session ID
 *
 * Returns:
 * Session status including phase, storage backend, and GCS paths
 */
export const getUploadSessionStatus = <ThrowOnError extends boolean = false>(
  options: Options<GetUploadSessionStatusData, ThrowOnError>,
) => {
  return (options.client ?? client).get<
    GetUploadSessionStatusResponses,
    GetUploadSessionStatusErrors,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/api/ontology/lakehouse/upload-session/{session_id}/status",
    ...options,
  });
};

/**
 * Upload file locally (development only)
 *
 * Upload a file directly to the backend (local development only).
 *
 * This endpoint is only available when the storage backend is 'local'.
 * In GCS mode, clients upload directly to GCS via resumable upload URLs.
 *
 * Args:
 * session_id: Upload session ID
 * file: The file to upload
 *
 * Returns:
 * Confirmation with stored file path
 */
export const localUpload = <ThrowOnError extends boolean = false>(
  options: Options<LocalUploadData, ThrowOnError>,
) => {
  return (options.client ?? client).post<
    LocalUploadResponses,
    LocalUploadErrors,
    ThrowOnError
  >({
    ...formDataBodySerializer,
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/api/ontology/lakehouse/upload-session/{session_id}/local-upload",
    ...options,
    headers: {
      "Content-Type": null,
      ...options.headers,
    },
  });
};

/**
 * Programmatic file ingest with schema mapping
 *
 * Programmatically ingest a file with schema mapping configuration.
 *
 * This endpoint is designed for external systems that need to upload data
 * with specific schema mappings and type casts. It supports both:
 *
 * 1. **Direct upload (small files < 50MB)**: Include the file in the request
 * 2. **Resumable upload (large files)**: Set chunked=True, then use the returned
 * resumable URL to upload directly to GCS, then call /upload-complete
 *
 * Schema mapping allows you to:
 * - Rename columns: {"source_col": "target_col"}
 * - Cast types: {"column": "double"} or {"column": {"type": "timestamp", "format": "YYYY-MM-DD"}}
 *
 * Args:
 * request: Ingest configuration including schema mapping
 * file: File to ingest (required if not using resumable upload)
 *
 * Returns:
 * Job ID (for direct upload) or session ID (for resumable upload)
 */
export const programmaticIngest = <ThrowOnError extends boolean = false>(
  options: Options<ProgrammaticIngestData, ThrowOnError>,
) => {
  return (options.client ?? client).post<
    ProgrammaticIngestResponses,
    ProgrammaticIngestErrors,
    ThrowOnError
  >({
    ...formDataBodySerializer,
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/api/ontology/lakehouse/programmatic-ingest",
    ...options,
    headers: {
      "Content-Type": null,
      ...options.headers,
    },
  });
};

/**
 * Get job status
 *
 * Get the status of a background job.
 *
 * Use this to track progress of file processing jobs started by complete_upload.
 *
 * Args:
 * job_id: Job identifier from complete_upload response
 *
 * Returns:
 * Job status with progress information
 */
export const getJobStatus = <ThrowOnError extends boolean = false>(
  options: Options<GetJobStatusData, ThrowOnError>,
) => {
  return (options.client ?? client).get<
    GetJobStatusResponses,
    GetJobStatusErrors,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/api/ontology/lakehouse/job-status/{job_id}",
    ...options,
  });
};

/**
 * Analyze schema alignment for appending data
 *
 * Analyze schema compatibility between an uploaded file and an existing table.
 *
 * This endpoint helps users understand if their data can be appended to an existing
 * table, and provides detailed information about:
 * - Perfect column matches (name and type)
 * - Columns that need type casting
 * - Fuzzy name matches (similar column names)
 * - Type conflicts that need resolution
 * - Extra columns that could extend the schema
 * - Missing columns that will be filled with nulls
 *
 * The analysis includes an alignment score and actionable recommendations for
 * successfully appending the data.
 *
 * Args:
 * file: File to analyze (CSV, Excel, Parquet, JSON)
 * org_id: Organization ID
 * namespace: Target namespace
 * table_name: Target table name
 * fuzzy_match_threshold: Similarity threshold for fuzzy matching (0-1)
 *
 * Returns:
 * Detailed schema alignment analysis with recommendations
 */
export const analyzeSchemaAlignment = <ThrowOnError extends boolean = false>(
  options: Options<AnalyzeSchemaAlignmentData, ThrowOnError>,
) => {
  return (options.client ?? client).post<
    AnalyzeSchemaAlignmentResponses,
    AnalyzeSchemaAlignmentErrors,
    ThrowOnError
  >({
    ...formDataBodySerializer,
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/api/ontology/lakehouse/analyze-schema-alignment",
    ...options,
    headers: {
      "Content-Type": null,
      ...options.headers,
    },
  });
};

/**
 * Get all namespaces for organization
 *
 * Get all namespaces for an organization.
 */
export const ontologyGetNamespaces = <ThrowOnError extends boolean = false>(
  options: Options<OntologyGetNamespacesData, ThrowOnError>,
) => {
  return (options.client ?? client).get<
    OntologyGetNamespacesResponses,
    OntologyGetNamespacesErrors,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/api/ontology/lakehouse/namespaces",
    ...options,
  });
};

/**
 * Create a new namespace
 *
 * Create a new namespace for organizing tables.
 */
export const ontologyCreateNamespace = <ThrowOnError extends boolean = false>(
  options: Options<OntologyCreateNamespaceData, ThrowOnError>,
) => {
  return (options.client ?? client).post<
    OntologyCreateNamespaceResponses,
    OntologyCreateNamespaceErrors,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/api/ontology/lakehouse/namespaces",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });
};

/**
 * Delete namespace
 *
 * Delete a namespace.
 */
export const ontologyDeleteNamespace = <ThrowOnError extends boolean = false>(
  options: Options<OntologyDeleteNamespaceData, ThrowOnError>,
) => {
  return (options.client ?? client).delete<
    OntologyDeleteNamespaceResponses,
    OntologyDeleteNamespaceErrors,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/api/ontology/lakehouse/namespaces/{namespace_id}",
    ...options,
  });
};

/**
 * Get namespace by ID
 *
 * Get a namespace by ID.
 */
export const ontologyGetNamespace = <ThrowOnError extends boolean = false>(
  options: Options<OntologyGetNamespaceData, ThrowOnError>,
) => {
  return (options.client ?? client).get<
    OntologyGetNamespaceResponses,
    OntologyGetNamespaceErrors,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/api/ontology/lakehouse/namespaces/{namespace_id}",
    ...options,
  });
};

/**
 * Update namespace
 *
 * Update a namespace.
 */
export const ontologyUpdateNamespace = <ThrowOnError extends boolean = false>(
  options: Options<OntologyUpdateNamespaceData, ThrowOnError>,
) => {
  return (options.client ?? client).put<
    OntologyUpdateNamespaceResponses,
    OntologyUpdateNamespaceErrors,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/api/ontology/lakehouse/namespaces/{namespace_id}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });
};

/**
 * Get lakehouse statistics and metrics
 *
 * Get comprehensive lakehouse statistics including tables, data volume,
 * active migrations, queries, and recent activity.
 *
 * Args:
 * org_id: Organization ID
 *
 * Returns:
 * Lakehouse statistics and metrics
 */
export const ontologyGetLakehouseStats = <ThrowOnError extends boolean = false>(
  options: Options<OntologyGetLakehouseStatsData, ThrowOnError>,
) => {
  return (options.client ?? client).get<
    OntologyGetLakehouseStatsResponses,
    OntologyGetLakehouseStatsErrors,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/api/ontology/lakehouse/stats",
    ...options,
  });
};

/**
 * Convert files to Iceberg tables
 *
 * Convert uploaded files to Iceberg tables.
 * This process includes schema inference, data validation, and table creation.
 *
 * Args:
 * table_name: Name for the resulting Iceberg table
 * request: Ingestion configuration and file information
 *
 * Returns:
 * Created table information
 */
export const ontologyIngestFileToTable = <ThrowOnError extends boolean = false>(
  options: Options<OntologyIngestFileToTableData, ThrowOnError>,
) => {
  return (options.client ?? client).post<
    OntologyIngestFileToTableResponses,
    OntologyIngestFileToTableErrors,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/api/ontology/lakehouse/ingest/{table_name}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });
};

/**
 * Append data to existing Iceberg table
 *
 * Append new data to an existing Iceberg table with schema evolution support.
 * This process handles schema compatibility validation and automatic column addition.
 *
 * Args:
 * table_name: Name of the existing Iceberg table
 * request: Append configuration and file information
 *
 * Returns:
 * Append operation result with row counts and schema changes
 */
export const ontologyAppendFileToTable = <ThrowOnError extends boolean = false>(
  options: Options<OntologyAppendFileToTableData, ThrowOnError>,
) => {
  return (options.client ?? client).post<
    OntologyAppendFileToTableResponses,
    OntologyAppendFileToTableErrors,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/api/ontology/lakehouse/append/{table_name}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });
};

/**
 * Sync from external databases
 *
 * Sync data from external databases (PostgreSQL, MySQL, MongoDB) with CDC support.
 *
 * Args:
 * request: Database sync configuration
 *
 * Returns:
 * Sync job information
 */
export const ontologySyncFromDatabase = <ThrowOnError extends boolean = false>(
  options?: Options<OntologySyncFromDatabaseData, ThrowOnError>,
) => {
  return (options?.client ?? client).post<
    OntologySyncFromDatabaseResponses,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/api/ontology/lakehouse/sync/database",
    ...options,
  });
};

/**
 * Sync from REST APIs
 *
 * Sync data from REST APIs with OAuth, pagination, and rate limiting.
 *
 * Args:
 * request: API sync configuration
 *
 * Returns:
 * Sync job information
 */
export const ontologySyncFromApi = <ThrowOnError extends boolean = false>(
  options?: Options<OntologySyncFromApiData, ThrowOnError>,
) => {
  return (options?.client ?? client).post<
    OntologySyncFromApiResponses,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/api/ontology/lakehouse/sync/api",
    ...options,
  });
};

/**
 * List all Iceberg tables
 *
 * List all Iceberg tables, optionally filtered by namespace.
 *
 * Args:
 * namespace: Optional namespace filter
 * org_id: Optional organization filter
 *
 * Returns:
 * List of table information
 */
export const ontologyListTables = <ThrowOnError extends boolean = false>(
  options?: Options<OntologyListTablesData, ThrowOnError>,
) => {
  return (options?.client ?? client).get<
    OntologyListTablesResponses,
    OntologyListTablesErrors,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/api/ontology/lakehouse/tables",
    ...options,
  });
};

/**
 * Drop table and cleanup
 *
 * Drop an Iceberg table and clean up associated storage.
 *
 * Args:
 * table_id: Table identifier
 *
 * Returns:
 * Deletion confirmation
 */
export const ontologyDropTable = <ThrowOnError extends boolean = false>(
  options: Options<OntologyDropTableData, ThrowOnError>,
) => {
  return (options.client ?? client).delete<
    OntologyDropTableResponses,
    OntologyDropTableErrors,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/api/ontology/lakehouse/tables/{table_id}",
    ...options,
  });
};

/**
 * Get table details and schema
 *
 * Get detailed information about an Iceberg table including schema.
 *
 * Args:
 * table_id: Table identifier
 *
 * Returns:
 * Detailed table information
 */
export const ontologyGetTableDetails = <ThrowOnError extends boolean = false>(
  options: Options<OntologyGetTableDetailsData, ThrowOnError>,
) => {
  return (options.client ?? client).get<
    OntologyGetTableDetailsResponses,
    OntologyGetTableDetailsErrors,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/api/ontology/lakehouse/tables/{table_id}",
    ...options,
  });
};

/**
 * Embed table text columns for semantic search
 *
 * Trigger embedding of text columns in a lakehouse table for RAG search.
 *
 * Runs as a dedicated background job. Auto-detects text-heavy columns
 * if text_columns is not specified.
 */
export const ontologyEmbedTable = <ThrowOnError extends boolean = false>(
  options: Options<OntologyEmbedTableData, ThrowOnError>,
) => {
  return (options.client ?? client).post<
    OntologyEmbedTableResponses,
    OntologyEmbedTableErrors,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/api/ontology/lakehouse/tables/{table_id}/embed",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });
};

/**
 * Get embedding status for a table
 *
 * Get the current embedding status, config, and row count for a table.
 */
export const ontologyGetEmbeddingStatus = <
  ThrowOnError extends boolean = false,
>(
  options: Options<OntologyGetEmbeddingStatusData, ThrowOnError>,
) => {
  return (options.client ?? client).get<
    OntologyGetEmbeddingStatusResponses,
    OntologyGetEmbeddingStatusErrors,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/api/ontology/lakehouse/tables/{table_id}/embedding-status",
    ...options,
  });
};

/**
 * Check tables schema health
 *
 * Check health status of tables and identify those with missing or invalid schemas.
 *
 * This diagnostic endpoint helps you identify tables that need schema synchronization
 * without making any modifications. It analyzes all tables and reports:
 * - Total number of tables
 * - Number of healthy tables (with valid schemas)
 * - Number of tables with schema issues
 * - Detailed list of tables that need sync with their IDs
 *
 * Use this endpoint to:
 * - Monitor schema health across your lakehouse
 * - Identify tables that need synchronization after migrations
 * - Audit schema consistency
 *
 * Once you identify tables with issues, use POST /lakehouse/tables/{table_id}/sync
 * to fix each affected table.
 *
 * Args:
 * namespace: Optional namespace filter to check specific namespace
 * org_id: Optional organization filter to check specific org
 *
 * Returns:
 * Health report with status, counts, and list of affected tables
 */
export const ontologyGetTablesHealth = <ThrowOnError extends boolean = false>(
  options?: Options<OntologyGetTablesHealthData, ThrowOnError>,
) => {
  return (options?.client ?? client).get<
    OntologyGetTablesHealthResponses,
    OntologyGetTablesHealthErrors,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/api/ontology/lakehouse/tables/health",
    ...options,
  });
};

/**
 * Sync table metadata from Iceberg
 *
 * Sync table metadata from the actual Iceberg table to the database.
 *
 * This endpoint reads the current state of the Iceberg table (row count,
 * file size, schema) and updates the database record to match. Useful for:
 * - Fixing metadata drift
 * - Recovering from failed updates
 * - Manual inspection and refresh
 * - Recovering missing schema_info
 *
 * The sync process:
 * 1. Fetches the table record from database
 * 2. Loads the actual Iceberg table from catalog
 * 3. Extracts current schema, row count, and file size
 * 4. Updates the database with synced metadata
 * 5. Returns detailed sync results
 *
 * Args:
 * table_id: Table identifier (UUID)
 *
 * Returns:
 * Updated metadata information including:
 * - Synced metadata (row count, size, schema fields)
 * - Previous state comparison
 * - Detailed sync status
 *
 * Raises:
 * 404: If table not found
 * 500: If catalog load fails or schema extraction fails
 */
export const ontologySyncTableMetadata = <ThrowOnError extends boolean = false>(
  options: Options<OntologySyncTableMetadataData, ThrowOnError>,
) => {
  return (options.client ?? client).post<
    OntologySyncTableMetadataResponses,
    OntologySyncTableMetadataErrors,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/api/ontology/lakehouse/tables/{table_id}/sync",
    ...options,
  });
};

/**
 * Evolve table schema
 *
 * Evolve table schema with backward compatibility checks.
 *
 * Args:
 * table_id: Table identifier
 * request: Schema evolution specification
 *
 * Returns:
 * Updated table information
 */
export const ontologyEvolveTableSchema = <ThrowOnError extends boolean = false>(
  options: Options<OntologyEvolveTableSchemaData, ThrowOnError>,
) => {
  return (options.client ?? client).put<
    OntologyEvolveTableSchemaResponses,
    OntologyEvolveTableSchemaErrors,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/api/ontology/lakehouse/tables/{table_id}/schema",
    ...options,
  });
};

/**
 * Table version history
 *
 * Get version history and snapshots for an Iceberg table.
 *
 * Args:
 * table_id: Table identifier
 *
 * Returns:
 * Table version history
 */
export const ontologyGetTableHistory = <ThrowOnError extends boolean = false>(
  options: Options<OntologyGetTableHistoryData, ThrowOnError>,
) => {
  return (options.client ?? client).get<
    OntologyGetTableHistoryResponses,
    OntologyGetTableHistoryErrors,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/api/ontology/lakehouse/tables/{table_id}/history",
    ...options,
  });
};

/**
 * Execute SQL query
 *
 * Execute SQL query against Iceberg tables using DuckDB.
 *
 * Args:
 * request: Query request with SQL and parameters
 *
 * Returns:
 * Query results with metadata
 */
export const ontologyExecuteSqlQuery = <ThrowOnError extends boolean = false>(
  options: Options<OntologyExecuteSqlQueryData, ThrowOnError>,
) => {
  return (options.client ?? client).post<
    OntologyExecuteSqlQueryResponses,
    OntologyExecuteSqlQueryErrors,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/api/ontology/lakehouse/query/sql",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });
};

/**
 * Natural language query
 *
 * Execute natural language query with LLM-powered SQL translation.
 *
 * Args:
 * request: Natural language query request
 *
 * Returns:
 * Query results with SQL translation
 */
export const ontologyExecuteNaturalQuery = <
  ThrowOnError extends boolean = false,
>(
  options: Options<OntologyExecuteNaturalQueryData, ThrowOnError>,
) => {
  return (options.client ?? client).post<
    OntologyExecuteNaturalQueryResponses,
    OntologyExecuteNaturalQueryErrors,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/api/ontology/lakehouse/query/natural",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });
};

/**
 * Query history
 *
 * Get query execution history.
 *
 * Args:
 * limit: Maximum number of queries to return
 *
 * Returns:
 * Query history with performance metrics
 */
export const ontologyGetQueryHistory = <ThrowOnError extends boolean = false>(
  options?: Options<OntologyGetQueryHistoryData, ThrowOnError>,
) => {
  return (options?.client ?? client).get<
    OntologyGetQueryHistoryResponses,
    OntologyGetQueryHistoryErrors,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/api/ontology/lakehouse/query/history",
    ...options,
  });
};

/**
 * Query execution plan
 *
 * Get query execution plan without running the query.
 *
 * Args:
 * request: Query request
 *
 * Returns:
 * Query execution plan
 */
export const ontologyExplainQuery = <ThrowOnError extends boolean = false>(
  options: Options<OntologyExplainQueryData, ThrowOnError>,
) => {
  return (options.client ?? client).post<
    OntologyExplainQueryResponses,
    OntologyExplainQueryErrors,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/api/ontology/lakehouse/query/explain",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });
};

/**
 * AI-powered single table object discovery
 *
 * Discover semantic objects from data tables using AI.
 *
 * Args:
 * request: Discovery configuration
 *
 * Returns:
 * Discovered semantic objects
 */
export const ontologyDiscoverSemanticObjectsSingleTable = <
  ThrowOnError extends boolean = false,
>(
  options: Options<
    OntologyDiscoverSemanticObjectsSingleTableData,
    ThrowOnError
  >,
) => {
  return (options.client ?? client).post<
    OntologyDiscoverSemanticObjectsSingleTableResponses,
    OntologyDiscoverSemanticObjectsSingleTableErrors,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/api/ontology/lakehouse/semantic/discover-table",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });
};

/**
 * Semantic object discovery - supports single table, namespace-wide, and data source discovery
 *
 * Unified semantic discovery endpoint that can handle:
 * - table_id: Single Iceberg table discovery (legacy)
 * - namespace: Namespace-wide discovery
 * - data_source_id: Unified data source discovery (Iceberg, Foreign, Composite)
 */
export const ontologyDiscoverSemanticObjectsUnified = <
  ThrowOnError extends boolean = false,
>(
  options: Options<OntologyDiscoverSemanticObjectsUnifiedData, ThrowOnError>,
) => {
  return (options.client ?? client).post<
    OntologyDiscoverSemanticObjectsUnifiedResponses,
    OntologyDiscoverSemanticObjectsUnifiedErrors,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/api/ontology/lakehouse/semantic/discover",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });
};

/**
 * List semantic objects
 *
 * List all semantic objects for the organization.
 *
 * Args:
 * org_id: Organization ID
 * object_type: Optional filter by object type
 *
 * Returns:
 * List of semantic objects
 */
export const ontologyListSemanticObjects = <
  ThrowOnError extends boolean = false,
>(
  options: Options<OntologyListSemanticObjectsData, ThrowOnError>,
) => {
  return (options.client ?? client).get<
    OntologyListSemanticObjectsResponses,
    OntologyListSemanticObjectsErrors,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/api/ontology/lakehouse/semantic/objects",
    ...options,
  });
};

/**
 * Create semantic object
 *
 * Create a new semantic object with view definition.
 *
 * Args:
 * request: Semantic object specification
 *
 * Returns:
 * Created semantic object
 */
export const ontologyCreateSemanticObject = <
  ThrowOnError extends boolean = false,
>(
  options: Options<OntologyCreateSemanticObjectData, ThrowOnError>,
) => {
  return (options.client ?? client).post<
    OntologyCreateSemanticObjectResponses,
    OntologyCreateSemanticObjectErrors,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/api/ontology/lakehouse/semantic/objects",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });
};

/**
 * Delete semantic object
 *
 * Delete a semantic object.
 *
 * Args:
 * object_id: Semantic object identifier
 * org_id: Organization ID
 *
 * Returns:
 * Deletion confirmation
 */
export const ontologyDeleteSemanticObject = <
  ThrowOnError extends boolean = false,
>(
  options: Options<OntologyDeleteSemanticObjectData, ThrowOnError>,
) => {
  return (options.client ?? client).delete<
    OntologyDeleteSemanticObjectResponses,
    OntologyDeleteSemanticObjectErrors,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/api/ontology/lakehouse/semantic/objects/{object_id}",
    ...options,
  });
};

/**
 * Update semantic object
 *
 * Update an existing semantic object.
 *
 * Args:
 * object_id: Semantic object identifier
 * request: Update specification
 *
 * Returns:
 * Updated semantic object
 */
export const ontologyUpdateSemanticObject = <
  ThrowOnError extends boolean = false,
>(
  options: Options<OntologyUpdateSemanticObjectData, ThrowOnError>,
) => {
  return (options.client ?? client).put<
    OntologyUpdateSemanticObjectResponses,
    OntologyUpdateSemanticObjectErrors,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/api/ontology/lakehouse/semantic/objects/{object_id}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });
};

/**
 * List relationships
 *
 * List all relationships between semantic objects.
 *
 * Returns:
 * List of object relationships
 */
export const ontologyListRelationships = <ThrowOnError extends boolean = false>(
  options: Options<OntologyListRelationshipsData, ThrowOnError>,
) => {
  return (options.client ?? client).get<
    OntologyListRelationshipsResponses,
    OntologyListRelationshipsErrors,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/api/ontology/lakehouse/semantic/relationships",
    ...options,
  });
};

/**
 * Create relationship
 *
 * Create a relationship between semantic objects.
 *
 * Args:
 * request: Relationship specification
 *
 * Returns:
 * Created relationship
 */
export const ontologyCreateRelationship = <
  ThrowOnError extends boolean = false,
>(
  options: Options<OntologyCreateRelationshipData, ThrowOnError>,
) => {
  return (options.client ?? client).post<
    OntologyCreateRelationshipResponses,
    OntologyCreateRelationshipErrors,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/api/ontology/lakehouse/semantic/relationships",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });
};

/**
 * Namespace-wide semantic discovery
 *
 * Discover all semantic objects and relationships across tables in a namespace.
 *
 * Args:
 * namespace_id: ID of the namespace to analyze
 * org_id: Organization ID
 *
 * Returns:
 * Comprehensive discovery results with cross-table relationships
 */
export const ontologyDiscoverNamespaceSemanticObjects = <
  ThrowOnError extends boolean = false,
>(
  options: Options<OntologyDiscoverNamespaceSemanticObjectsData, ThrowOnError>,
) => {
  return (options.client ?? client).post<
    OntologyDiscoverNamespaceSemanticObjectsResponses,
    OntologyDiscoverNamespaceSemanticObjectsErrors,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/api/ontology/lakehouse/semantic/discover-namespace/{namespace_id}",
    ...options,
  });
};

/**
 * Get namespace semantic overview
 *
 * Get semantic overview statistics for a namespace.
 *
 * Args:
 * namespace_id: ID of the namespace
 * org_id: Organization ID
 *
 * Returns:
 * Namespace semantic statistics and overview
 */
export const ontologyGetNamespaceOverview = <
  ThrowOnError extends boolean = false,
>(
  options: Options<OntologyGetNamespaceOverviewData, ThrowOnError>,
) => {
  return (options.client ?? client).get<
    OntologyGetNamespaceOverviewResponses,
    OntologyGetNamespaceOverviewErrors,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/api/ontology/lakehouse/semantic/namespace/{namespace_id}/overview",
    ...options,
  });
};

/**
 * Fine-tune semantic object dimensions
 *
 * Fine-tune dimensions and parameters of a semantic object.
 *
 * Args:
 * object_id: ID of the semantic object
 * org_id: Organization ID
 * dimensions_data: Updated dimensions and parameters
 *
 * Returns:
 * Updated semantic object
 */
export const ontologyUpdateObjectDimensions = <
  ThrowOnError extends boolean = false,
>(
  options: Options<OntologyUpdateObjectDimensionsData, ThrowOnError>,
) => {
  return (options.client ?? client).put<
    OntologyUpdateObjectDimensionsResponses,
    OntologyUpdateObjectDimensionsErrors,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/api/ontology/lakehouse/semantic/objects/{object_id}/dimensions",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });
};

/**
 * List all metrics
 *
 * List all metrics for the organization.
 *
 * Args:
 * org_id: Organization ID
 *
 * Returns:
 * List of metrics with metadata
 */
export const listLakehouseMetrics = <ThrowOnError extends boolean = false>(
  options: Options<ListLakehouseMetricsData, ThrowOnError>,
) => {
  return (options.client ?? client).get<
    ListLakehouseMetricsResponses,
    ListLakehouseMetricsErrors,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/api/ontology/lakehouse/metrics",
    ...options,
  });
};

/**
 * Create metric
 *
 * Create a new calculated metric.
 *
 * Args:
 * org_id: Organization ID
 * metric_data: Metric definition with SQL and parameters
 *
 * Returns:
 * Created metric
 */
export const createLakehouseMetric = <ThrowOnError extends boolean = false>(
  options: Options<CreateLakehouseMetricData, ThrowOnError>,
) => {
  return (options.client ?? client).post<
    CreateLakehouseMetricResponses,
    CreateLakehouseMetricErrors,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/api/ontology/lakehouse/metrics",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });
};

/**
 * Delete metric
 *
 * Delete a metric.
 *
 * Args:
 * metric_id: Metric identifier
 * org_id: Organization ID
 *
 * Returns:
 * Deletion confirmation
 */
export const deleteLakehouseMetric = <ThrowOnError extends boolean = false>(
  options: Options<DeleteLakehouseMetricData, ThrowOnError>,
) => {
  return (options.client ?? client).delete<
    DeleteLakehouseMetricResponses,
    DeleteLakehouseMetricErrors,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/api/ontology/lakehouse/metrics/{metric_id}",
    ...options,
  });
};

/**
 * Get metric by ID
 *
 * Get a specific metric by ID.
 *
 * Args:
 * metric_id: Metric identifier
 * org_id: Organization ID
 *
 * Returns:
 * Metric details
 */
export const getLakehouseMetric = <ThrowOnError extends boolean = false>(
  options: Options<GetLakehouseMetricData, ThrowOnError>,
) => {
  return (options.client ?? client).get<
    GetLakehouseMetricResponses,
    GetLakehouseMetricErrors,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/api/ontology/lakehouse/metrics/{metric_id}",
    ...options,
  });
};

/**
 * Update metric
 *
 * Update an existing metric.
 *
 * Args:
 * metric_id: Metric identifier
 * org_id: Organization ID
 * update_data: Updated metric data
 *
 * Returns:
 * Updated metric
 */
export const updateLakehouseMetric = <ThrowOnError extends boolean = false>(
  options: Options<UpdateLakehouseMetricData, ThrowOnError>,
) => {
  return (options.client ?? client).put<
    UpdateLakehouseMetricResponses,
    UpdateLakehouseMetricErrors,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/api/ontology/lakehouse/metrics/{metric_id}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });
};

/**
 * Calculate metric
 *
 * Execute metric calculation.
 *
 * Args:
 * metric_id: Metric identifier
 * org_id: Organization ID
 * body: Optional runtime parameters
 *
 * Returns:
 * Calculation result
 */
export const calculateLakehouseMetric = <ThrowOnError extends boolean = false>(
  options: Options<CalculateLakehouseMetricData, ThrowOnError>,
) => {
  return (options.client ?? client).post<
    CalculateLakehouseMetricResponses,
    CalculateLakehouseMetricErrors,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/api/ontology/lakehouse/metrics/{metric_id}/calculate",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });
};

/**
 * Get metric dependencies
 *
 * Get dependency graph for a metric.
 *
 * Args:
 * metric_id: Metric identifier
 * org_id: Organization ID
 *
 * Returns:
 * Dependency graph with visualization data
 */
export const ontologyGetMetricDependencies = <
  ThrowOnError extends boolean = false,
>(
  options: Options<OntologyGetMetricDependenciesData, ThrowOnError>,
) => {
  return (options.client ?? client).get<
    OntologyGetMetricDependenciesResponses,
    OntologyGetMetricDependenciesErrors,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/api/ontology/lakehouse/metrics/{metric_id}/dependencies",
    ...options,
  });
};

/**
 * Test metric SQL
 *
 * Test metric SQL definition.
 *
 * Args:
 * org_id: Organization ID
 * test_data: SQL definition and parameters to test
 *
 * Returns:
 * Test results with validation and sample data
 */
export const testLakehouseMetricSql = <ThrowOnError extends boolean = false>(
  options: Options<TestLakehouseMetricSqlData, ThrowOnError>,
) => {
  return (options.client ?? client).post<
    TestLakehouseMetricSqlResponses,
    TestLakehouseMetricSqlErrors,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/api/ontology/lakehouse/metrics/test",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });
};

/**
 * Get metric calculations
 *
 * Get calculation history for metrics.
 *
 * Args:
 * org_id: Organization ID
 *
 * Returns:
 * List of metric calculations
 */
export const listLakehouseMetricCalculations = <
  ThrowOnError extends boolean = false,
>(
  options: Options<ListLakehouseMetricCalculationsData, ThrowOnError>,
) => {
  return (options.client ?? client).get<
    ListLakehouseMetricCalculationsResponses,
    ListLakehouseMetricCalculationsErrors,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/api/ontology/lakehouse/{org_id}/metrics/calculations",
    ...options,
  });
};

/**
 * Natural language query via agent
 *
 * Execute natural language queries through AI agent integration.
 *
 * Args:
 * org_id: Organization ID
 * query_data: Query description and optional parameters
 *
 * Returns:
 * Agent-formatted query results with business context
 */
export const ontologyAgentNaturalQuery = <ThrowOnError extends boolean = false>(
  options: Options<OntologyAgentNaturalQueryData, ThrowOnError>,
) => {
  return (options.client ?? client).post<
    OntologyAgentNaturalQueryResponses,
    OntologyAgentNaturalQueryErrors,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/api/ontology/lakehouse/agent/query",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });
};

/**
 * Get lakehouse context for agents
 *
 * Get lakehouse context for AI agent conversations.
 *
 * Args:
 * org_id: Organization ID
 * context_type: Type of context (overview, semantic_objects, metrics, tables, namespaces)
 *
 * Returns:
 * Formatted context information for agents
 */
export const ontologyGetAgentContext = <ThrowOnError extends boolean = false>(
  options: Options<OntologyGetAgentContextData, ThrowOnError>,
) => {
  return (options.client ?? client).get<
    OntologyGetAgentContextResponses,
    OntologyGetAgentContextErrors,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/api/ontology/lakehouse/agent/context",
    ...options,
  });
};

/**
 * Get semantic suggestions for agent queries
 *
 * Get semantic object suggestions for agent queries.
 *
 * Args:
 * org_id: Organization ID
 * suggestion_data: User query and context for suggestions
 *
 * Returns:
 * Semantic suggestions and analysis opportunities
 */
export const ontologyGetSemanticSuggestions = <
  ThrowOnError extends boolean = false,
>(
  options: Options<OntologyGetSemanticSuggestionsData, ThrowOnError>,
) => {
  return (options.client ?? client).post<
    OntologyGetSemanticSuggestionsResponses,
    OntologyGetSemanticSuggestionsErrors,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/api/ontology/lakehouse/agent/semantic-suggestions",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });
};

/**
 * Get table lineage
 *
 * Get complete lineage information for a table.
 *
 * Args:
 * table_id: Table identifier
 *
 * Returns:
 * Lineage graph with upstream and downstream dependencies
 */
export const ontologyGetTableLineage = <ThrowOnError extends boolean = false>(
  options: Options<OntologyGetTableLineageData, ThrowOnError>,
) => {
  return (options.client ?? client).get<
    OntologyGetTableLineageResponses,
    OntologyGetTableLineageErrors,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/api/ontology/lakehouse/lineage/{table_id}",
    ...options,
  });
};

/**
 * Column-level lineage
 *
 * Get column-level lineage information.
 *
 * Args:
 * table_id: Table identifier
 * column: Column name
 *
 * Returns:
 * Column lineage information
 */
export const ontologyGetColumnLineage = <ThrowOnError extends boolean = false>(
  options: Options<OntologyGetColumnLineageData, ThrowOnError>,
) => {
  return (options.client ?? client).get<
    OntologyGetColumnLineageResponses,
    OntologyGetColumnLineageErrors,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/api/ontology/lakehouse/lineage/column/{table_id}/{column}",
    ...options,
  });
};

/**
 * Impact analysis
 *
 * Analyze the impact of changes to a table.
 *
 * Args:
 * table_id: Table identifier
 *
 * Returns:
 * Impact analysis showing affected downstream objects
 */
export const ontologyGetImpactAnalysis = <ThrowOnError extends boolean = false>(
  options: Options<OntologyGetImpactAnalysisData, ThrowOnError>,
) => {
  return (options.client ?? client).get<
    OntologyGetImpactAnalysisResponses,
    OntologyGetImpactAnalysisErrors,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/api/ontology/lakehouse/lineage/impact/{table_id}",
    ...options,
  });
};

/**
 * Assess datasource migration feasibility
 *
 * Assess the feasibility and benefits of migrating a datasource to lakehouse format.
 *
 * Args:
 * datasource_id: ID of the datasource to assess
 * org_id: Organization ID
 *
 * Returns:
 * Migration assessment with feasibility, benefits, and recommendations
 */
export const ontologyAssessDatasourceMigration = <
  ThrowOnError extends boolean = false,
>(
  options: Options<OntologyAssessDatasourceMigrationData, ThrowOnError>,
) => {
  return (options.client ?? client).get<
    OntologyAssessDatasourceMigrationResponses,
    OntologyAssessDatasourceMigrationErrors,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/api/ontology/lakehouse/integration/datasource/{datasource_id}/migration-assessment",
    ...options,
  });
};

/**
 * Create datasource migration job
 *
 * Create a datasource-to-lakehouse migration job.
 *
 * Args:
 * datasource_id: ID of the datasource to migrate
 * org_id: Organization ID
 * migration_config: Migration configuration parameters
 *
 * Returns:
 * Migration job information
 */
export const ontologyCreateMigrationJob = <
  ThrowOnError extends boolean = false,
>(
  options: Options<OntologyCreateMigrationJobData, ThrowOnError>,
) => {
  return (options.client ?? client).post<
    OntologyCreateMigrationJobResponses,
    OntologyCreateMigrationJobErrors,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/api/ontology/lakehouse/integration/datasource/migrate",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });
};

/**
 * Get migration job progress
 *
 * Get the status and progress of a migration job.
 *
 * Args:
 * migration_id: ID of the migration job
 * org_id: Organization ID
 *
 * Returns:
 * Migration status and progress information
 */
export const ontologyGetMigrationProgress = <
  ThrowOnError extends boolean = false,
>(
  options: Options<OntologyGetMigrationProgressData, ThrowOnError>,
) => {
  return (options.client ?? client).get<
    OntologyGetMigrationProgressResponses,
    OntologyGetMigrationProgressErrors,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/api/ontology/lakehouse/integration/migration/{migration_id}/progress",
    ...options,
  });
};

/**
 * Execute a migration job
 *
 * Execute a previously created migration job.
 *
 * Args:
 * migration_id: ID of the migration job to execute
 * org_id: Organization ID
 *
 * Returns:
 * Execution status confirmation
 */
export const ontologyExecuteMigrationJob = <
  ThrowOnError extends boolean = false,
>(
  options: Options<OntologyExecuteMigrationJobData, ThrowOnError>,
) => {
  return (options.client ?? client).post<
    OntologyExecuteMigrationJobResponses,
    OntologyExecuteMigrationJobErrors,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/api/ontology/lakehouse/integration/migration/{migration_id}/execute",
    ...options,
  });
};

/**
 * Discover semantic objects from datasource
 *
 * Discover semantic objects from an existing datasource using AI analysis.
 *
 * Args:
 * datasource_id: ID of the datasource to analyze
 * org_id: Organization ID
 *
 * Returns:
 * Discovered semantic objects and relationships
 */
export const ontologyDiscoverSemanticsFromDatasource = <
  ThrowOnError extends boolean = false,
>(
  options: Options<OntologyDiscoverSemanticsFromDatasourceData, ThrowOnError>,
) => {
  return (options.client ?? client).post<
    OntologyDiscoverSemanticsFromDatasourceResponses,
    OntologyDiscoverSemanticsFromDatasourceErrors,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/api/ontology/lakehouse/integration/semantic/discover-from-datasource",
    ...options,
  });
};

/**
 * Analyze metric enhancement potential
 *
 * Analyze how a metric could be enhanced with semantic objects and lakehouse features.
 *
 * Args:
 * metric_id: ID of the metric to analyze
 * org_id: Organization ID
 *
 * Returns:
 * Enhancement analysis and suggestions
 */
export const ontologyAnalyzeMetricEnhancement = <
  ThrowOnError extends boolean = false,
>(
  options: Options<OntologyAnalyzeMetricEnhancementData, ThrowOnError>,
) => {
  return (options.client ?? client).get<
    OntologyAnalyzeMetricEnhancementResponses,
    OntologyAnalyzeMetricEnhancementErrors,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/api/ontology/lakehouse/integration/metric/{metric_id}/enhancement-analysis",
    ...options,
  });
};

/**
 * Get integration health metrics
 *
 * Get overall integration health and metrics for an organization.
 *
 * Args:
 * org_id: Organization ID
 *
 * Returns:
 * Integration status and health metrics
 */
export const ontologyGetIntegrationStatus = <
  ThrowOnError extends boolean = false,
>(
  options: Options<OntologyGetIntegrationStatusData, ThrowOnError>,
) => {
  return (options.client ?? client).get<
    OntologyGetIntegrationStatusResponses,
    OntologyGetIntegrationStatusErrors,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/api/ontology/lakehouse/integration/status/integration",
    ...options,
  });
};

/**
 * Get cross-system data lineage
 *
 * Get comprehensive lineage across datasources, lakehouse, and metrics.
 *
 * Args:
 * org_id: Organization ID
 * object_id: Optional specific object to trace lineage for
 *
 * Returns:
 * Cross-system lineage visualization data
 */
export const ontologyGetCrossSystemLineage = <
  ThrowOnError extends boolean = false,
>(
  options: Options<OntologyGetCrossSystemLineageData, ThrowOnError>,
) => {
  return (options.client ?? client).get<
    OntologyGetCrossSystemLineageResponses,
    OntologyGetCrossSystemLineageErrors,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/api/ontology/lakehouse/integration/lineage/cross-system",
    ...options,
  });
};

/**
 * List organization migrations
 *
 * List all migration jobs for an organization.
 *
 * Args:
 * org_id: Organization ID
 *
 * Returns:
 * List of migration jobs with status
 */
export const ontologyListMigrations = <ThrowOnError extends boolean = false>(
  options: Options<OntologyListMigrationsData, ThrowOnError>,
) => {
  return (options.client ?? client).get<
    OntologyListMigrationsResponses,
    OntologyListMigrationsErrors,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/api/ontology/lakehouse/integration/migrations",
    ...options,
  });
};

/**
 * Batch assess all datasources for migration
 *
 * Perform migration assessment on all datasources in the organization.
 *
 * Args:
 * org_id: Organization ID
 *
 * Returns:
 * Batch assessment results
 */
export const ontologyBatchAssessDatasources = <
  ThrowOnError extends boolean = false,
>(
  options: Options<OntologyBatchAssessDatasourcesData, ThrowOnError>,
) => {
  return (options.client ?? client).post<
    OntologyBatchAssessDatasourcesResponses,
    OntologyBatchAssessDatasourcesErrors,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/api/ontology/lakehouse/integration/batch/assess-all-datasources",
    ...options,
  });
};

/**
 * Batch assess and migrate high feasibility datasources
 *
 * Perform migration assessment on all datasources and automatically migrate high feasibility ones.
 *
 * Args:
 * org_id: Organization ID
 * min_feasibility_score: Minimum feasibility score to trigger automatic migration (0.0 to 1.0)
 *
 * Returns:
 * Batch assessment results with migration job IDs for triggered migrations
 */
export const ontologyBatchAssessAndMigrateDatasources = <
  ThrowOnError extends boolean = false,
>(
  options: Options<OntologyBatchAssessAndMigrateDatasourcesData, ThrowOnError>,
) => {
  return (options.client ?? client).post<
    OntologyBatchAssessAndMigrateDatasourcesResponses,
    OntologyBatchAssessAndMigrateDatasourcesErrors,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/api/ontology/lakehouse/integration/batch/assess-and-migrate-datasources",
    ...options,
  });
};

/**
 * Rebuild Catalog
 *
 * Rebuild PyIceberg catalog from existing warehouse data.
 *
 * This endpoint reconstructs the catalog.db by scanning the database for tables
 * and re-registering them in the PyIceberg catalog. This is useful when:
 * - Docker container restarts and catalog.db is lost
 * - Catalog becomes out of sync with actual data
 * - After manual data file operations
 *
 * Args:
 * org_id: Organization ID (required unless rebuild_all=True)
 * rebuild_all: If True, rebuild catalogs for all organizations (admin only)
 *
 * Returns:
 * Rebuild statistics including tables found and registered
 */
export const ontologyRebuildCatalog = <ThrowOnError extends boolean = false>(
  options: Options<OntologyRebuildCatalogData, ThrowOnError>,
) => {
  return (options.client ?? client).post<
    OntologyRebuildCatalogResponses,
    OntologyRebuildCatalogErrors,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/api/ontology/lakehouse/catalog/rebuild",
    ...options,
  });
};

/**
 * List Foreign Connections
 *
 * List all foreign database connections for an organization.
 *
 * Args:
 * org_id: Organization ID
 * federation_enabled_only: Only return federation-enabled connections (default: True)
 *
 * Returns:
 * List of foreign connections with datasource information
 */
export const ontologyListForeignConnections = <
  ThrowOnError extends boolean = false,
>(
  options: Options<OntologyListForeignConnectionsData, ThrowOnError>,
) => {
  return (options.client ?? client).get<
    OntologyListForeignConnectionsResponses,
    OntologyListForeignConnectionsErrors,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/api/ontology/lakehouse/foreign-connections",
    ...options,
  });
};

/**
 * Create Foreign Connection
 *
 * Create a new foreign database connection for direct query federation.
 *
 * This enables querying external PostgreSQL databases directly using the
 * foreign.connection_name.table_name pattern without importing data.
 *
 * After creation, the schema is automatically synced and tables are
 * registered as data_sources for semantic discovery.
 *
 * Example usage after creation:
 * SELECT * FROM foreign.prod_db.users WHERE created_at > '2024-01-01'
 *
 * Args:
 * request: Foreign connection configuration
 * org_id: Organization ID
 *
 * Returns:
 * Created foreign connection details
 */
export const ontologyCreateForeignConnection = <
  ThrowOnError extends boolean = false,
>(
  options: Options<OntologyCreateForeignConnectionData, ThrowOnError>,
) => {
  return (options.client ?? client).post<
    OntologyCreateForeignConnectionResponses,
    OntologyCreateForeignConnectionErrors,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/api/ontology/lakehouse/foreign-connections",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });
};

/**
 * Get Foreign Connection
 *
 * Get details of a specific foreign connection by name.
 *
 * Args:
 * connection_name: The connection name
 * org_id: Organization ID
 *
 * Returns:
 * Foreign connection details with datasource information
 */
export const ontologyGetForeignConnection = <
  ThrowOnError extends boolean = false,
>(
  options: Options<OntologyGetForeignConnectionData, ThrowOnError>,
) => {
  return (options.client ?? client).get<
    OntologyGetForeignConnectionResponses,
    OntologyGetForeignConnectionErrors,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/api/ontology/lakehouse/foreign-connections/{connection_name}",
    ...options,
  });
};

/**
 * Delete Foreign Connection
 *
 * Delete a foreign connection.
 *
 * This will prevent queries from using the connection but won't affect
 * the underlying datasource or any synced data in the lakehouse.
 *
 * Args:
 * connection_id: Foreign connection ID
 * org_id: Organization ID
 *
 * Returns:
 * Success message
 */
export const ontologyDeleteForeignConnection = <
  ThrowOnError extends boolean = false,
>(
  options: Options<OntologyDeleteForeignConnectionData, ThrowOnError>,
) => {
  return (options.client ?? client).delete<
    OntologyDeleteForeignConnectionResponses,
    OntologyDeleteForeignConnectionErrors,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/api/ontology/lakehouse/foreign-connections/{connection_id}",
    ...options,
  });
};

/**
 * Update Foreign Connection
 *
 * Update an existing foreign connection.
 *
 * Args:
 * connection_id: Foreign connection ID
 * request: Update parameters
 * org_id: Organization ID
 *
 * Returns:
 * Updated foreign connection details
 */
export const ontologyUpdateForeignConnection = <
  ThrowOnError extends boolean = false,
>(
  options: Options<OntologyUpdateForeignConnectionData, ThrowOnError>,
) => {
  return (options.client ?? client).patch<
    OntologyUpdateForeignConnectionResponses,
    OntologyUpdateForeignConnectionErrors,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/api/ontology/lakehouse/foreign-connections/{connection_id}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });
};

/**
 * Test Foreign Connection
 *
 * Test a foreign database connection by executing a simple query.
 *
 * This verifies that the connection can be established and queries can be executed.
 * By default, runs "SELECT 1" but a custom test query can be provided.
 *
 * Args:
 * request: Test connection request with connection ID
 * org_id: Organization ID
 *
 * Returns:
 * Test results including success status and execution time
 */
export const ontologyTestForeignConnection = <
  ThrowOnError extends boolean = false,
>(
  options: Options<OntologyTestForeignConnectionData, ThrowOnError>,
) => {
  return (options.client ?? client).post<
    OntologyTestForeignConnectionResponses,
    OntologyTestForeignConnectionErrors,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/api/ontology/lakehouse/foreign-connections/test",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });
};

/**
 * Discover Foreign Connection Schemas
 *
 * Discover all schemas in a foreign database connection.
 *
 * This endpoint introspects the foreign PostgreSQL database to list all available
 * schemas and their table counts. Use this to browse the structure of external
 * databases before querying them.
 *
 * Args:
 * connection_name: Foreign connection name
 * org_id: Organization ID
 *
 * Returns:
 * List of schemas with table counts
 */
export const ontologyDiscoverForeignConnectionSchemas = <
  ThrowOnError extends boolean = false,
>(
  options: Options<OntologyDiscoverForeignConnectionSchemasData, ThrowOnError>,
) => {
  return (options.client ?? client).get<
    OntologyDiscoverForeignConnectionSchemasResponses,
    OntologyDiscoverForeignConnectionSchemasErrors,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/api/ontology/lakehouse/foreign-connections/{connection_name}/schemas",
    ...options,
  });
};

/**
 * Discover Foreign Connection Tables
 *
 * Discover tables in a foreign database connection.
 *
 * This endpoint introspects the foreign PostgreSQL database to list all available
 * tables with their metadata including columns, row counts, and sizes. Optionally
 * filter by schema name.
 *
 * Args:
 * connection_name: Foreign connection name
 * org_id: Organization ID
 * schema_name: Optional schema filter
 *
 * Returns:
 * List of tables with detailed metadata
 */
export const ontologyDiscoverForeignConnectionTables = <
  ThrowOnError extends boolean = false,
>(
  options: Options<OntologyDiscoverForeignConnectionTablesData, ThrowOnError>,
) => {
  return (options.client ?? client).get<
    OntologyDiscoverForeignConnectionTablesResponses,
    OntologyDiscoverForeignConnectionTablesErrors,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/api/ontology/lakehouse/foreign-connections/{connection_name}/tables",
    ...options,
  });
};

/**
 * Get Foreign Table Details
 *
 * Get detailed information about a specific table in a foreign connection.
 *
 * This endpoint retrieves comprehensive metadata about a foreign table including
 * all columns, indexes, constraints, and statistics.
 *
 * Args:
 * connection_name: Foreign connection name
 * schema_name: Schema name
 * table_name: Table name
 * org_id: Organization ID
 *
 * Returns:
 * Detailed table information with columns and indexes
 */
export const ontologyGetForeignTableDetails = <
  ThrowOnError extends boolean = false,
>(
  options: Options<OntologyGetForeignTableDetailsData, ThrowOnError>,
) => {
  return (options.client ?? client).get<
    OntologyGetForeignTableDetailsResponses,
    OntologyGetForeignTableDetailsErrors,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/api/ontology/lakehouse/foreign-connections/{connection_name}/tables/{schema_name}/{table_name}",
    ...options,
  });
};

/**
 * Debug Resolve Runtime
 */
export const ontologyDebugResolveRuntime = <
  ThrowOnError extends boolean = false,
>(
  options: Options<OntologyDebugResolveRuntimeData, ThrowOnError>,
) => {
  return (options.client ?? client).post<
    OntologyDebugResolveRuntimeResponses,
    OntologyDebugResolveRuntimeErrors,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/api/ontology/runtime/debug/resolve",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });
};

/**
 * List Runtime Spaces
 */
export const ontologyListRuntimeSpaces = <ThrowOnError extends boolean = false>(
  options: Options<OntologyListRuntimeSpacesData, ThrowOnError>,
) => {
  return (options.client ?? client).get<
    OntologyListRuntimeSpacesResponses,
    OntologyListRuntimeSpacesErrors,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/api/ontology/runtime/spaces",
    ...options,
  });
};

/**
 * Promote Runtime Asset
 */
export const ontologyPromoteRuntimeAsset = <
  ThrowOnError extends boolean = false,
>(
  options: Options<OntologyPromoteRuntimeAssetData, ThrowOnError>,
) => {
  return (options.client ?? client).post<
    OntologyPromoteRuntimeAssetResponses,
    OntologyPromoteRuntimeAssetErrors,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/api/ontology/runtime/assets/{asset_id}/promote",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });
};

/**
 * Get Runtime Trace
 */
export const ontologyGetRuntimeTrace = <ThrowOnError extends boolean = false>(
  options: Options<OntologyGetRuntimeTraceData, ThrowOnError>,
) => {
  return (options.client ?? client).get<
    OntologyGetRuntimeTraceResponses,
    OntologyGetRuntimeTraceErrors,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/api/ontology/runtime/traces/{trace_id}",
    ...options,
  });
};

/**
 * Get Runtime Graph Neighborhood
 */
export const ontologyGetRuntimeGraphNeighborhood = <
  ThrowOnError extends boolean = false,
>(
  options: Options<OntologyGetRuntimeGraphNeighborhoodData, ThrowOnError>,
) => {
  return (options.client ?? client).get<
    OntologyGetRuntimeGraphNeighborhoodResponses,
    OntologyGetRuntimeGraphNeighborhoodErrors,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/api/ontology/runtime/graph/neighborhood",
    ...options,
  });
};

/**
 * Get Runtime Graph Lineage
 */
export const ontologyGetRuntimeGraphLineage = <
  ThrowOnError extends boolean = false,
>(
  options: Options<OntologyGetRuntimeGraphLineageData, ThrowOnError>,
) => {
  return (options.client ?? client).get<
    OntologyGetRuntimeGraphLineageResponses,
    OntologyGetRuntimeGraphLineageErrors,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/api/ontology/runtime/graph/lineage",
    ...options,
  });
};

/**
 * Get Runtime Graph
 */
export const ontologyGetRuntimeGraph = <ThrowOnError extends boolean = false>(
  options: Options<OntologyGetRuntimeGraphData, ThrowOnError>,
) => {
  return (options.client ?? client).get<
    OntologyGetRuntimeGraphResponses,
    OntologyGetRuntimeGraphErrors,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/api/ontology/runtime/graph",
    ...options,
  });
};

/**
 * Test Connection
 *
 * Test the connection to a specific datasource.
 *
 * Args:
 * datasource_id: The ID of the datasource to test.
 *
 * Returns:
 * TestConnectionResponse: An object indicating if the connection was successful.
 */
export const ontologyTestConnection = <ThrowOnError extends boolean = false>(
  options: Options<OntologyTestConnectionData, ThrowOnError>,
) => {
  return (options.client ?? client).post<
    OntologyTestConnectionResponses,
    OntologyTestConnectionErrors,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/api/ontology/datasources/{datasource_id}/test",
    ...options,
  });
};

/**
 * Create a new PostgreSQL datasource
 *
 * Create a new PostgreSQL datasource with auto-creation of foreign connection for federation.
 */
export const ontologyCreatePostgresqlDatasource = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<OntologyCreatePostgresqlDatasourceData, ThrowOnError>,
) => {
  return (options?.client ?? client).post<
    OntologyCreatePostgresqlDatasourceResponses,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/api/ontology/datasources/postgresql",
    ...options,
  });
};

/**
 * Create a new MySQL datasource
 *
 * Create a new MySQL datasource with auto-creation of foreign connection for federation.
 */
export const ontologyCreateMysqlDatasource = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<OntologyCreateMysqlDatasourceData, ThrowOnError>,
) => {
  return (options?.client ?? client).post<
    OntologyCreateMysqlDatasourceResponses,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/api/ontology/datasources/mysql",
    ...options,
  });
};

/**
 * Create a new MongoDB datasource
 *
 * Create a new MongoDB datasource
 */
export const ontologyCreateMongodbDatasource = <
  ThrowOnError extends boolean = false,
>(
  options: Options<OntologyCreateMongodbDatasourceData, ThrowOnError>,
) => {
  return (options.client ?? client).post<
    OntologyCreateMongodbDatasourceResponses,
    OntologyCreateMongodbDatasourceErrors,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/api/ontology/datasources/mongodb",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });
};

/**
 * Create a new SQL Server datasource
 *
 * Create a new SQL Server datasource with auto-creation of foreign connection for federation.
 */
export const ontologyCreateSqlserverDatasource = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<OntologyCreateSqlserverDatasourceData, ThrowOnError>,
) => {
  return (options?.client ?? client).post<
    OntologyCreateSqlserverDatasourceResponses,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/api/ontology/datasources/sqlserver",
    ...options,
  });
};

/**
 * Get all datasources for an organization
 *
 * Get all datasources for an organization
 */
export const ontologyGetDatasources = <ThrowOnError extends boolean = false>(
  options: Options<OntologyGetDatasourcesData, ThrowOnError>,
) => {
  return (options.client ?? client).get<
    OntologyGetDatasourcesResponses,
    OntologyGetDatasourcesErrors,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/api/ontology/datasources",
    ...options,
  });
};

/**
 * Get a datasource by ID
 *
 * Get a datasource by ID
 */
export const ontologyGetDatasource = <ThrowOnError extends boolean = false>(
  options: Options<OntologyGetDatasourceData, ThrowOnError>,
) => {
  return (options.client ?? client).get<
    OntologyGetDatasourceResponses,
    OntologyGetDatasourceErrors,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/api/ontology/datasources/{datasource_id}",
    ...options,
  });
};

/**
 * Get all metrics for an organization
 *
 * Get all metrics for an organization
 */
export const ontologyGetMetrics = <ThrowOnError extends boolean = false>(
  options: Options<OntologyGetMetricsData, ThrowOnError>,
) => {
  return (options.client ?? client).get<
    OntologyGetMetricsResponses,
    OntologyGetMetricsErrors,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/api/ontology/metrics",
    ...options,
  });
};

/**
 * Create a new metric
 *
 * Create a new metric
 */
export const createDatasourceMetric = <ThrowOnError extends boolean = false>(
  options: Options<CreateDatasourceMetricData, ThrowOnError>,
) => {
  return (options.client ?? client).post<
    CreateDatasourceMetricResponses,
    CreateDatasourceMetricErrors,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/api/ontology/metrics",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });
};

/**
 * Delete a metric
 *
 * Delete a metric
 */
export const deleteDatasourceMetric = <ThrowOnError extends boolean = false>(
  options: Options<DeleteDatasourceMetricData, ThrowOnError>,
) => {
  return (options.client ?? client).delete<
    DeleteDatasourceMetricResponses,
    DeleteDatasourceMetricErrors,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/api/ontology/metrics/{metric_id}",
    ...options,
  });
};

/**
 * Get a metric by ID
 *
 * Get a metric by ID
 */
export const ontologyGetMetric = <ThrowOnError extends boolean = false>(
  options: Options<OntologyGetMetricData, ThrowOnError>,
) => {
  return (options.client ?? client).get<
    OntologyGetMetricResponses,
    OntologyGetMetricErrors,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/api/ontology/metrics/{metric_id}",
    ...options,
  });
};

/**
 * Update a metric
 *
 * Update a metric
 */
export const updateDatasourceMetric = <ThrowOnError extends boolean = false>(
  options: Options<UpdateDatasourceMetricData, ThrowOnError>,
) => {
  return (options.client ?? client).put<
    UpdateDatasourceMetricResponses,
    UpdateDatasourceMetricErrors,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/api/ontology/metrics/{metric_id}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });
};

/**
 * List work records for the org with optional filters
 */
export const playbooksListWorkRecords = <ThrowOnError extends boolean = false>(
  options: Options<PlaybooksListWorkRecordsData, ThrowOnError>,
) => {
  return (options.client ?? client).get<
    PlaybooksListWorkRecordsResponses,
    PlaybooksListWorkRecordsErrors,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/api/playbooks/work-records",
    ...options,
  });
};

/**
 * Fetch a single work record with full payload + metadata
 */
export const playbooksGetWorkRecord = <ThrowOnError extends boolean = false>(
  options: Options<PlaybooksGetWorkRecordData, ThrowOnError>,
) => {
  return (options.client ?? client).get<
    PlaybooksGetWorkRecordResponses,
    PlaybooksGetWorkRecordErrors,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/api/playbooks/work-records/{record_id}",
    ...options,
  });
};

/**
 * Release the lock and re-queue a record into its runner's source status
 */
export const playbooksRetryWorkRecord = <ThrowOnError extends boolean = false>(
  options: Options<PlaybooksRetryWorkRecordData, ThrowOnError>,
) => {
  return (options.client ?? client).post<
    PlaybooksRetryWorkRecordResponses,
    PlaybooksRetryWorkRecordErrors,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/api/playbooks/work-records/{record_id}/retry",
    ...options,
  });
};

/**
 * Apply an operator approve/reject decision on a manual_review record
 */
export const playbooksManualReviewAction = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PlaybooksManualReviewActionData, ThrowOnError>,
) => {
  return (options.client ?? client).post<
    PlaybooksManualReviewActionResponses,
    PlaybooksManualReviewActionErrors,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/api/playbooks/work-records/{record_id}/manual-review",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });
};

/**
 * List artifacts attached to a work record
 */
export const playbooksListWorkArtifacts = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PlaybooksListWorkArtifactsData, ThrowOnError>,
) => {
  return (options.client ?? client).get<
    PlaybooksListWorkArtifactsResponses,
    PlaybooksListWorkArtifactsErrors,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/api/playbooks/work-artifacts",
    ...options,
  });
};

/**
 * Create a short-lived signed URL for downloading the artifact bytes
 */
export const playbooksSignedDownloadUrl = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PlaybooksSignedDownloadUrlData, ThrowOnError>,
) => {
  return (options.client ?? client).get<
    PlaybooksSignedDownloadUrlResponses,
    PlaybooksSignedDownloadUrlErrors,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/api/playbooks/work-artifacts/{artifact_id}/signed-download",
    ...options,
  });
};

/**
 * Manual upload — create a Work Record + input artifact for the chosen Phase Runner
 */
export const playbooksUploadRecordSource = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PlaybooksUploadRecordSourceData, ThrowOnError>,
) => {
  return (options.client ?? client).post<
    PlaybooksUploadRecordSourceResponses,
    PlaybooksUploadRecordSourceErrors,
    ThrowOnError
  >({
    ...formDataBodySerializer,
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/api/playbooks/record-sources/upload",
    ...options,
    headers: {
      "Content-Type": null,
      ...options.headers,
    },
  });
};

/**
 * List phase runners with computed health metrics
 */
export const playbooksListPhaseRunnerHealth = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PlaybooksListPhaseRunnerHealthData, ThrowOnError>,
) => {
  return (options.client ?? client).get<
    PlaybooksListPhaseRunnerHealthResponses,
    PlaybooksListPhaseRunnerHealthErrors,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/api/playbooks/phase-runners",
    ...options,
  });
};

/**
 * Recent tick history for one phase runner
 */
export const playbooksListPhaseRunnerTicks = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PlaybooksListPhaseRunnerTicksData, ThrowOnError>,
) => {
  return (options.client ?? client).get<
    PlaybooksListPhaseRunnerTicksResponses,
    PlaybooksListPhaseRunnerTicksErrors,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/api/playbooks/phase-runners/{runner_id}/ticks",
    ...options,
  });
};

/**
 * List playbooks for organization
 *
 * List all playbooks for an organization.
 */
export const playbooksListPlaybooks = <ThrowOnError extends boolean = false>(
  options: Options<PlaybooksListPlaybooksData, ThrowOnError>,
) => {
  return (options.client ?? client).get<
    PlaybooksListPlaybooksResponses,
    PlaybooksListPlaybooksErrors,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/api/playbooks/",
    ...options,
  });
};

/**
 * Create a new playbook
 *
 * Create a new playbook (starts in draft status).
 */
export const playbooksCreatePlaybook = <ThrowOnError extends boolean = false>(
  options: Options<PlaybooksCreatePlaybookData, ThrowOnError>,
) => {
  return (options.client ?? client).post<
    PlaybooksCreatePlaybookResponses,
    PlaybooksCreatePlaybookErrors,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/api/playbooks/",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });
};

/**
 * Delete playbook (soft delete)
 *
 * Soft delete a playbook.
 */
export const playbooksDeletePlaybook = <ThrowOnError extends boolean = false>(
  options: Options<PlaybooksDeletePlaybookData, ThrowOnError>,
) => {
  return (options.client ?? client).delete<
    PlaybooksDeletePlaybookResponses,
    PlaybooksDeletePlaybookErrors,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/api/playbooks/{playbook_id}",
    ...options,
  });
};

/**
 * Get playbook details
 *
 * Get full playbook details including workflow definition.
 */
export const playbooksGetPlaybook = <ThrowOnError extends boolean = false>(
  options: Options<PlaybooksGetPlaybookData, ThrowOnError>,
) => {
  return (options.client ?? client).get<
    PlaybooksGetPlaybookResponses,
    PlaybooksGetPlaybookErrors,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/api/playbooks/{playbook_id}",
    ...options,
  });
};

/**
 * Update playbook
 *
 * Update playbook. Saves current state as previous version before updating.
 * Note: Active scheduled playbooks can only be paused, not edited.
 */
export const playbooksUpdatePlaybook = <ThrowOnError extends boolean = false>(
  options: Options<PlaybooksUpdatePlaybookData, ThrowOnError>,
) => {
  return (options.client ?? client).put<
    PlaybooksUpdatePlaybookResponses,
    PlaybooksUpdatePlaybookErrors,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/api/playbooks/{playbook_id}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });
};

/**
 * Rollback to previous version
 *
 * Rollback playbook to its previous version.
 */
export const playbooksRollbackPlaybook = <ThrowOnError extends boolean = false>(
  options: Options<PlaybooksRollbackPlaybookData, ThrowOnError>,
) => {
  return (options.client ?? client).post<
    PlaybooksRollbackPlaybookResponses,
    PlaybooksRollbackPlaybookErrors,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/api/playbooks/{playbook_id}/rollback",
    ...options,
  });
};

/**
 * Activate playbook
 *
 * Activate a playbook (enables scheduled execution or makes manual available).
 */
export const playbooksActivatePlaybook = <ThrowOnError extends boolean = false>(
  options: Options<PlaybooksActivatePlaybookData, ThrowOnError>,
) => {
  return (options.client ?? client).post<
    PlaybooksActivatePlaybookResponses,
    PlaybooksActivatePlaybookErrors,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/api/playbooks/{playbook_id}/activate",
    ...options,
  });
};

/**
 * Pause playbook
 *
 * Pause a playbook (disables scheduled execution).
 */
export const playbooksPausePlaybook = <ThrowOnError extends boolean = false>(
  options: Options<PlaybooksPausePlaybookData, ThrowOnError>,
) => {
  return (options.client ?? client).post<
    PlaybooksPausePlaybookResponses,
    PlaybooksPausePlaybookErrors,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/api/playbooks/{playbook_id}/pause",
    ...options,
  });
};

/**
 * Enable webhook for playbook
 *
 * Enable webhook trigger and generate a token if none exists.
 */
export const playbooksEnableWebhook = <ThrowOnError extends boolean = false>(
  options: Options<PlaybooksEnableWebhookData, ThrowOnError>,
) => {
  return (options.client ?? client).post<
    PlaybooksEnableWebhookResponses,
    PlaybooksEnableWebhookErrors,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/api/playbooks/{playbook_id}/webhook/enable",
    ...options,
  });
};

/**
 * Regenerate webhook token
 *
 * Generate a new webhook token, invalidating the old one.
 */
export const playbooksRegenerateWebhook = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PlaybooksRegenerateWebhookData, ThrowOnError>,
) => {
  return (options.client ?? client).post<
    PlaybooksRegenerateWebhookResponses,
    PlaybooksRegenerateWebhookErrors,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/api/playbooks/{playbook_id}/webhook/regenerate",
    ...options,
  });
};

/**
 * Disable webhook for playbook
 *
 * Disable the webhook trigger (token is preserved for re-enable).
 */
export const playbooksDisableWebhook = <ThrowOnError extends boolean = false>(
  options: Options<PlaybooksDisableWebhookData, ThrowOnError>,
) => {
  return (options.client ?? client).post<
    PlaybooksDisableWebhookResponses,
    PlaybooksDisableWebhookErrors,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/api/playbooks/{playbook_id}/webhook/disable",
    ...options,
  });
};

/**
 * Trigger manual playbook execution
 *
 * Trigger execution of a manual playbook.
 * Returns execution ID for tracking progress.
 */
export const playbooksExecutePlaybook = <ThrowOnError extends boolean = false>(
  options: Options<PlaybooksExecutePlaybookData, ThrowOnError>,
) => {
  return (options.client ?? client).post<
    PlaybooksExecutePlaybookResponses,
    PlaybooksExecutePlaybookErrors,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/api/playbooks/{playbook_id}/execute",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });
};

/**
 * Trigger manual playbook execution with file inputs
 */
export const playbooksExecutePlaybookWithFiles = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PlaybooksExecutePlaybookWithFilesData, ThrowOnError>,
) => {
  return (options.client ?? client).post<
    PlaybooksExecutePlaybookWithFilesResponses,
    PlaybooksExecutePlaybookWithFilesErrors,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/api/playbooks/{playbook_id}/execute-with-files",
    ...options,
  });
};

/**
 * List playbook executions
 *
 * List execution history for a playbook.
 */
export const playbooksListExecutions = <ThrowOnError extends boolean = false>(
  options: Options<PlaybooksListExecutionsData, ThrowOnError>,
) => {
  return (options.client ?? client).get<
    PlaybooksListExecutionsResponses,
    PlaybooksListExecutionsErrors,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/api/playbooks/{playbook_id}/executions",
    ...options,
  });
};

/**
 * List execution input and artifact files
 */
export const playbooksListExecutionFiles = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PlaybooksListExecutionFilesData, ThrowOnError>,
) => {
  return (options.client ?? client).get<
    PlaybooksListExecutionFilesResponses,
    PlaybooksListExecutionFilesErrors,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/api/playbooks/{playbook_id}/executions/{execution_id}/files",
    ...options,
  });
};

/**
 * Create a signed execution file download URL
 */
export const playbooksCreateExecutionFileDownloadUrl = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PlaybooksCreateExecutionFileDownloadUrlData, ThrowOnError>,
) => {
  return (options.client ?? client).post<
    PlaybooksCreateExecutionFileDownloadUrlResponses,
    PlaybooksCreateExecutionFileDownloadUrlErrors,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/api/playbooks/{playbook_id}/executions/{execution_id}/files/{file_id}/download-url",
    ...options,
  });
};

/**
 * Get execution details
 *
 * Get detailed execution info including node-by-node results.
 */
export const playbooksGetExecution = <ThrowOnError extends boolean = false>(
  options: Options<PlaybooksGetExecutionData, ThrowOnError>,
) => {
  return (options.client ?? client).get<
    PlaybooksGetExecutionResponses,
    PlaybooksGetExecutionErrors,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/api/playbooks/{playbook_id}/executions/{execution_id}",
    ...options,
  });
};

/**
 * Cancel running execution
 *
 * Cancel a running execution.
 */
export const playbooksCancelExecution = <ThrowOnError extends boolean = false>(
  options: Options<PlaybooksCancelExecutionData, ThrowOnError>,
) => {
  return (options.client ?? client).post<
    PlaybooksCancelExecutionResponses,
    PlaybooksCancelExecutionErrors,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/api/playbooks/{playbook_id}/executions/{execution_id}/cancel",
    ...options,
  });
};

/**
 * List orchestrators for organization
 */
export const playbooksListOrchestrators = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PlaybooksListOrchestratorsData, ThrowOnError>,
) => {
  return (options.client ?? client).get<
    PlaybooksListOrchestratorsResponses,
    PlaybooksListOrchestratorsErrors,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/api/playbooks/orchestrators/",
    ...options,
  });
};

/**
 * Create orchestrator
 */
export const playbooksCreateOrchestrator = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PlaybooksCreateOrchestratorData, ThrowOnError>,
) => {
  return (options.client ?? client).post<
    PlaybooksCreateOrchestratorResponses,
    PlaybooksCreateOrchestratorErrors,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/api/playbooks/orchestrators/",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });
};

/**
 * Preview orchestrator routing and resolved inputs
 */
export const playbooksPreviewOrchestrator = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PlaybooksPreviewOrchestratorData, ThrowOnError>,
) => {
  return (options.client ?? client).post<
    PlaybooksPreviewOrchestratorResponses,
    PlaybooksPreviewOrchestratorErrors,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/api/playbooks/orchestrators/preview",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });
};

/**
 * Delete orchestrator
 */
export const playbooksDeleteOrchestrator = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PlaybooksDeleteOrchestratorData, ThrowOnError>,
) => {
  return (options.client ?? client).delete<
    PlaybooksDeleteOrchestratorResponses,
    PlaybooksDeleteOrchestratorErrors,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/api/playbooks/orchestrators/{orchestrator_id}",
    ...options,
  });
};

/**
 * Get orchestrator details
 */
export const playbooksGetOrchestrator = <ThrowOnError extends boolean = false>(
  options: Options<PlaybooksGetOrchestratorData, ThrowOnError>,
) => {
  return (options.client ?? client).get<
    PlaybooksGetOrchestratorResponses,
    PlaybooksGetOrchestratorErrors,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/api/playbooks/orchestrators/{orchestrator_id}",
    ...options,
  });
};

/**
 * Update orchestrator
 */
export const playbooksUpdateOrchestrator = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PlaybooksUpdateOrchestratorData, ThrowOnError>,
) => {
  return (options.client ?? client).put<
    PlaybooksUpdateOrchestratorResponses,
    PlaybooksUpdateOrchestratorErrors,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/api/playbooks/orchestrators/{orchestrator_id}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });
};

/**
 * Activate orchestrator
 */
export const playbooksActivateOrchestrator = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PlaybooksActivateOrchestratorData, ThrowOnError>,
) => {
  return (options.client ?? client).post<
    PlaybooksActivateOrchestratorResponses,
    PlaybooksActivateOrchestratorErrors,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/api/playbooks/orchestrators/{orchestrator_id}/activate",
    ...options,
  });
};

/**
 * Pause orchestrator
 */
export const playbooksPauseOrchestrator = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PlaybooksPauseOrchestratorData, ThrowOnError>,
) => {
  return (options.client ?? client).post<
    PlaybooksPauseOrchestratorResponses,
    PlaybooksPauseOrchestratorErrors,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/api/playbooks/orchestrators/{orchestrator_id}/pause",
    ...options,
  });
};

/**
 * Run orchestrator manually
 */
export const playbooksRunOrchestrator = <ThrowOnError extends boolean = false>(
  options: Options<PlaybooksRunOrchestratorData, ThrowOnError>,
) => {
  return (options.client ?? client).post<
    PlaybooksRunOrchestratorResponses,
    PlaybooksRunOrchestratorErrors,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/api/playbooks/orchestrators/{orchestrator_id}/run",
    ...options,
  });
};

/**
 * List orchestrator runs
 */
export const playbooksListOrchestratorRuns = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PlaybooksListOrchestratorRunsData, ThrowOnError>,
) => {
  return (options.client ?? client).get<
    PlaybooksListOrchestratorRunsResponses,
    PlaybooksListOrchestratorRunsErrors,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/api/playbooks/orchestrators/{orchestrator_id}/runs",
    ...options,
  });
};

/**
 * Get orchestrator run details
 */
export const playbooksGetOrchestratorRun = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PlaybooksGetOrchestratorRunData, ThrowOnError>,
) => {
  return (options.client ?? client).get<
    PlaybooksGetOrchestratorRunResponses,
    PlaybooksGetOrchestratorRunErrors,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/api/playbooks/orchestrators/runs/{run_id}",
    ...options,
  });
};

/**
 * List orchestrator run items
 */
export const playbooksListOrchestratorRunItems = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PlaybooksListOrchestratorRunItemsData, ThrowOnError>,
) => {
  return (options.client ?? client).get<
    PlaybooksListOrchestratorRunItemsResponses,
    PlaybooksListOrchestratorRunItemsErrors,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/api/playbooks/orchestrators/runs/{run_id}/items",
    ...options,
  });
};

/**
 * Retry failed run items
 */
export const playbooksRetryFailedOrchestratorRun = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PlaybooksRetryFailedOrchestratorRunData, ThrowOnError>,
) => {
  return (options.client ?? client).post<
    PlaybooksRetryFailedOrchestratorRunResponses,
    PlaybooksRetryFailedOrchestratorRunErrors,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/api/playbooks/orchestrators/runs/{run_id}/retry-failed",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });
};

/**
 * Cancel an orchestrator run
 */
export const playbooksCancelOrchestratorRun = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PlaybooksCancelOrchestratorRunData, ThrowOnError>,
) => {
  return (options.client ?? client).post<
    PlaybooksCancelOrchestratorRunResponses,
    PlaybooksCancelOrchestratorRunErrors,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/api/playbooks/orchestrators/runs/{run_id}/cancel",
    ...options,
  });
};

/**
 * List managed input collections
 */
export const playbooksListManagedLists = <ThrowOnError extends boolean = false>(
  options: Options<PlaybooksListManagedListsData, ThrowOnError>,
) => {
  return (options.client ?? client).get<
    PlaybooksListManagedListsResponses,
    PlaybooksListManagedListsErrors,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/api/playbooks/input-collections/",
    ...options,
  });
};

/**
 * Create managed input collection
 */
export const playbooksCreateManagedList = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PlaybooksCreateManagedListData, ThrowOnError>,
) => {
  return (options.client ?? client).post<
    PlaybooksCreateManagedListResponses,
    PlaybooksCreateManagedListErrors,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/api/playbooks/input-collections/",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });
};

/**
 * Delete managed list
 */
export const playbooksDeleteManagedList = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PlaybooksDeleteManagedListData, ThrowOnError>,
) => {
  return (options.client ?? client).delete<
    PlaybooksDeleteManagedListResponses,
    PlaybooksDeleteManagedListErrors,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/api/playbooks/input-collections/{collection_id}",
    ...options,
  });
};

/**
 * Get managed list details
 */
export const playbooksGetManagedList = <ThrowOnError extends boolean = false>(
  options: Options<PlaybooksGetManagedListData, ThrowOnError>,
) => {
  return (options.client ?? client).get<
    PlaybooksGetManagedListResponses,
    PlaybooksGetManagedListErrors,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/api/playbooks/input-collections/{collection_id}",
    ...options,
  });
};

/**
 * Update managed list
 */
export const playbooksUpdateManagedList = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PlaybooksUpdateManagedListData, ThrowOnError>,
) => {
  return (options.client ?? client).put<
    PlaybooksUpdateManagedListResponses,
    PlaybooksUpdateManagedListErrors,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/api/playbooks/input-collections/{collection_id}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });
};

/**
 * List managed list items
 */
export const playbooksListManagedListItems = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PlaybooksListManagedListItemsData, ThrowOnError>,
) => {
  return (options.client ?? client).get<
    PlaybooksListManagedListItemsResponses,
    PlaybooksListManagedListItemsErrors,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/api/playbooks/input-collections/{collection_id}/items",
    ...options,
  });
};

/**
 * Insert managed list items
 */
export const playbooksCreateManagedListItems = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PlaybooksCreateManagedListItemsData, ThrowOnError>,
) => {
  return (options.client ?? client).post<
    PlaybooksCreateManagedListItemsResponses,
    PlaybooksCreateManagedListItemsErrors,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/api/playbooks/input-collections/{collection_id}/items",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });
};

/**
 * Delete managed list item
 */
export const playbooksDeleteManagedListItem = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PlaybooksDeleteManagedListItemData, ThrowOnError>,
) => {
  return (options.client ?? client).delete<
    PlaybooksDeleteManagedListItemResponses,
    PlaybooksDeleteManagedListItemErrors,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/api/playbooks/input-collections/{collection_id}/items/{item_id}",
    ...options,
  });
};

/**
 * Update managed list item
 */
export const playbooksUpdateManagedListItem = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PlaybooksUpdateManagedListItemData, ThrowOnError>,
) => {
  return (options.client ?? client).put<
    PlaybooksUpdateManagedListItemResponses,
    PlaybooksUpdateManagedListItemErrors,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/api/playbooks/input-collections/{collection_id}/items/{item_id}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });
};

/**
 * List generated PDF reports
 *
 * List all PDF reports generated by create_pdf nodes in this playbook.
 * Returns reports from successful executions, sorted by most recent first.
 */
export const playbooksListReports = <ThrowOnError extends boolean = false>(
  options: Options<PlaybooksListReportsData, ThrowOnError>,
) => {
  return (options.client ?? client).get<
    PlaybooksListReportsResponses,
    PlaybooksListReportsErrors,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/api/playbooks/{playbook_id}/reports",
    ...options,
  });
};

/**
 * Get available node types
 *
 * Get all available node types with their schemas.
 */
export const playbooksGetNodeTypes = <ThrowOnError extends boolean = false>(
  options: Options<PlaybooksGetNodeTypesData, ThrowOnError>,
) => {
  return (options.client ?? client).get<
    PlaybooksGetNodeTypesResponses,
    PlaybooksGetNodeTypesErrors,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/api/playbooks/nodes/types",
    ...options,
  });
};

/**
 * Discover upstream nodes and compute output schemas
 *
 * Compute upstream discovery and output schemas for a target node.
 *
 * This endpoint traverses the playbook graph backwards from the target node,
 * computes config-dependent output schemas for each upstream node, and
 * returns categorized results for use in config forms.
 *
 * The response includes:
 * - All upstream nodes with their schemas
 * - Categorized sources (data, view, LLM, etc.)
 * - Detected workflow pattern
 * - Available variables for interpolation
 *
 * This is used by:
 * 1. Frontend config forms to show smart suggestions
 * 2. AI agents to understand upstream data for automated assistance
 */
export const playbooksDiscoverNodeContext = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PlaybooksDiscoverNodeContextData, ThrowOnError>,
) => {
  return (options.client ?? client).post<
    PlaybooksDiscoverNodeContextResponses,
    PlaybooksDiscoverNodeContextErrors,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/api/playbooks/nodes/discover",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });
};

/**
 * List org integrations
 *
 * List integrations for an organization.
 */
export const playbooksListIntegrations = <ThrowOnError extends boolean = false>(
  options: Options<PlaybooksListIntegrationsData, ThrowOnError>,
) => {
  return (options.client ?? client).get<
    PlaybooksListIntegrationsResponses,
    PlaybooksListIntegrationsErrors,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/api/playbooks/integrations/",
    ...options,
  });
};

/**
 * Create org integration
 *
 * Create a new org integration.
 */
export const playbooksCreateIntegration = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PlaybooksCreateIntegrationData, ThrowOnError>,
) => {
  return (options.client ?? client).post<
    PlaybooksCreateIntegrationResponses,
    PlaybooksCreateIntegrationErrors,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/api/playbooks/integrations/",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });
};

/**
 * Delete org integration
 *
 * Soft delete an org integration.
 */
export const playbooksDeleteIntegration = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PlaybooksDeleteIntegrationData, ThrowOnError>,
) => {
  return (options.client ?? client).delete<
    PlaybooksDeleteIntegrationResponses,
    PlaybooksDeleteIntegrationErrors,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/api/playbooks/integrations/{integration_id}",
    ...options,
  });
};

/**
 * Update org integration
 *
 * Update an existing org integration.
 */
export const playbooksUpdateIntegration = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PlaybooksUpdateIntegrationData, ThrowOnError>,
) => {
  return (options.client ?? client).patch<
    PlaybooksUpdateIntegrationResponses,
    PlaybooksUpdateIntegrationErrors,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/api/playbooks/integrations/{integration_id}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });
};

/**
 * Set default org integration
 *
 * Set the default integration for an integration type.
 */
export const playbooksSetDefaultIntegration = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PlaybooksSetDefaultIntegrationData, ThrowOnError>,
) => {
  return (options.client ?? client).post<
    PlaybooksSetDefaultIntegrationResponses,
    PlaybooksSetDefaultIntegrationErrors,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/api/playbooks/integrations/{integration_id}/set-default",
    ...options,
  });
};

/**
 * Send integration test email
 *
 * Send a test email using an org email integration.
 */
export const playbooksTestIntegrationEmail = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PlaybooksTestIntegrationEmailData, ThrowOnError>,
) => {
  return (options.client ?? client).post<
    PlaybooksTestIntegrationEmailResponses,
    PlaybooksTestIntegrationEmailErrors,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/api/playbooks/integrations/{integration_id}/test-send",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });
};

/**
 * Get monitor overview dashboard data
 *
 * Get aggregated data for the monitor dashboard including:
 * - Currently running playbook executions
 * - Next 10 scheduled playbook executions
 * - KPIs (runs today, success rate, active playbooks, failures)
 * - Weekly output summary (reports, emails, Slack messages)
 * - Recent failed executions
 */
export const playbooksGetMonitorOverview = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PlaybooksGetMonitorOverviewData, ThrowOnError>,
) => {
  return (options.client ?? client).get<
    PlaybooksGetMonitorOverviewResponses,
    PlaybooksGetMonitorOverviewErrors,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/api/playbooks/monitor/overview",
    ...options,
  });
};

/**
 * Get scheduled executions for timeline
 *
 * Get all scheduled playbook executions within a date range.
 * Uses croniter to calculate future execution times from cron expressions.
 */
export const playbooksGetScheduleTimeline = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PlaybooksGetScheduleTimelineData, ThrowOnError>,
) => {
  return (options.client ?? client).get<
    PlaybooksGetScheduleTimelineResponses,
    PlaybooksGetScheduleTimelineErrors,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/api/playbooks/monitor/schedule",
    ...options,
  });
};

/**
 * List all report artifacts across playbooks
 *
 * List all report artifacts generated across all playbooks in the organization.
 *
 * PDF reports come from create_pdf nodes. CSV artifacts can also be created
 * by read_data nodes and delivered as email attachments, so they are surfaced
 * here as downloadable reports too.
 */
export const playbooksListAllReports = <ThrowOnError extends boolean = false>(
  options: Options<PlaybooksListAllReportsData, ThrowOnError>,
) => {
  return (options.client ?? client).get<
    PlaybooksListAllReportsResponses,
    PlaybooksListAllReportsErrors,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/api/playbooks/monitor/outputs/reports",
    ...options,
  });
};

/**
 * List all emails sent across playbooks
 *
 * List all emails sent across all playbooks in the organization.
 */
export const playbooksListAllEmails = <ThrowOnError extends boolean = false>(
  options: Options<PlaybooksListAllEmailsData, ThrowOnError>,
) => {
  return (options.client ?? client).get<
    PlaybooksListAllEmailsResponses,
    PlaybooksListAllEmailsErrors,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/api/playbooks/monitor/outputs/emails",
    ...options,
  });
};

/**
 * List all Slack messages sent across playbooks
 *
 * List all Slack messages sent across all playbooks in the organization.
 */
export const playbooksListAllSlackMessages = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PlaybooksListAllSlackMessagesData, ThrowOnError>,
) => {
  return (options.client ?? client).get<
    PlaybooksListAllSlackMessagesResponses,
    PlaybooksListAllSlackMessagesErrors,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/api/playbooks/monitor/outputs/slack",
    ...options,
  });
};

/**
 * Get Celery queue health status
 *
 * Return queue depths and worker status for monitoring.
 *
 * Returns:
 * - status: "healthy" if workers are active, "degraded" if no workers, "disabled" if Celery disabled
 * - active_workers: Number of active Celery workers (-1 if unknown)
 * - queue_depths: Number of tasks in each queue
 * - total_queued: Total tasks across all queues
 */
export const playbooksGetQueueHealth = <ThrowOnError extends boolean = false>(
  options: Options<PlaybooksGetQueueHealthData, ThrowOnError>,
) => {
  return (options.client ?? client).get<
    PlaybooksGetQueueHealthResponses,
    PlaybooksGetQueueHealthErrors,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/api/playbooks/health/queues",
    ...options,
  });
};

/**
 * Get user notifications
 *
 * Get notifications for the current user.
 */
export const notificationsGetNotifications = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<NotificationsGetNotificationsData, ThrowOnError>,
) => {
  return (options?.client ?? client).get<
    NotificationsGetNotificationsResponses,
    NotificationsGetNotificationsErrors,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/api/notifications",
    ...options,
  });
};

/**
 * Get unread notification count
 *
 * Get count of unread notifications for the current user.
 */
export const notificationsGetUnreadCount = <
  ThrowOnError extends boolean = false,
>(
  options?: Options<NotificationsGetUnreadCountData, ThrowOnError>,
) => {
  return (options?.client ?? client).get<
    NotificationsGetUnreadCountResponses,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/api/notifications/unread-count",
    ...options,
  });
};

/**
 * Mark notification as read
 *
 * Mark a notification as read.
 */
export const notificationsMarkAsRead = <ThrowOnError extends boolean = false>(
  options: Options<NotificationsMarkAsReadData, ThrowOnError>,
) => {
  return (options.client ?? client).patch<
    NotificationsMarkAsReadResponses,
    NotificationsMarkAsReadErrors,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/api/notifications/{notification_id}/read",
    ...options,
  });
};

/**
 * Mark all notifications as read
 *
 * Mark all notifications as read for the current user.
 */
export const notificationsMarkAllRead = <ThrowOnError extends boolean = false>(
  options?: Options<NotificationsMarkAllReadData, ThrowOnError>,
) => {
  return (options?.client ?? client).post<
    NotificationsMarkAllReadResponses,
    unknown,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/api/notifications/mark-all-read",
    ...options,
  });
};

/**
 * Create a new skill
 *
 * Create a new skill. Auth (creator_id + org membership) checked in dependency.
 */
export const skillsCreateSkill = <ThrowOnError extends boolean = false>(
  options: Options<SkillsCreateSkillData, ThrowOnError>,
) => {
  return (options.client ?? client).post<
    SkillsCreateSkillResponses,
    SkillsCreateSkillErrors,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/api/skills",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });
};

/**
 * Get all skills for an organization
 *
 * Get all skills for an organization.
 */
export const skillsGetOrganizationSkills = <
  ThrowOnError extends boolean = false,
>(
  options: Options<SkillsGetOrganizationSkillsData, ThrowOnError>,
) => {
  return (options.client ?? client).get<
    SkillsGetOrganizationSkillsResponses,
    SkillsGetOrganizationSkillsErrors,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/api/skills/org/{org_id}",
    ...options,
  });
};

/**
 * Delete a skill
 *
 * Delete a skill.
 */
export const skillsDeleteSkill = <ThrowOnError extends boolean = false>(
  options: Options<SkillsDeleteSkillData, ThrowOnError>,
) => {
  return (options.client ?? client).delete<
    SkillsDeleteSkillResponses,
    SkillsDeleteSkillErrors,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/api/skills/{skill_id}",
    ...options,
  });
};

/**
 * Get a specific skill by ID
 *
 * Get a specific skill by its ID.
 */
export const skillsGetSkill = <ThrowOnError extends boolean = false>(
  options: Options<SkillsGetSkillData, ThrowOnError>,
) => {
  return (options.client ?? client).get<
    SkillsGetSkillResponses,
    SkillsGetSkillErrors,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/api/skills/{skill_id}",
    ...options,
  });
};

/**
 * Update a skill
 *
 * Update an existing skill.
 */
export const skillsUpdateSkill = <ThrowOnError extends boolean = false>(
  options: Options<SkillsUpdateSkillData, ThrowOnError>,
) => {
  return (options.client ?? client).put<
    SkillsUpdateSkillResponses,
    SkillsUpdateSkillErrors,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/api/skills/{skill_id}",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });
};

/**
 * Handle Connect Webhook
 *
 * Receive Pipedream Connect success/error events.
 *
 * The URL is signed when the Connect token is created. This keeps local rows
 * in sync even if the browser callback misses the success event.
 */
export const pipedreamHandleConnectWebhook = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PipedreamHandleConnectWebhookData, ThrowOnError>,
) => {
  return (options.client ?? client).post<
    PipedreamHandleConnectWebhookResponses,
    PipedreamHandleConnectWebhookErrors,
    ThrowOnError
  >({
    url: "/api/pipedream/connect-webhook",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });
};

/**
 * Create Connect Token
 *
 * Create a short-lived token for the Pipedream Connect frontend OAuth flow.
 */
export const pipedreamCreateConnectToken = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PipedreamCreateConnectTokenData, ThrowOnError>,
) => {
  return (options.client ?? client).post<
    PipedreamCreateConnectTokenResponses,
    PipedreamCreateConnectTokenErrors,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/api/pipedream/connect-token",
    ...options,
  });
};

/**
 * List Supported Apps
 *
 * List supported apps enriched with current Pipedream app availability.
 */
export const pipedreamListSupportedApps = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PipedreamListSupportedAppsData, ThrowOnError>,
) => {
  return (options.client ?? client).get<
    PipedreamListSupportedAppsResponses,
    PipedreamListSupportedAppsErrors,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/api/pipedream/apps",
    ...options,
  });
};

/**
 * List Connections
 *
 * List user's personal + org-wide connections for this org.
 */
export const pipedreamListConnections = <ThrowOnError extends boolean = false>(
  options: Options<PipedreamListConnectionsData, ThrowOnError>,
) => {
  return (options.client ?? client).get<
    PipedreamListConnectionsResponses,
    PipedreamListConnectionsErrors,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/api/pipedream/connections",
    ...options,
  });
};

/**
 * Save Connection
 *
 * Save a newly connected Pipedream account after the frontend OAuth flow completes.
 */
export const pipedreamSaveConnection = <ThrowOnError extends boolean = false>(
  options: Options<PipedreamSaveConnectionData, ThrowOnError>,
) => {
  return (options.client ?? client).post<
    PipedreamSaveConnectionResponses,
    PipedreamSaveConnectionErrors,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/api/pipedream/connections",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });
};

/**
 * Get Resolved Connections
 *
 * Get effective connections for current user after resolution (personal > org-wide).
 */
export const pipedreamGetResolvedConnections = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PipedreamGetResolvedConnectionsData, ThrowOnError>,
) => {
  return (options.client ?? client).get<
    PipedreamGetResolvedConnectionsResponses,
    PipedreamGetResolvedConnectionsErrors,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/api/pipedream/connections/resolved",
    ...options,
  });
};

/**
 * Browse Connection Files
 *
 * Browse files/envelopes exposed by a Pipedream connection.
 */
export const pipedreamBrowseConnectionFiles = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PipedreamBrowseConnectionFilesData, ThrowOnError>,
) => {
  return (options.client ?? client).get<
    PipedreamBrowseConnectionFilesResponses,
    PipedreamBrowseConnectionFilesErrors,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/api/pipedream/connections/{connection_id}/browse",
    ...options,
  });
};

/**
 * Prepare Connection File Access
 *
 * Prepare a short-lived preview/download URL for a browsed file.
 */
export const pipedreamPrepareConnectionFileAccess = <
  ThrowOnError extends boolean = false,
>(
  options: Options<PipedreamPrepareConnectionFileAccessData, ThrowOnError>,
) => {
  return (options.client ?? client).post<
    PipedreamPrepareConnectionFileAccessResponses,
    PipedreamPrepareConnectionFileAccessErrors,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/api/pipedream/connections/{connection_id}/file-access",
    ...options,
    headers: {
      "Content-Type": "application/json",
      ...options.headers,
    },
  });
};

/**
 * Disconnect
 *
 * Disconnect a Pipedream account.
 */
export const pipedreamDisconnect = <ThrowOnError extends boolean = false>(
  options: Options<PipedreamDisconnectData, ThrowOnError>,
) => {
  return (options.client ?? client).delete<
    PipedreamDisconnectResponses,
    PipedreamDisconnectErrors,
    ThrowOnError
  >({
    security: [
      {
        scheme: "bearer",
        type: "http",
      },
    ],
    url: "/api/pipedream/connections/{connection_id}",
    ...options,
  });
};

/**
 * Get cache health and statistics
 *
 * Return cache health status and memory info.
 */
export const agentsGetCacheHealth = <ThrowOnError extends boolean = false>(
  options?: Options<AgentsGetCacheHealthData, ThrowOnError>,
) => {
  return (options?.client ?? client).get<
    AgentsGetCacheHealthResponses,
    unknown,
    ThrowOnError
  >({
    url: "/api/cache/health",
    ...options,
  });
};
